/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An opaque cursor for pagination */
  Cursor: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: Date | string; output: string; }
  /**
   * A string representing a specific point in time in the [ISO Format](https://en.wikipedia.org/wiki/ISO_8601) `"yyyy-MM-dd[T]HH:mm:ss[±]hh:mm"` containing the information in which timezone this date is happening.
   *
   *   For example `"2022-03-15T20:15:00+01:00"` would denote the _15th of March 2022, 20:15:00 local time in a timezone offset by 1 hour from UTC_. (e.g. Vienna)
   */
  DateOutput: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: Date | string; output: string; }
  /**
   * A time string representing a time without timezone, using the format `"HH:mm:ss"` or `"12:00:00"`
   *
   */
  LocalTimeInput: { input: any; output: any; }
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: { input: string; output: string; }
  /** A URL */
  URL: { input: string; output: string; }
};

export type About = {
  __typename: 'About';
  general: Scalars['String']['output'];
  team: Maybe<Scalars['String']['output']>;
};

export type ActivitiesPerSport = {
  __typename: 'ActivitiesPerSport';
  activityCount: Scalars['Int']['output'];
  sport: Sport;
};

export type Activity = {
  __typename: 'Activity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  venue: Venue;
};

export enum ActivityAvailability {
  ACTIVITY_AVAILABILITY_AFTERNOON = 'ACTIVITY_AVAILABILITY_AFTERNOON',
  ACTIVITY_AVAILABILITY_EVENING = 'ACTIVITY_AVAILABILITY_EVENING',
  ACTIVITY_AVAILABILITY_MORNING = 'ACTIVITY_AVAILABILITY_MORNING'
}

export enum ActivityLocationType {
  INDOOR = 'INDOOR',
  ONLINE = 'ONLINE',
  OUTDOOR = 'OUTDOOR'
}

export enum ActivitySpotLimitDisplayType {
  ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_FREE_SPOTS_COUNT = 'ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_FREE_SPOTS_COUNT',
  ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_PARTICIPANTS_COUNT = 'ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_PARTICIPANTS_COUNT'
}

export type AddMatch = BallsportMatch | ExpectedErrors;

export type AddOn = {
  __typename: 'AddOn';
  description: Scalars['String']['output'];
  fields: Array<AddOnField>;
  id: Scalars['ID']['output'];
  mandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AddOnField = NumberAddOnField | SelectAddOnField | TextAddOnField;

export type AddOnFieldInput = {
  __typename: 'AddOnFieldInput';
  id: Scalars['ID']['output'];
  multiSelectionValue: Maybe<Array<Scalars['ID']['output']>>;
  numberValue: Maybe<Scalars['Float']['output']>;
  singleSelectionValue: Maybe<Scalars['ID']['output']>;
  textValue: Maybe<Scalars['String']['output']>;
};

export type AddOnFieldInputInput = {
  id: Scalars['ID']['input'];
  multiSelectionValue?: InputMaybe<Array<Scalars['ID']['input']>>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  singleSelectionValue?: InputMaybe<Scalars['ID']['input']>;
  textValue?: InputMaybe<Scalars['String']['input']>;
};

export type AddOnInput = {
  __typename: 'AddOnInput';
  fields: Array<AddOnFieldInput>;
  id: Scalars['ID']['output'];
};

export type AddOnInputInput = {
  fields: Array<AddOnFieldInputInput>;
  id: Scalars['ID']['input'];
};

export type AddParticipantOnMatchV2 = ExpectedErrors | MatchParticipant;

export enum AddParticipantToMatchAnswer {
  NO = 'NO',
  YES = 'YES'
}

export type AddToWaitingListResponse = ExpectedErrors | WaitingList;

export type AdditionalProfileInput = {
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
};

export enum AppType {
  BRANDED = 'BRANDED',
  EVERSPORTS = 'EVERSPORTS'
}

/** A budget which is applied to a cart item */
export type AppliedBudget = {
  __typename: 'AppliedBudget';
  /** The name of the Corporate Budget */
  budgetName: Scalars['String']['output'];
  /** The name of the Corporate providing the Budget */
  corporateName: Scalars['String']['output'];
  /** The amount used for this booking */
  reduction: MonetaryValue;
};

/** A voucher which is applied to a cart by the user */
export type AppliedVoucher = {
  __typename: 'AppliedVoucher';
  /** The voucher-code the user applied to the cart */
  code: Scalars['String']['output'];
  originalValue: Maybe<MonetaryValue>;
  remainingValue: Maybe<MonetaryValue>;
};

export enum Area {
  INDOOR = 'Indoor',
  OUTDOOR = 'Outdoor'
}

/** Products that a user has assigned, and which they can use for a booking order to use for booking `BookableItem`s */
export type AssignedBookingProduct = AssignedCard | AssignedMembership;

export type AssignedCard = AssignedProductInterface & {
  __typename: 'AssignedCard';
  assignedProductValidity: AssignedProductValidity;
  id: Scalars['ID']['output'];
  product: Card;
  totalUsages: Maybe<Scalars['Float']['output']>;
  usagesLeft: Maybe<Scalars['Float']['output']>;
  validFrom: Maybe<Scalars['Date']['output']>;
  validUntil: Maybe<Scalars['Date']['output']>;
};

export type AssignedFloorPlan = {
  __typename: 'AssignedFloorPlan';
  id: Scalars['ID']['output'];
  nonBookableItems: Array<NonBookableItem>;
  spots: Array<Spot>;
};

export type AssignedMembership = AssignedProductInterface & {
  __typename: 'AssignedMembership';
  assignedProductValidity: AssignedProductValidity;
  id: Scalars['ID']['output'];
  isTerminable: Scalars['Boolean']['output'];
  membershipState: Maybe<MembershipState>;
  nextPaymentInfo: Maybe<NextPaymentInfo>;
  paymentAndCancellationTerms: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<StoredPaymentMethod>;
  paymentPlan: PaymentPlan;
  periods: Array<MembershipPeriod>;
  product: Membership;
  renewal: Maybe<Renewal>;
  validity: TimeRange;
};

export type AssignedMembershipResponse = AssignedMembership | ExpectedErrors;

/** Products that a user has purchased */
export type AssignedProduct = AssignedCard | AssignedMembership | AssignedRecording | AssignedVoucher | GenericAssignedProduct;

export type AssignedProductInterface = {
  assignedProductValidity: AssignedProductValidity;
  id: Scalars['ID']['output'];
};

export type AssignedProductOrderItem = OrderItemInterface & {
  __typename: 'AssignedProductOrderItem';
  assignedProduct: AssignedProduct;
  confirmedWith: Maybe<ConfirmWithOption>;
  endPrice: Scalars['Float']['output'];
  purchasedWith: Maybe<PurchasedWith>;
  quantity: Scalars['Float']['output'];
  reduction: Scalars['Float']['output'];
};

export type AssignedProductValidity = {
  __typename: 'AssignedProductValidity';
  additionalInformation: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  /** @deprecated Please use UsageLimitPeriodV2 instead, which returns `start` and `end` as datetime string in ISO 8601 format */
  usageLimitPeriod: Maybe<UsageLimitPeriod>;
  usageLimitPeriodV2: Maybe<UsageLimitPeriodV2>;
};

/** Products that are assigned to a user (by purchase or manually), only for user profile */
export type AssignedProductsForUserProfileType = AssignedCard | AssignedMembership;

export type AssignedRecording = {
  __typename: 'AssignedRecording';
  id: Scalars['ID']['output'];
  password: Maybe<Scalars['String']['output']>;
  product: Recording;
  url: Scalars['String']['output'];
  validUntil: Maybe<Scalars['DateTime']['output']>;
};

export type AssignedRecordingConnection = {
  __typename: 'AssignedRecordingConnection';
  edges: Array<AssignedRecordingEdge>;
  /** The actual "AssignedRecording" items */
  nodes: Array<AssignedRecording>;
  pageInfo: PageInfo;
};

export type AssignedRecordingEdge = {
  __typename: 'AssignedRecordingEdge';
  cursor: Scalars['Cursor']['output'];
  node: AssignedRecording;
};

export type AssignedSpotWithBooking = {
  __typename: 'AssignedSpotWithBooking';
  appointmentParticipationId: Scalars['ID']['output'];
  spot: Maybe<Spot>;
};

export type AssignedVoucher = AssignedProductInterface & {
  __typename: 'AssignedVoucher';
  assignedProductValidity: AssignedProductValidity;
  /** The code of the voucher */
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  product: Voucher;
  remainingValue: MonetaryValue;
  usedValue: MonetaryValue;
  value: MonetaryValue;
};

export type AuthParamsInput = {
  /** The personal token of a pending corporate employee. */
  corporateInvitationToken?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the corporate who invited this user as an employee. If added to the request the user will become a corporate employee. */
  corporatePartner?: InputMaybe<Scalars['ID']['input']>;
  origin: Origin;
  /**
   * This is an optional query string to append to the verification link inside E-Mails that are sent as part of the authentication flow.
   *     The resulting link looks something like this: https://www.eversports.at/auth/verify-email?token=${token}&${queryString}
   */
  queryString?: InputMaybe<Scalars['String']['input']>;
  /** Region describing where this call is made from. This is primarily used to generate valid localized content (eg urls for registration emails). Use a valid ISO code here like `AT` */
  region?: InputMaybe<Scalars['String']['input']>;
};

export type AuthResponse = AuthResult | ExpectedErrors;

export type AuthResult = {
  __typename: 'AuthResult';
  /** ONLY DEV: This is needed for e2e tests and convenient for local development */
  activationLink: Maybe<Scalars['String']['output']>;
  apiToken: Scalars['String']['output'];
  registrationSource: Maybe<RegistrationSource>;
  user: User;
};

/** Defines timeranges on certain weekdays, within certain periods of the year. E.g. During summer season, on Tuesdays and Thursdays from 9:00-17:00. This is mostly used for opening hours */
export type Availability = {
  __typename: 'Availability';
  /** Seasonality end, month and day formatted as YYYY-MM-DD */
  end: Scalars['String']['output'];
  periods: Array<AvailabilityPeriod>;
  /** Seasonality start, month and day formatted as YYYY-MM-DD */
  start: Scalars['String']['output'];
};

export type AvailabilityPeriod = {
  __typename: 'AvailabilityPeriod';
  /** Time end, hour and minute formatted as hh:mm */
  end: Scalars['String']['output'];
  /** Time start, hour and minute formatted as hh:mm */
  start: Scalars['String']['output'];
  weekdays: Array<Weekday>;
};

export type AvailableBenefits = {
  __typename: 'AvailableBenefits';
  /** the corporate partner providing for these benefits */
  corporatePartner: Maybe<CorporatePartner>;
  isBudgetAvailable: Scalars['Boolean']['output'];
  isSpecialPriceAvailable: Scalars['Boolean']['output'];
};

export type AvailableBudget = {
  __typename: 'AvailableBudget';
  /** the Budget settings regulating this user's available Budget */
  corporateBudget: CorporateBudget;
  corporatePartner: CorporatePartner;
  display: BudgetLimit;
  employeeBudgetDepleted: Scalars['Boolean']['output'];
  employeeLimit: BudgetLimit;
  totalBudgetDepleted: Scalars['Boolean']['output'];
};

export type BallsportMatch = MatchInterface & ParticipationInterface & {
  __typename: 'BallsportMatch';
  /** Friends of the logged in user who are participating */
  attendingFriends: Maybe<FriendConnection>;
  /** @deprecated Information about the booking will be resolved on the 'BallsportMatch' directly */
  booking: Maybe<CourtBooking>;
  cancellationCondition: Scalars['String']['output'];
  comments: MatchCommentConnection;
  competitionType: Maybe<MatchCompetitionType>;
  court: Maybe<Court>;
  end: Scalars['DateTime']['output'];
  gender: Maybe<MatchGender>;
  id: Scalars['ID']['output'];
  isPaid: Scalars['Boolean']['output'];
  level: Maybe<MatchLevel>;
  matchVisibilityValidations: Array<MatchVisibilityValidation>;
  maxParticipants: Maybe<Scalars['Int']['output']>;
  meta: MetaData;
  minParticipants: Maybe<Scalars['Int']['output']>;
  /** @deprecated Deprecated in favour of organizerV2 */
  organizer: User;
  organizerNote: Maybe<Scalars['String']['output']>;
  organizerV2: MatchOrganizerType;
  participants: Array<MatchParticipant>;
  participationState: Maybe<ParticipationState>;
  price: Maybe<MonetaryValue>;
  relativeLink: Scalars['String']['output'];
  sport: Sport;
  start: Scalars['DateTime']['output'];
  state: BallsportMatchState;
  venue: Venue;
  visibility: MatchVisibility;
};


export type BallsportMatchAttendingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BallsportMatchCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BallsportMatchConnection = {
  __typename: 'BallsportMatchConnection';
  edges: Array<BallsportMatchEdge>;
  /** The actual "BallsportMatch" items */
  nodes: Array<BallsportMatch>;
  pageInfo: PageInfo;
};

export type BallsportMatchEdge = {
  __typename: 'BallsportMatchEdge';
  cursor: Scalars['Cursor']['output'];
  node: BallsportMatch;
};

export enum BallsportMatchState {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  MOVED = 'MOVED',
  PLANNED = 'PLANNED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED'
}

export type BaseNotification = NotificationInterface & {
  __typename: 'BaseNotification';
  contentType: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  headerText: Maybe<Scalars['String']['output']>;
  icon: Maybe<NotificationIcon>;
  id: Scalars['ID']['output'];
  link: Maybe<NotificationLink>;
  seen: Scalars['Boolean']['output'];
  text: Maybe<Scalars['String']['output']>;
};

export type BookableItem = CourtBookableItem | EventBookableItem;

export type BookableItemCartItem = CartItemInterface & {
  __typename: 'BookableItemCartItem';
  addOns: Array<AddOn>;
  addOnsInput: Array<AddOnInput>;
  appliedBudget: Maybe<AppliedBudget>;
  appliedVoucher: Maybe<AppliedVoucher>;
  /** @deprecated Use `confirmWithOptions` instead, which is consistent for `BookableItemCartItem` and `ProductCartItem` */
  assignedProducts: Array<AssignedBookingProduct>;
  bookableItem: BookableItem;
  commentInput: Maybe<Scalars['String']['output']>;
  confirmWithOptions: Array<ConfirmWithOption>;
  id: Scalars['ID']['output'];
  /** Provides Information on whether the user can or must add other players to their booking. This is mostly used at Tennis Clubs, where members provide the information with what fellow member they are playing upon reservation of a court */
  multiPlayerSettings: Maybe<MultiPlayerSettings>;
  purchaseOptions: Array<PurchaseOption>;
  selectedProductId: Maybe<Scalars['String']['output']>;
  settleWith: Maybe<SettlementOption>;
  timeRange: Maybe<TimeRange>;
  trainer: Maybe<Trainer>;
};

export enum BookableSpotIconType {
  BOXES = 'BOXES',
  CIRCLE = 'CIRCLE',
  FITNESS_BENCHES = 'FITNESS_BENCHES',
  MATS = 'MATS',
  POLE = 'POLE',
  PUNCHING_BAGS = 'PUNCHING_BAGS',
  REFORMERS = 'REFORMERS',
  ROWING_MACHINES = 'ROWING_MACHINES',
  SKI_ERGOMETERS = 'SKI_ERGOMETERS',
  SPINNING_BICYCLES = 'SPINNING_BICYCLES',
  STEPPERS = 'STEPPERS',
  TREADMILLS = 'TREADMILLS',
  WEIGHTS = 'WEIGHTS'
}

export type Booking = CourtBooking | EventBooking;

export type BookingInterface = {
  confirmedWith: Maybe<ConfirmWithOption>;
  id: Scalars['ID']['output'];
  purchasedWith: Maybe<PurchasedWith>;
  timeRange: TimeRange;
};

export type BookingOrderItem = OrderItemInterface & {
  __typename: 'BookingOrderItem';
  booking: Booking;
  confirmedWith: Maybe<ConfirmWithOption>;
  endPrice: Scalars['Float']['output'];
  purchasedWith: Maybe<PurchasedWith>;
  reduction: Scalars['Float']['output'];
};

export type BookingRequestOrderItem = OrderItemInterface & {
  __typename: 'BookingRequestOrderItem';
  bookableItem: EventBookableItem;
  confirmedWith: Maybe<ConfirmWithOption>;
  endPrice: Scalars['Float']['output'];
  purchasedWith: Maybe<PurchasedWith>;
  reduction: Scalars['Float']['output'];
  timeRange: Maybe<TimeRange>;
  trainer: Maybe<Trainer>;
};

export type BoundingBox = {
  __typename: 'BoundingBox';
  /** Right upper coordinates of the bounding box */
  northEast: Coordinate;
  /** Left lower coordinates of the bounding box */
  southWest: Coordinate;
};

export type BoundingBoxArgs = {
  /** Right upper coordinates of the bounding box */
  northEast: CoordinateArgs;
  /** Left lower coordinates of the bounding box */
  southWest: CoordinateArgs;
};

export type BrandedPushNotificationEndpoint = {
  __typename: 'BrandedPushNotificationEndpoint';
  appType: AppType;
  /** The branded app associated with this endpoint. */
  companyBrandedApp: CompanyBrandedApp;
};

export enum BudgetInterval {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type BudgetLimit = Limited | Unlimited;

export enum BudgetType {
  ONCE = 'ONCE',
  RENEWING = 'RENEWING'
}

export type CancelMatch = BallsportMatch | ExpectedErrors;

export type CancellationInfo = {
  __typename: 'CancellationInfo';
  autoCancellationCondition: Maybe<Scalars['String']['output']>;
  isAllowed: Scalars['Boolean']['output'];
  isLateCancellationAllowed: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type Card = ProductInterface & {
  __typename: 'Card';
  /** List of activities for which this Card can be used. */
  activities: Array<Activity>;
  /** This is a special offer reserved for new customers */
  allowedOnlyForNewCustomers: Scalars['Boolean']['output'];
  /** List of time periods within which this Card can be used. */
  availabilities: Array<Availability>;
  /** This product can be bought only once per customer */
  canBePurchasedOnlyOncePerCustomer: Scalars['Boolean']['output'];
  cardType: CardType;
  category: Maybe<CardCategory>;
  /** List of courts on which this Card can be used. */
  courts: Array<Court>;
  description: Maybe<Scalars['String']['output']>;
  displayInformation: CardDisplayInformation;
  /** A list of special prices the currently logged in user is actually eligible for. Check `specialPrices` if you want to know the generally available special prices independently from user context. */
  eligibleSpecialPrices: Array<SpecialPrice>;
  id: Scalars['ID']['output'];
  /** This is an exclusive reduced price for corporate employees */
  isCorporatePrice: Scalars['Boolean']['output'];
  /** This is a trial offer for people new to the studio */
  isTrialCard: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** A previous "was" price of the product, has no relevance for actual purchase, but is only meant to be displayed as strike-through */
  originalPrice: Maybe<MonetaryValue>;
  price: MonetaryValue;
  productPurchaseInformation: ProductPurchaseInformation;
  /** A list of *all* special prices theoretically available for that product. Check `eligibleSpecialPrices` if your only interested in the prices the currently logged in user is actually eligible for. */
  specialPrices: Array<SpecialPrice>;
  /** List of sports for which this Card can be used. */
  sports: Array<Sport>;
  usages: Array<UsageLimit>;
  /** @deprecated Deprecated because of renamed type, pls use validityV2 instead */
  validity: Maybe<Validity>;
  validityV2: Maybe<TimePeriod>;
  /** List of venues at which the Card can be used. */
  venues: Array<Venue>;
};

/** An arbitrary categorization by the venue to group their products, which is only used for display and has no logical implications. */
export type CardCategory = {
  __typename: 'CardCategory';
  name: Scalars['String']['output'];
  priority: Scalars['Float']['output'];
};

export type CardConnection = {
  __typename: 'CardConnection';
  edges: Array<CardEdge>;
  /** The actual "Card" items */
  nodes: Array<Card>;
  pageInfo: PageInfo;
};

/** This is only displayinformation irrelevant for booking rules */
export type CardDisplayInformation = {
  __typename: 'CardDisplayInformation';
  area: Maybe<Area>;
  displayLimit: DisplayLimit;
  surface: Maybe<Surface>;
  targetAudience: Maybe<Scalars['String']['output']>;
};

export type CardEdge = {
  __typename: 'CardEdge';
  cursor: Scalars['Cursor']['output'];
  node: Card;
};

export enum CardType {
  CARD_TYPE_COURT_ABO = 'CARD_TYPE_COURT_ABO',
  CARD_TYPE_COURT_BLOCK = 'CARD_TYPE_COURT_BLOCK',
  CARD_TYPE_COURT_CREDIT = 'CARD_TYPE_COURT_CREDIT',
  CARD_TYPE_COURT_SEASON = 'CARD_TYPE_COURT_SEASON',
  CARD_TYPE_EVENT_BLOCK = 'CARD_TYPE_EVENT_BLOCK',
  CARD_TYPE_EVENT_TIME = 'CARD_TYPE_EVENT_TIME'
}

export type Cart = {
  __typename: 'Cart';
  /** The Budget a user could potentially use for this cart */
  availableBudget: Maybe<AvailableBudget>;
  /** The benefits available on the current state of the cart */
  availableCorporateBenefits: AvailableBenefits;
  canConfirmOrder: Scalars['Boolean']['output'];
  /** Returns the customer associated with the cart */
  customer: Maybe<Customer>;
  id: Scalars['ID']['output'];
  isPayAtVenueAllowed: Scalars['Boolean']['output'];
  /** `True` if vouchers are enabled for this cart, otherwise `false` */
  isVoucherEnabled: Scalars['Boolean']['output'];
  items: Array<CartItem>;
  /** An optional `Mandate` that is available for this cart */
  mandate: Maybe<Mandate>;
  /** Returns whether a medical certificate is required for this cart based on venue and sport context */
  medicalCertificateRequired: Scalars['Boolean']['output'];
  multiAnswerPatronQuestionInput: Maybe<PatronageAnswer>;
  patronQuestionInput: Maybe<Scalars['Boolean']['output']>;
  /** Determines which type of patron question should be shown to the user */
  patronQuestionType: PatronQuestionType;
  /** Returns an array of currently possible payment methods for the given cart. This value might change over time based on the carts configuration. If there's no payment necessary this will be null */
  paymentMethods: Maybe<Array<PaymentMethod>>;
  /** Delivers all the venue-policies the user has to accept for this cart */
  policies: Array<Policy>;
  /** Policies the user accepted for this cart */
  policiesInput: Array<Scalars['ID']['output']>;
  priceTable: Maybe<PriceTable>;
  quickCheckoutAvailable: Scalars['Boolean']['output'];
  /** Determines whether the patron question (PATRON_QUESTION_TYPE_CHANNEL) should be randomized or not */
  randomizePatronQuestion: Scalars['Boolean']['output'];
  requiredInformation: Array<RequiredInformationType>;
  requiredInformationInput: RequiredInformation;
  /**
   * Determines whether a question should be shown asking the user whether or not they have been at this venue before
   * @deprecated Use `patronQuestionType` instead, as we now support more than one type of patron question
   */
  showPatronQuestion: Scalars['Boolean']['output'];
  /** Available `StoredPaymentMethod`  available for this cart */
  storedPaymentMethods: Array<StoredPaymentMethod>;
  valid: Scalars['Boolean']['output'];
  venue: Venue;
};

export type CartItem = BookableItemCartItem | ProductCartItem;

export type CartItemInterface = {
  appliedBudget: Maybe<AppliedBudget>;
  appliedVoucher: Maybe<AppliedVoucher>;
  confirmWithOptions: Array<ConfirmWithOption>;
  id: Scalars['ID']['output'];
  purchaseOptions: Array<PurchaseOption>;
  settleWith: Maybe<SettlementOption>;
};

export type CartResponse = Cart | ExpectedErrors;

export type CheapestProduct = Card | Membership;

export type CheckInResponse = ExpectedErrors | SelfCheckIn;

export type City = {
  __typename: 'City';
  /** The URL under which pages showing this city should be hosted. Can be used to refer to the proper canonical URL on the client for pages like the venue profile or city discover pages. */
  canonicalHost: Scalars['String']['output'];
  districts: Array<District>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  popularSports: Array<Sport>;
  slug: Scalars['String']['output'];
};

export type CitySearchResult = SearchResult & {
  __typename: 'CitySearchResult';
  coordinate: Coordinate;
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  matchedName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secondaryMatch: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type ClientMetadataInput = {
  /** Whether the client is a branded app */
  isBrandedApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** The platform of the client making the request */
  platform?: InputMaybe<ClientMetadataPlatform>;
};

/** The platform of the client making the request */
export enum ClientMetadataPlatform {
  ANDROID = 'ANDROID',
  IOS = 'IOS'
}

export type Company = {
  __typename: 'Company';
  brandedApp: Maybe<CompanyBrandedApp>;
  country: Maybe<Country>;
  id: Scalars['ID']['output'];
  latestPolicies: Array<Policy>;
  name: Scalars['String']['output'];
  venues: Array<Venue>;
  widgetBrandSettings: CompanyWidgetBrandSettings;
};


export type CompanyVenuesArgs = {
  isHiddenInApp?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenOnMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyBrandedApp = CompanyBrandedAppInterface & {
  __typename: 'CompanyBrandedApp';
  id: Scalars['ID']['output'];
  invoicingVenue: Venue;
  settings: CompanyBrandedAppSettings;
  widgets: Array<CompanyWidget>;
};

export type CompanyBrandedAppInterface = {
  id: Scalars['ID']['output'];
  invoicingVenue: Venue;
  widgets: Array<CompanyWidget>;
};

export type CompanyBrandedAppSettings = {
  __typename: 'CompanyBrandedAppSettings';
  backgroundColor: Scalars['String']['output'];
  cardBackgroundColor: Scalars['String']['output'];
  cardTextColor: Scalars['String']['output'];
  fontFamily: Maybe<Scalars['String']['output']>;
  primaryColor: Scalars['String']['output'];
  secondaryColor: Maybe<Scalars['String']['output']>;
  textColor: Scalars['String']['output'];
};

export type CompanyWidget = {
  __typename: 'CompanyWidget';
  id: Scalars['ID']['output'];
  type: CompanyWidgetType;
};

export type CompanyWidgetBrandSettings = {
  __typename: 'CompanyWidgetBrandSettings';
  backgroundColor: Scalars['String']['output'];
  cardBackgroundColor: Scalars['String']['output'];
  cardTextColor: Scalars['String']['output'];
  displayName: Maybe<Scalars['String']['output']>;
  floorPlanBackgroundColor: Maybe<Scalars['String']['output']>;
  fontFamily: Maybe<Scalars['String']['output']>;
  logo: Maybe<Image>;
  primaryColor: Scalars['String']['output'];
  spotBookableBackgroundColor: Maybe<Scalars['String']['output']>;
  spotBookableTextColor: Maybe<Scalars['String']['output']>;
  spotNonBookableBackgroundColor: Maybe<Scalars['String']['output']>;
  spotNonBookableTextColor: Maybe<Scalars['String']['output']>;
  textColor: Scalars['String']['output'];
};

/** Company widgets can be either activities, activity schedule or prices */
export enum CompanyWidgetType {
  ACTIVITIES = 'ACTIVITIES',
  ACTIVITY_SCHEDULE = 'ACTIVITY_SCHEDULE',
  PRICES = 'PRICES',
  VIDEOS = 'VIDEOS',
  VOUCHERS = 'VOUCHERS'
}

export enum ComparisonOperator {
  EQUAL = 'EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  SMALLER_THAN = 'SMALLER_THAN',
  SMALLER_THAN_OR_EQUAL = 'SMALLER_THAN_OR_EQUAL'
}

export type ConfirmNewsletterSubscriptionResponse = ConfirmNewsletterSubscriptionResult | ExpectedErrors;

export type ConfirmNewsletterSubscriptionResult = {
  __typename: 'ConfirmNewsletterSubscriptionResult';
  success: Scalars['Boolean']['output'];
};

/** Products that a user has assigned, and which they can use to confirm a `CartItem` without payment */
export type ConfirmWithOption = AssignedCard | AssignedMembership;

export type Contact = {
  __typename: 'Contact';
  email: Maybe<Scalars['String']['output']>;
  facebook: Maybe<Scalars['String']['output']>;
  instagram: Maybe<Scalars['String']['output']>;
  telephone: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
  youtube: Maybe<Scalars['String']['output']>;
};

export type Coordinate = {
  __typename: 'Coordinate';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CoordinateArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CorporateBenefits = {
  __typename: 'CorporateBenefits';
  availableBudget: Maybe<AvailableBudget>;
  corporatePartner: CorporatePartner;
  hasSpecialPriceAccess: Scalars['Boolean']['output'];
};

export type CorporateBudget = {
  __typename: 'CorporateBudget';
  employeeLimit: BudgetLimit;
  expiry: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Please use the nullable intervalV2 instead! This non-nullable interval does not account for new absolute one-time budget. (It returns YEAR instead) */
  interval: BudgetInterval;
  intervalV2: Maybe<BudgetInterval>;
  totalLimit: BudgetLimit;
  type: BudgetType;
};

export type CorporateInvitationData = {
  __typename: 'CorporateInvitationData';
  corporateBudget: Maybe<CorporateBudget>;
  corporatePartner: CorporatePartner;
  hasSpecialPriceAccess: Scalars['Boolean']['output'];
};

export type CorporatePartner = {
  __typename: 'CorporatePartner';
  additionalDescription: Maybe<Scalars['String']['output']>;
  defaultBudget: Maybe<CorporateBudget>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logo: Maybe<Image>;
  name: Scalars['String']['output'];
  /** @deprecated Corporate Vouchercodes are being replaced by the new Budget. */
  voucherCode: Maybe<Scalars['String']['output']>;
};

export type Country = {
  __typename: 'Country';
  iso: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Court = {
  __typename: 'Court';
  area: Maybe<CourtAreaType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  surface: Maybe<CourtSurfaceType>;
};

export enum CourtAreaType {
  INDOOR = 'INDOOR',
  OUTDOOR = 'OUTDOOR'
}

export type CourtAvailability = {
  date: Scalars['Date']['input'];
  time?: InputMaybe<Scalars['LocalTimeInput']['input']>;
};

export type CourtBookableItem = {
  __typename: 'CourtBookableItem';
  activityImage: Maybe<Image>;
  cancellationCondition: Scalars['String']['output'];
  court: Court;
  id: Scalars['ID']['output'];
  sport: Sport;
  timeRange: TimeRange;
  venue: Venue;
};

export type CourtBooking = BookingInterface & ParticipationInterface & {
  __typename: 'CourtBooking';
  /** Friends of the logged in user who are participating */
  attendingFriends: Maybe<FriendConnection>;
  bookableItem: CourtBookableItem;
  confirmedWith: Maybe<ConfirmWithOption>;
  court: Court;
  customer: Customer;
  customerAccessPin: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Returns true if
   *       a) payment state of the first fully paid invoice is succeeded
   *       OR
   *       b) first issued invoice amount == 0 with no payment (company budget, discount)
   *
   */
  isPaid: Scalars['Boolean']['output'];
  match: Maybe<Match>;
  participationState: Maybe<ParticipationState>;
  payment: Maybe<Payment>;
  purchasedWith: Maybe<PurchasedWith>;
  state: CourtBookingState;
  timeRange: TimeRange;
};


export type CourtBookingAttendingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum CourtBookingState {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  MOVED = 'MOVED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED'
}

export enum CourtSurfaceType {
  ARTIFICIAL_GRASS = 'ARTIFICIAL_GRASS',
  ARTIFICIAL_ICE = 'ARTIFICIAL_ICE',
  ASH = 'ASH',
  ASPHALT = 'ASPHALT',
  CARPET = 'CARPET',
  CARPET_GRANULE = 'CARPET_GRANULE',
  CONCRETE = 'CONCRETE',
  FELT = 'FELT',
  GRANULE = 'GRANULE',
  GRASS = 'GRASS',
  HARD_COURT = 'HARD_COURT',
  ICE = 'ICE',
  OPTICOURT = 'OPTICOURT',
  PARQUET = 'PARQUET',
  PVC = 'PVC',
  RED_COURT = 'RED_COURT',
  SAND = 'SAND',
  SYNTHETIC = 'SYNTHETIC',
  TARTAN = 'TARTAN',
  WATER = 'WATER'
}

export type CreatedBallsportMatch = BallsportMatch | ExpectedErrors;

export type CredentialLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Customer = {
  __typename: 'Customer';
  accessPin: Maybe<Scalars['String']['output']>;
  customerGroup: CustomerGroup;
  id: Scalars['ID']['output'];
  isSubscribedToNewsletter: Scalars['Boolean']['output'];
  location: Maybe<Location>;
  mandate: Maybe<Mandate>;
  medicalCertificate: Maybe<CustomerMedicalCertificate>;
};

export type CustomerConnection = {
  __typename: 'CustomerConnection';
  edges: Array<CustomerEdge>;
  /** The actual "Customer" items */
  nodes: Array<Customer>;
  pageInfo: PageInfo;
};

export type CustomerEdge = {
  __typename: 'CustomerEdge';
  cursor: Scalars['Cursor']['output'];
  node: Customer;
};

export type CustomerGroup = {
  __typename: 'CustomerGroup';
  company: Company;
  id: Scalars['ID']['output'];
};

export type CustomerMedicalCertificate = {
  __typename: 'CustomerMedicalCertificate';
  status: CustomerMedicalCertificateStatus;
  validityDate: Maybe<Scalars['DateTime']['output']>;
};

export enum CustomerMedicalCertificateStatus {
  EXPIRED = 'EXPIRED',
  EXPIRING = 'EXPIRING',
  MISSING = 'MISSING',
  VALID = 'VALID'
}

export type CustomerResponseType = Customer | ExpectedErrors;

export type CustomerSession = {
  __typename: 'CustomerSession';
  /** Customer session client secret for temporary access to customer */
  clientSecret: Scalars['String']['output'];
  /** Stripe customer ID for the authenticated user */
  customerId: Scalars['String']['output'];
};

export type DeleteMatch = BallsportMatch | ExpectedErrors;

/** This data is used on our discover pages to improve the seo ranking */
export type DiscoverContent = {
  __typename: 'DiscoverContent';
  bookableSports: Array<Sport>;
  /** additional information about the page */
  description: Maybe<Scalars['String']['output']>;
  /** heading of the page eg. h1 */
  heading: Scalars['String']['output'];
  sections: Array<Section>;
  similarSports: Array<Sport>;
};

export type DiscoverContext = {
  boundingBox: BoundingBox;
  center: Coordinate;
  city: Maybe<City>;
  content: Maybe<DiscoverContent>;
  meta: Maybe<MetaData>;
  sport: Maybe<Sport>;
};

export type DiscoverContextForCity = DiscoverContext & DiscoverVenueContext & {
  __typename: 'DiscoverContextForCity';
  /** The sports bookable in and around this city */
  bookableSports: Array<Sport>;
  boundingBox: BoundingBox;
  center: Coordinate;
  city: City;
  content: Maybe<DiscoverContent>;
  meta: Maybe<MetaData>;
  onlineVenues: VenueConnection;
  sport: Maybe<Sport>;
};

export type DiscoverContextForCityAndSport = DiscoverContext & DiscoverVenueContext & {
  __typename: 'DiscoverContextForCityAndSport';
  boundingBox: BoundingBox;
  center: Coordinate;
  city: Maybe<City>;
  content: Maybe<DiscoverContent>;
  /** This field returns the events for the sport discover page. */
  eventBookableItems: EventBookableItemConnection;
  /** This field returns the events for the sport discover page. Be aware that this is slower than `eventBookableItems`. */
  eventSessions: EventSessionConnection;
  /** This field returns, on the basis of the sport category, available filters for the sport discover page. */
  filters: DiscoverFilter;
  meta: Maybe<MetaData>;
  offerings: Array<DiscoverOfferingType>;
  onlineVenues: VenueConnection;
  sport: Sport;
  /** @deprecated This resolveProperty just fixes the current initial load issues on the react application. It should be removed and only exist in the venue resolver. */
  venueSearch: VenueConnection;
};


export type DiscoverContextForCityAndSportEventBookableItemsArgs = {
  activityLocationType?: InputMaybe<Array<ActivityLocationType>>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  difficultyLevel?: InputMaybe<Array<EventDifficultyLevel>>;
  eventTypes?: InputMaybe<Array<EventType>>;
  eventVisibility?: InputMaybe<Array<EventVisibility>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timeRange?: InputMaybe<OpenEndTimeRangeInput>;
};


export type DiscoverContextForCityAndSportEventSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  eventFilters: EventFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueFilters: DiscoverContextVenueFilters;
};


export type DiscoverContextForCityAndSportVenueSearchArgs = {
  filters: DiscoverContextVenueFilters;
  sort?: InputMaybe<VenueSearchSort>;
  userLocation?: InputMaybe<CoordinateArgs>;
};

export type DiscoverContextVenueFilters = {
  activityAvailabilities?: InputMaybe<Array<ActivityAvailability>>;
  courtAreas?: InputMaybe<Array<CourtAreaType>>;
  courtAvailability?: InputMaybe<CourtAvailability>;
  courtSurfaces?: InputMaybe<Array<CourtSurfaceType>>;
  districts?: InputMaybe<Array<Scalars['ID']['input']>>;
  reviewCount?: InputMaybe<IntegerValueQuery>;
  /** Introduce minor randomness into the order of venues to make the page appear more recent and ever-changing to search engines. */
  seoShuffle?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueAmenities?: InputMaybe<Array<VenueAmenityType>>;
  venueAttributes?: InputMaybe<Array<VenueAttributes>>;
  venueOfferingTypes?: InputMaybe<Array<VenueOfferingType>>;
};

export type DiscoverCoordinateContext = {
  __typename: 'DiscoverCoordinateContext';
  boundingBox: BoundingBox;
  center: Coordinate;
  offerings: Array<DiscoverOfferingType>;
};

export type DiscoverFilter = {
  __typename: 'DiscoverFilter';
  surfaces: Maybe<Array<CourtSurfaceType>>;
};

export type DiscoverMatchContext = DiscoverContext & {
  __typename: 'DiscoverMatchContext';
  boundingBox: BoundingBox;
  center: Coordinate;
  city: Maybe<City>;
  content: Maybe<DiscoverContent>;
  filters: DiscoverMatchFilter;
  /** Find public matches. Currently only future matches, sorted by start asc */
  matches: BallsportMatchConnection;
  meta: Maybe<MetaData>;
  /** Offerings are only available for a certain sport. If no sport is passed, it resolves as empty array */
  offerings: Array<DiscoverOfferingType>;
  sport: Maybe<Sport>;
};


export type DiscoverMatchContextMatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filters: MatchFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DiscoverMatchFilter = {
  __typename: 'DiscoverMatchFilter';
  sports: Maybe<Array<Sport>>;
  venues: Maybe<Array<Venue>>;
};

export enum DiscoverOfferingType {
  DISCOVER_OFFERING_CAMP_ACTIVITY = 'DISCOVER_OFFERING_CAMP_ACTIVITY',
  DISCOVER_OFFERING_CLASS_ACTIVITY = 'DISCOVER_OFFERING_CLASS_ACTIVITY',
  DISCOVER_OFFERING_COURSE_ACTIVITY = 'DISCOVER_OFFERING_COURSE_ACTIVITY',
  DISCOVER_OFFERING_EDUCATION_ACTIVITY = 'DISCOVER_OFFERING_EDUCATION_ACTIVITY',
  DISCOVER_OFFERING_EVENT_ACTIVITY = 'DISCOVER_OFFERING_EVENT_ACTIVITY',
  DISCOVER_OFFERING_LIVESTREAM = 'DISCOVER_OFFERING_LIVESTREAM',
  DISCOVER_OFFERING_OPENTRAINING_ACTIVITY = 'DISCOVER_OFFERING_OPENTRAINING_ACTIVITY',
  DISCOVER_OFFERING_PRIVATE_ACTIVITY = 'DISCOVER_OFFERING_PRIVATE_ACTIVITY',
  DISCOVER_OFFERING_PUBLIC_MATCH = 'DISCOVER_OFFERING_PUBLIC_MATCH',
  DISCOVER_OFFERING_RETREAT_ACTIVITY = 'DISCOVER_OFFERING_RETREAT_ACTIVITY',
  DISCOVER_OFFERING_TRAINING_ACTIVITY = 'DISCOVER_OFFERING_TRAINING_ACTIVITY',
  DISCOVER_OFFERING_VIDEO = 'DISCOVER_OFFERING_VIDEO',
  DISCOVER_OFFERING_WORKSHOP_ACTIVITY = 'DISCOVER_OFFERING_WORKSHOP_ACTIVITY'
}

export type DiscoverVenueContext = {
  boundingBox: BoundingBox;
  center: Coordinate;
  city: Maybe<City>;
  content: Maybe<DiscoverContent>;
  meta: Maybe<MetaData>;
  onlineVenues: VenueConnection;
  sport: Maybe<Sport>;
};

/** This has nothing to do with actual booking stuff and is mostly legacy leftovers */
export type DisplayLimit = {
  __typename: 'DisplayLimit';
  limit: Maybe<Scalars['Int']['output']>;
  period: Maybe<DisplayLimitPeriod>;
  unit: Maybe<Scalars['String']['output']>;
};

export enum DisplayLimitPeriod {
  DISPLAY_LIMIT_PERIOD_DAY = 'DISPLAY_LIMIT_PERIOD_DAY',
  DISPLAY_LIMIT_PERIOD_MONTH = 'DISPLAY_LIMIT_PERIOD_MONTH',
  DISPLAY_LIMIT_PERIOD_SEASON = 'DISPLAY_LIMIT_PERIOD_SEASON',
  DISPLAY_LIMIT_PERIOD_WEEK = 'DISPLAY_LIMIT_PERIOD_WEEK',
  DISPLAY_LIMIT_PERIOD_YEAR = 'DISPLAY_LIMIT_PERIOD_YEAR'
}

export type District = {
  __typename: 'District';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EphemeralKey = {
  __typename: 'EphemeralKey';
  /** Stripe customer ID for the authenticated user */
  customerId: Scalars['String']['output'];
  /** Ephemeral key secret for temporary access to customer payment methods */
  ephemeralKeySecret: Scalars['String']['output'];
};

/** A bookable representation of an event. For single-session events, this corresponds to an `Appointment`. For multi-session events, this corresponds to an `Activity` that contains multiple sessions. */
export type EventBookableItem = {
  __typename: 'EventBookableItem';
  activityImage: Maybe<Image>;
  activityName: Scalars['String']['output'];
  /**
   * Returns the user's assigned spot for this item if it is booked, along with the booking ID.
   * @deprecated Deprecated in favor of `currentBooking`.
   */
  assignedSpot: Maybe<AssignedSpotWithBooking>;
  autoCancelCondition: Maybe<Scalars['String']['output']>;
  availableSpots: Maybe<SpotLimit>;
  cancellationCondition: Scalars['String']['output'];
  /** The point in time until which this event can be cancelled. Nullable for ticket events, where the cancellation deadline will be relative to the actual ticket/sessions you buy. */
  cancellationDeadline: Maybe<Scalars['DateTime']['output']>;
  /** A free text by the venue describing their policy. Note that what actually counts is the cancellationDeadline */
  cancellationDescription: Maybe<FormattedText>;
  /** Returns the current booking of the user for this item, if any. */
  currentBooking: Maybe<EventBooking>;
  /** A free text description of the event */
  description: Maybe<FormattedText>;
  /** Duration of the event in minutes */
  duration: Maybe<Scalars['Float']['output']>;
  eventSessions: Array<EventSession>;
  /** Determines the type of this event */
  eventType: EventType;
  floorPlan: Maybe<AssignedFloorPlan>;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  isUserOnWaitingList: Scalars['Boolean']['output'];
  /** The level */
  level: Maybe<EventDifficultyLevel>;
  location: Location;
  locations: Array<Location>;
  /** Returns the maximum number of participants assigned to this activity */
  maxParticipants: Maybe<Scalars['Float']['output']>;
  participatingFriends: FriendConnection;
  purchaseOptions: Array<PurchaseOption>;
  /** whether or not this item is bookable. May change depending on the logged in state of the user. E.g. certain thing like ALREADY_BOOKED can only be validated for a particular user. */
  registrationState: EventRegistrationState;
  /** Determines how people register for this event */
  registrationType: EventRegistrationType;
  /** The window within which this event is bookable */
  registrationWindow: OpenTimeRange;
  /** The current state relative to registration window */
  registrationWindowState: EventRegistrationWindowState;
  sessionComment: Maybe<SessionComment>;
  shareUrl: Scalars['String']['output'];
  shortId: Scalars['String']['output'];
  sport: Sport;
  /**
   * Delivers the trainer for the eventsessions
   * @deprecated Use trainers field instead as list fields should use plural naming.
   */
  trainer: Maybe<Array<Trainer>>;
  trainerLabel: Scalars['String']['output'];
  /** Get the trainers for the bookable items */
  trainers: Array<Trainer>;
  venue: Venue;
};


/** A bookable representation of an event. For single-session events, this corresponds to an `Appointment`. For multi-session events, this corresponds to an `Activity` that contains multiple sessions. */
export type EventBookableItemParticipatingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type EventBookableItemConnection = {
  __typename: 'EventBookableItemConnection';
  edges: Array<EventBookableItemEdge>;
  /** The actual "EventBookableItem" items */
  nodes: Array<EventBookableItem>;
  pageInfo: PageInfo;
};

export type EventBookableItemEdge = {
  __typename: 'EventBookableItemEdge';
  cursor: Scalars['Cursor']['output'];
  node: EventBookableItem;
};

/** A user's booking for an event. Corresponds to an `ActivityParticipation` in the underlying data model. */
export type EventBooking = BookingInterface & {
  __typename: 'EventBooking';
  assignedSpot: Maybe<Spot>;
  /** @deprecated Use bookableItemV2 instead, which returns the entire bookable item, with all sessions, rather than just the ones included in your booking. If you want just the sessions included in your booking use sessions instead */
  bookableItem: EventBookableItem;
  /** return the full bookableItem, including all session of the bookable item, not just the ones included in the booking. */
  bookableItemV2: EventBookableItem;
  cancelInfo: CancellationInfo;
  confirmedWith: Maybe<ConfirmWithOption>;
  id: Scalars['ID']['output'];
  /** The participations of this booking's event sessions */
  participations: EventSessionParticipationConnection;
  purchasedWith: Maybe<PurchasedWith>;
  /** @deprecated Deprecated due to the migration of SelfCheckIn to EventSessionParticipation and data inconsistent */
  selfCheckIn: Maybe<SelfCheckIn>;
  /** The sessions included in this booking */
  sessions: Array<EventSession>;
  timeRange: TimeRange;
};


/** A user's booking for an event. Corresponds to an `ActivityParticipation` in the underlying data model. */
export type EventBookingParticipationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum EventDifficultyLevel {
  ALL = 'ALL',
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  PROFESSIONAL = 'PROFESSIONAL'
}

export type EventFilters = {
  activityLocationType?: InputMaybe<Array<ActivityLocationType>>;
  difficultyLevel?: InputMaybe<Array<EventDifficultyLevel>>;
  eventTypes?: InputMaybe<Array<EventType>>;
  eventVisibility?: InputMaybe<Array<EventVisibility>>;
  timeRange?: InputMaybe<OpenEndTimeRangeInput>;
};

export type EventRegistrationState = {
  __typename: 'EventRegistrationState';
  bookable: Scalars['Boolean']['output'];
  validationProblems: Array<EventRegistrationValidationProblem>;
};

/**
 * Determines how customers are registering for this Event.
 *     - "SingleSession" means registrations are always made for only exactly 1 session at a time
 *     - "AllSessions" means registrations are always made for *all* the sessions in the event at once
 *     - "Tickets" means that and entity called _Ticket_ defines specific subsets of 1, some or all sessions and registration are made for these predefined subsets of Sessions
 */
export enum EventRegistrationType {
  ALL_SESSIONS = 'ALL_SESSIONS',
  PRIVATE_SESSION = 'PRIVATE_SESSION',
  SINGLE_SESSION = 'SINGLE_SESSION',
  TICKETS = 'TICKETS'
}

/** A reason why an eventbookable item cannot be booked */
export enum EventRegistrationValidationProblem {
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  CANCELLED = 'CANCELLED',
  CUSTOMERGROUP_RESTRICTED = 'CUSTOMERGROUP_RESTRICTED',
  FULLY_BOOKED = 'FULLY_BOOKED',
  INVALID_EVENT = 'INVALID_EVENT',
  IN_PAST = 'IN_PAST',
  MAX_FUTURE_BOOKINGS = 'MAX_FUTURE_BOOKINGS',
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_BOOKABLE = 'NOT_BOOKABLE',
  REGISTRATION_WINDOW = 'REGISTRATION_WINDOW'
}

/** Indicates whether this event is currently open for booking, not yet open or no longer open. Note that "open" does not automatically mean it is actually bookable. Other factors such as availability also need to be considered independently. (see _registrationState_) */
export enum EventRegistrationWindowState {
  CLOSED = 'CLOSED',
  NOT_YET_OPEN = 'NOT_YET_OPEN',
  OPEN = 'OPEN'
}

export type EventSession = {
  __typename: 'EventSession';
  availableSpots: SpotLimit;
  court: Maybe<Court>;
  end: Scalars['DateTime']['output'];
  event: EventBookableItem;
  hasOnlineStream: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Image>;
  location: Maybe<Location>;
  name: Scalars['String']['output'];
  onlineStream: Maybe<OnlineStream>;
  shortId: Scalars['ID']['output'];
  start: Scalars['DateTime']['output'];
  trainer: Maybe<Trainer>;
};

export type EventSessionConnection = {
  __typename: 'EventSessionConnection';
  edges: Array<EventSessionEdge>;
  /** The actual "EventSession" items */
  nodes: Array<EventSession>;
  pageInfo: PageInfo;
};

export type EventSessionEdge = {
  __typename: 'EventSessionEdge';
  cursor: Scalars['Cursor']['output'];
  node: EventSession;
};

export type EventSessionParticipation = ParticipationInterface & {
  __typename: 'EventSessionParticipation';
  /** Friends of the logged in user who are participating */
  attendingFriends: Maybe<FriendConnection>;
  /** return the full bookableItem, including all session of the bookable item, not just the ones included in the booking. */
  bookableItem: EventBookableItem;
  eventBooking: EventBooking;
  id: Scalars['ID']['output'];
  /** Whether the session was cancelled by the venue */
  isSessionCancelled: Maybe<Scalars['Boolean']['output']>;
  participationState: Maybe<ParticipationState>;
  selfCheckIn: Maybe<SelfCheckIn>;
  session: EventSession;
  timeRange: TimeRange;
};


export type EventSessionParticipationAttendingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type EventSessionParticipationConnection = {
  __typename: 'EventSessionParticipationConnection';
  edges: Array<EventSessionParticipationEdge>;
  /** The actual "EventSessionParticipation" items */
  nodes: Array<EventSessionParticipation>;
  pageInfo: PageInfo;
};

export type EventSessionParticipationEdge = {
  __typename: 'EventSessionParticipationEdge';
  cursor: Scalars['Cursor']['output'];
  node: EventSessionParticipation;
};

export enum EventType {
  CAMP = 'Camp',
  CLASS = 'Class',
  COURSE = 'Course',
  EDUCATION = 'Education',
  EVENT = 'Event',
  OPENTRAINING = 'OpenTraining',
  PRIVATE = 'Private',
  RETREAT = 'Retreat',
  TRAINING = 'Training',
  WORKSHOP = 'Workshop'
}

export enum EventVisibility {
  BOOKABLE = 'BOOKABLE',
  DISPLAY = 'DISPLAY',
  HIDE = 'HIDE'
}

export type EversportsPushNotificationEndpoint = {
  __typename: 'EversportsPushNotificationEndpoint';
  appType: AppType;
};

export type ExpectedError = {
  __typename: 'ExpectedError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  path: Maybe<Scalars['String']['output']>;
};

export type ExpectedErrors = {
  __typename: 'ExpectedErrors';
  errors: Array<ExpectedError>;
};

export type ExternalLoginInput = {
  accessToken: Scalars['String']['input'];
  additionalProfileInformation?: InputMaybe<AdditionalProfileInput>;
  provider: ExternalLoginProvider;
};

export enum ExternalLoginProvider {
  EXTERNAL_LOGIN_PROVIDER_APPLE = 'EXTERNAL_LOGIN_PROVIDER_APPLE',
  EXTERNAL_LOGIN_PROVIDER_FACEBOOK = 'EXTERNAL_LOGIN_PROVIDER_FACEBOOK',
  EXTERNAL_LOGIN_PROVIDER_GOOGLE = 'EXTERNAL_LOGIN_PROVIDER_GOOGLE'
}

export type ExternalTrackingIds = {
  __typename: 'ExternalTrackingIds';
  googleAnalyticsId: Maybe<Scalars['String']['output']>;
};

export type Family = {
  __typename: 'Family';
  id: Scalars['ID']['output'];
  members: Array<User>;
  owner: User;
};

export type FamilyResponse = ExpectedErrors | Family;

export enum FamilyRole {
  FAMILY_ROLE_MEMBER = 'FAMILY_ROLE_MEMBER',
  FAMILY_ROLE_OWNER = 'FAMILY_ROLE_OWNER'
}

export type FavoriteVenue = {
  __typename: 'FavoriteVenue';
  frequencyDescription: Maybe<Scalars['String']['output']>;
  venue: Venue;
};

export type FavoriteVenueConnection = {
  __typename: 'FavoriteVenueConnection';
  edges: Array<FavoriteVenueEdge>;
  /** The actual "FavoriteVenue" items */
  nodes: Array<FavoriteVenue>;
  pageInfo: PageInfo;
};

export type FavoriteVenueEdge = {
  __typename: 'FavoriteVenueEdge';
  cursor: Scalars['Cursor']['output'];
  node: FavoriteVenue;
};

export type FeaturePreview = {
  __typename: 'FeaturePreview';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  on: Scalars['Boolean']['output'];
  rolloutPercentage: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A freetext possibly containing markup like lists, paragraphs, emphasis etc. */
export type FormattedText = {
  __typename: 'FormattedText';
  /** An HTML representation of the description containing semantic HTML tags like <p>, <li> or <b> and HTML entities like &amp; to represent a & sign. */
  html: Scalars['String']['output'];
  /** A plain text representation of the formatted text using plain text characters like e.g. newline (`\n`) to replace a paragraph. */
  plainText: Scalars['String']['output'];
};

export type Friend = {
  __typename: 'Friend';
  id: Scalars['ID']['output'];
  publicUser: PublicUserV2;
  since: Scalars['DateTime']['output'];
};

export type FriendConnection = {
  __typename: 'FriendConnection';
  edges: Array<FriendEdge>;
  /** The actual "Friend" items */
  nodes: Array<Friend>;
  pageInfo: PageInfo;
};

export type FriendEdge = {
  __typename: 'FriendEdge';
  cursor: Scalars['Cursor']['output'];
  node: Friend;
};

export type FriendRequest = {
  __typename: 'FriendRequest';
  from: PublicUserV2;
  id: Scalars['ID']['output'];
  requestedAt: Scalars['DateTime']['output'];
  to: PublicUserV2;
};

export type FriendRequestConnection = {
  __typename: 'FriendRequestConnection';
  edges: Array<FriendRequestEdge>;
  /** The actual "FriendRequest" items */
  nodes: Array<FriendRequest>;
  pageInfo: PageInfo;
};

export type FriendRequestEdge = {
  __typename: 'FriendRequestEdge';
  cursor: Scalars['Cursor']['output'];
  node: FriendRequest;
};

export enum Gender {
  GENDER_FEMALE = 'GENDER_FEMALE',
  GENDER_MALE = 'GENDER_MALE',
  GENDER_OTHER = 'GENDER_OTHER'
}

/** Temporary type for generic stuff that can be on an order but is not implemented yet */
export type GenericAssignedProduct = {
  __typename: 'GenericAssignedProduct';
  id: Scalars['ID']['output'];
};

export type GeoSearchByRadiusAndCoordinate = {
  coordinate: CoordinateArgs;
  /** Radius in meter */
  radius: Scalars['Float']['input'];
};

export type Image = {
  __typename: 'Image';
  large: Scalars['String']['output'];
  listBasic: Scalars['String']['output'];
  listPremium: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  small: Scalars['String']['output'];
  xLarge: Scalars['String']['output'];
  xSmall: Scalars['String']['output'];
};

export type IntegerValueQuery = {
  operator: ComparisonOperator;
  value: Scalars['Int']['input'];
};

export type Interval = {
  __typename: 'Interval';
  type: IntervalUnit;
  value: Scalars['Int']['output'];
};

export enum IntervalUnit {
  INTERVAL_UNIT_DAYS = 'INTERVAL_UNIT_DAYS',
  INTERVAL_UNIT_HOURS = 'INTERVAL_UNIT_HOURS',
  INTERVAL_UNIT_MONTHS = 'INTERVAL_UNIT_MONTHS',
  INTERVAL_UNIT_WEEKS = 'INTERVAL_UNIT_WEEKS',
  INTERVAL_UNIT_YEARS = 'INTERVAL_UNIT_YEARS'
}

export type InventorySearchResult = SportSearchResult | VenueSearchResult;

export type Invitation = {
  __typename: 'Invitation';
  customers: Array<Customer>;
  invitedBy: InvitedBy;
  isEversportsUser: Scalars['Boolean']['output'];
  showAppPromotion: Scalars['Boolean']['output'];
  state: InvitationState;
  user: User;
  /** @deprecated Deprecated in favor of customer.customerGroup.company */
  venue: Maybe<Venue>;
};

export enum InvitationState {
  INVITATION_STATE_ACCEPTED = 'INVITATION_STATE_ACCEPTED',
  INVITATION_STATE_ACTIVE = 'INVITATION_STATE_ACTIVE',
  INVITATION_STATE_EXPIRED = 'INVITATION_STATE_EXPIRED'
}

/** It will return a User if the invitation was created by a family owner removing a family member and inviting it to eversports, or a Venue otherwise */
export type InvitedBy = User | Venue;

export type Invoice = {
  __typename: 'Invoice';
  amount: MonetaryValue;
  downloadLink: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** @deprecated Use state field to know if invoice is fully paid or not */
  isFullyPaid: Scalars['Boolean']['output'];
  issueDate: Maybe<Scalars['DateTime']['output']>;
  number: Scalars['String']['output'];
  state: InvoiceState;
  usedPaymentServices: Array<PaymentServiceType>;
};

/**
 *
 *   - INVOICE_STATE_FULLY_PAID: Fully paid invoice
 *   - INVOICE_STATE_OPEN: Not fully paid
 *   - INVOICE_STATE_CANCELLED: Cancelled invoice
 *   - INVOICE_STATE_REFUND: refund invoice for a cancelled invoice
 *
 */
export enum InvoiceState {
  INVOICE_STATE_CANCELLED = 'INVOICE_STATE_CANCELLED',
  INVOICE_STATE_FULLY_PAID = 'INVOICE_STATE_FULLY_PAID',
  INVOICE_STATE_OPEN = 'INVOICE_STATE_OPEN',
  INVOICE_STATE_REFUND = 'INVOICE_STATE_REFUND'
}

export enum JoinMatchAnswer {
  NO = 'NO',
  YES = 'YES'
}

export type JoinMatchV2 = BallsportMatch | ExpectedErrors;

export type LeaveMatchV2 = BallsportMatch | ExpectedErrors;

/** A limit of how much Budget is available */
export type Limited = {
  __typename: 'Limited';
  /** If `true` means the above `value` was capped for non-disclosure reasons. I.e. the actual display might be larger than the displayed sum. Hence the client should display the value as "more than x" */
  displayCapped: Scalars['Boolean']['output'];
  limit: MonetaryValue;
  type: Scalars['String']['output'];
};

/** A limit of spots */
export type LimitedSpots = {
  __typename: 'LimitedSpots';
  /** If `true` means the above `limit` was capped for non-disclosure reasons. I.e. the actual available spots might be larger than the displayed amount. Hence the client should display the value as "more than x" */
  displayCapped: Scalars['Boolean']['output'];
  /** The number of free spots. It might be capped in case `displayCapped` equals `true` */
  limit: Scalars['Int']['output'];
  /** The number of booked spots */
  occupied: Scalars['Int']['output'];
  /** Maximum number of bookable spots */
  total: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type Location = {
  __typename: 'Location';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  /** This field should include information for the house number, street number or door number */
  detail: Scalars['String']['output'];
  /** Note this field is NULLABLE. In some cases like a venue's location we don't have this info. If indoor is explicitly "false", the location is outdoor. */
  indoor: Maybe<Scalars['Boolean']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type LocationInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  /** This field should include information for the house number, street number or door number */
  detail: Scalars['String']['input'];
  /** Note this field is NULLABLE. In some cases like a venue's location we don't have this info. If indoor is explicitly "false", the location is outdoor. */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type LongestStreak = {
  __typename: 'LongestStreak';
  days: Scalars['Int']['output'];
  timeRange: Maybe<TimeRange>;
};

export type Mandate = {
  __typename: 'Mandate';
  bankAccount: StoredBankAccount;
  isVerified: Scalars['Boolean']['output'];
};

export type Match = BallsportMatch;

export type MatchComment = {
  __typename: 'MatchComment';
  commentator: MatchCommentator;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type MatchCommentConnection = {
  __typename: 'MatchCommentConnection';
  edges: Array<MatchCommentEdge>;
  /** The actual "MatchComment" items */
  nodes: Array<MatchComment>;
  pageInfo: PageInfo;
};

export type MatchCommentEdge = {
  __typename: 'MatchCommentEdge';
  cursor: Scalars['Cursor']['output'];
  node: MatchComment;
};

export type MatchCommentator = {
  __typename: 'MatchCommentator';
  name: Scalars['String']['output'];
  profilePicture: Maybe<Image>;
  userId: Scalars['ID']['output'];
};

export enum MatchCompetitionType {
  COMPETITIVE = 'COMPETITIVE',
  FRIENDLY = 'FRIENDLY'
}

export type MatchFilters = {
  competitionTypes?: InputMaybe<Array<MatchCompetitionType>>;
  genders?: InputMaybe<Array<MatchGender>>;
  /** Geo search of matches by radius around a coordinate */
  geoSearch?: InputMaybe<GeoSearchByRadiusAndCoordinate>;
  /** If set to `true`, it will filter for matches with open spots. `false` and `undefined` will not filter the result */
  hasOpenSpots?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<MatchLevel>>;
  sportIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeRange?: InputMaybe<OpenEndTimeRangeInput>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  visibility?: InputMaybe<MatchVisibility>;
};

export enum MatchGender {
  FEMALE_ONLY = 'FEMALE_ONLY',
  MALE_ONLY = 'MALE_ONLY',
  UNISEX = 'UNISEX'
}

export type MatchInterface = {
  comments: MatchCommentConnection;
  competitionType: Maybe<MatchCompetitionType>;
  end: Scalars['DateTime']['output'];
  gender: Maybe<MatchGender>;
  id: Scalars['ID']['output'];
  level: Maybe<MatchLevel>;
  matchVisibilityValidations: Array<MatchVisibilityValidation>;
  maxParticipants: Maybe<Scalars['Int']['output']>;
  minParticipants: Maybe<Scalars['Int']['output']>;
  /** @deprecated Deprecated in favour of organizerV2 */
  organizer: User;
  organizerNote: Maybe<Scalars['String']['output']>;
  organizerV2: MatchOrganizerType;
  participants: Array<MatchParticipant>;
  relativeLink: Scalars['String']['output'];
  sport: Sport;
  start: Scalars['DateTime']['output'];
  venue: Venue;
  visibility: MatchVisibility;
};


export type MatchInterfaceCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum MatchLevel {
  ADVANCED = 'ADVANCED',
  ANY = 'ANY',
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE'
}

export enum MatchMissingField {
  COMPETITION_TYPE = 'COMPETITION_TYPE',
  GENDER = 'GENDER',
  LEVEL = 'LEVEL',
  MAX_PARTICIPANTS = 'MAX_PARTICIPANTS'
}

export type MatchOrganizerInterface = {
  bio: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  profilePicture: Maybe<Image>;
};

/** Possible types of an organizer, depending on the logged in user */
export type MatchOrganizerType = PrivateMatchOrganizer | PublicMatchOrganizer;

export type MatchParticipant = {
  __typename: 'MatchParticipant';
  answer: MatchParticipantAnswer;
  id: Scalars['ID']['output'];
  /** @deprecated Deprecated in favour of user field */
  identity: MatchParticipantIdentity;
  /** @deprecated This is just there to avoid clients to break. Must be removed when all clients remove the dependency. always empty string */
  secretId: Scalars['String']['output'];
  user: MatchParticipantUserType;
};

export enum MatchParticipantAnswer {
  NO = 'NO',
  YES = 'YES'
}

export type MatchParticipantIdentity = PublicUser | User;

export type MatchParticipantInput = {
  answer: MatchParticipantAnswer;
  /** Has value when participant is an anonymous user. Is exclusive with "userId" propery. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Has value when participant is a member of eversports. Is exclusive with "name" propery. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MatchParticipantUserType = PublicUserV2 | User;

export type MatchUpdateFields = {
  competitionType?: InputMaybe<MatchCompetitionType>;
  gender?: InputMaybe<MatchGender>;
  level?: InputMaybe<MatchLevel>;
  maxParticipants?: InputMaybe<Scalars['Float']['input']>;
  minParticipants?: InputMaybe<Scalars['Float']['input']>;
  organizerNote?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<MatchVisibility>;
};

export enum MatchVisibility {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type MatchVisibilityValidation = PrivateMatchVisibilityValidation | PublicMatchVisibilityValidation;

export type MatchVisibilityValidationInterface = {
  missingFields: Array<MatchMissingField>;
  requiredFields: Array<MatchMissingField>;
};

export type Member = {
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
};

/**
 * Membership, for example "Monthly flex"
 *
 * A membership is characterized by having a runtime instead of a single
 * validity period, and a payment plan instead of a one-time price.
 *
 * - _Can_ define _repeating_ `UsageLimit`s.
 */
export type Membership = ProductInterface & {
  __typename: 'Membership';
  /** List of activities for which this Membership can be used. */
  activities: Array<Activity>;
  conditions: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The partial billing information of the membership if bought today. */
  partialBillingInformation: PartialBillingInformation;
  /** The partial payment information if the membership is bought today. */
  partialPriceInformation: Maybe<PartialPriceInformation>;
  paymentAndCancellationTerms: Maybe<Scalars['String']['output']>;
  paymentPlan: PaymentPlan;
  productPurchaseInformation: ProductPurchaseInformation;
  runtime: Runtime;
  usages: Array<UsageLimit>;
  /** List of venues at which the Membership can be used. */
  venues: Array<Venue>;
};


/**
 * Membership, for example "Monthly flex"
 *
 * A membership is characterized by having a runtime instead of a single
 * validity period, and a payment plan instead of a one-time price.
 *
 * - _Can_ define _repeating_ `UsageLimit`s.
 */
export type MembershipPartialBillingInformationArgs = {
  validFrom: Scalars['DateTime']['input'];
};

export type MembershipPeriod = {
  __typename: 'MembershipPeriod';
  id: Scalars['ID']['output'];
  invoices: Array<Invoice>;
};

export enum MembershipState {
  MEMBERSHIP_STATE_ABORTED = 'MEMBERSHIP_STATE_ABORTED',
  MEMBERSHIP_STATE_ACTIVE = 'MEMBERSHIP_STATE_ACTIVE',
  MEMBERSHIP_STATE_CANCELLED = 'MEMBERSHIP_STATE_CANCELLED',
  MEMBERSHIP_STATE_PENDING = 'MEMBERSHIP_STATE_PENDING',
  MEMBERSHIP_STATE_TERMINATED = 'MEMBERSHIP_STATE_TERMINATED'
}

export type MetaData = {
  __typename: 'MetaData';
  /** meta description of the html document. should be used within the meta description tag */
  description: Maybe<Scalars['String']['output']>;
  /** if true, the page should be indexed by search engines */
  index: Maybe<Scalars['Boolean']['output']>;
  /** data relevant for social media */
  social: Social;
  /** title of the html document. should be used within the title tag */
  title: Scalars['String']['output'];
};

/**
 * This type represents any kind of monetary value, such as price or balance.
 * It is a combination of a `value` in cents, and a `currency` as an
 * [ISO 4217 Currency Code](https://www.xe.com/iso4217.php).
 *
 * ### Example
 *
 * A price of `1, 99 €` will be represented as
 *
 * ```
 * {
 *     value: 199,
 *     currency: "EUR"
 *   }
 * ```
 */
export type MonetaryValue = {
  __typename: 'MonetaryValue';
  currency: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type MultiPlayerSettings = {
  __typename: 'MultiPlayerSettings';
  /** Maximum number of players that can be added to the booking. This includes the user themselves */
  maxPlayers: Scalars['Int']['output'];
  /** Minimum number of players required for the booking. This includes the user themselves */
  minPlayers: Scalars['Int']['output'];
  /** If true, other players must be named for this booking */
  required: Scalars['Boolean']['output'];
};

export type MultiPlayerUser = {
  __typename: 'MultiPlayerUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  /** Abort an open order */
  abortOrder: OrderResponse;
  acceptEversportsPolicies: AuthResponse;
  /** Accept a friend request, returns the `PublicUserV2` of the requested user */
  acceptFriendRequest: FriendRequest;
  acceptInvitation: AuthResponse;
  acceptVenuePolicies: AuthResponse;
  addFamilyMember: UserResponseType;
  addMatchComment: AddMatch;
  /** Adds the id of a multiplayer user to a bookableItem cartItem */
  addMultiplayerUserToBookableItemCartItem: CartResponse;
  addNetPromoterScore: Scalars['Boolean']['output'];
  /**
   * add a participant to a match
   * @deprecated Return type is not specific to mutation. Use addParticipantOnMatchV2
   */
  addParticipantOnMatch: MatchParticipant;
  /** add a participant to a match */
  addParticipantOnMatchV2: AddParticipantOnMatchV2;
  addToWaitingList: AddToWaitingListResponse;
  addVenueToFavourites: Venue;
  /** Cancel booking */
  cancelBooking: Scalars['Boolean']['output'];
  cancelFriendRequest: FriendRequest;
  /** cancel a match (by organizer) */
  cancelMatch: CancelMatch;
  changePassword: AuthResponse;
  /** Update the isCheckedIn status of the provided event session participation */
  checkIn: CheckInResponse;
  confirmNewsletterSubscription: ConfirmNewsletterSubscriptionResponse;
  /** Confirm an open order */
  confirmOrder: OrderResponse;
  /** Confirm a payment */
  confirmPaymentWithPaymentMethod: PaymentResponseType;
  /** Creates a new cart for booking an court bookable item */
  createCartFromCourtBookableItem: CartResponse;
  /** Creates a new cart for booking an event bookable item */
  createCartFromEventBookableItem: CartResponse;
  /** Creates a new cart for a shop product */
  createCartFromPrivateSessionOffer: CartResponse;
  /** Creates a new cart for a shop product */
  createCartFromProduct: CartResponse;
  /** Creates a new cart for a voucher */
  createCartFromVoucher: CartResponse;
  /** Creates a court booking. Called from the marketplace etc. */
  createCourtBookableItem: Scalars['String']['output'];
  /** Creates customer session. Provides temporary access to stripe customer */
  createCustomerSession: CustomerSession;
  /** Create ephemeral key for mobile payment elements. Provides temporary access to customer payment methods. */
  createEphemeralKey: EphemeralKey;
  createFamily: FamilyResponse;
  /** create a match from a booking (by the person who did the booking) */
  createMatchFromBooking: CreatedBallsportMatch;
  /** Create an order from a given cart. May result in an order with a `CONFIRMED` or an `OPEN` state, based on whether a form of payment is necessary or not */
  createOrderFromCart: OrderResponse;
  createPrivateFeedback: PrivateFeedbackResponse;
  credentialLogin: AuthResponse;
  credentialRegistration: AuthResponse;
  declineFriendRequest: FriendRequest;
  deleteMatchComment: DeleteMatch;
  dismissNetPromoterScore: Scalars['Boolean']['output'];
  dismissNetPromoterScoreV2: Scalars['Boolean']['output'];
  endFriendship: PublicUserV2;
  externalLogin: AuthResponse;
  familyLogin: AuthResponse;
  inviteFamilyMemberAsEversportsUser: UserResponseType;
  /**
   * add current logged-in user to a given match participants
   * @deprecated Return type is not specific to mutation. Use joinMatchV2
   */
  joinMatch: Match;
  /** add current logged-in user to a given match participants */
  joinMatchV2: JoinMatchV2;
  /**
   * remove current logged-in user from the list of participants of a given match
   * @deprecated Return type is not specific to mutation. Use leaveMatchV2
   */
  leaveMatch: Match;
  /** remove current logged-in user from the list of participants of a given match */
  leaveMatchV2: LeaveMatchV2;
  logout: Scalars['Boolean']['output'];
  markAllNotificationsAsSeen: Scalars['Boolean']['output'];
  maskerade: AuthResponse;
  /** Setup a payment intent for a payment */
  preparePayment: PaymentResponseType;
  /** Create or Update push notification endpoint information to receive pushes to this app. Needs a logged in user. */
  registerEndpoint: Scalars['Boolean']['output'];
  removeFamilyMember: UserResponseType;
  removeFromWaitingList: RemoveFromWaitingListResponse;
  /** Removes the id of a multiplayer user from a bookableItem cartItem */
  removeMultiplayerUserFromBookableItemCartItem: CartResponse;
  /**
   * remove some participants from a match
   * @deprecated Return type is not specific to mutation. Use removeParticipantsFromMatchV2
   */
  removeParticipantsFromMatch: Match;
  /** remove some participants from a match */
  removeParticipantsFromMatchV2: RemoveParticipantsFromMatchV2;
  /** Remove a `PaymentMethod` from user stored payment methods */
  removePaymentMethod: StoredPaymentMethodResponse;
  removeVenueFromFavourites: Venue;
  /** Request a friendship, returns the `PublicUserV2` of the requested user */
  requestFriendship: FriendRequest;
  requestPasswordReset: ResetPasswordResponse;
  requestVerificationEmail: RequestVerificationResponse;
  resetPassword: AuthResponse;
  seenNotifications: Scalars['Boolean']['output'];
  /** Set add-on for a bookable item cart item */
  setAddOnsForBookableItemCartItem: CartResponse;
  /** Set the number of guest players for multiplayer booking */
  setCommentOnBookableItemCartItem: CartResponse;
  /** Sets the answer to a multi answer patron question for the given cart */
  setMultiAnswerPatronQuestionOnCart: CartResponse;
  /** Set the number of guest players for multiplayer booking */
  setNumberOfGuestsOnBookableItemCartItem: CartResponse;
  /**
   * set organizer note of the match (by organizer)
   * @deprecated use updateMatch mutation instead
   */
  setOrganizerNoteOnMatch: Match;
  /** Sets the patron question for the given cart */
  setPatronQuestionOnCart: CartResponse;
  /** Sets the given policies as accepted, which policies are necessary is given in the field `cart.policies`. */
  setPoliciesOnCart: CartResponse;
  /**
   * Set selected product for a bookable item cart item
   * @deprecated Use `setProductForCartItem` instead, which is consistent for product and bookableitem checkout
   */
  setProductForBookableItemCartItem: CartResponse;
  /** Set selected product for a product or bookableitem cart item */
  setProductForCartItem: CartResponse;
  /** Set eventually necessary missing/required information on a cart */
  setRequiredInformationOnCart: CartResponse;
  /**
   * Sets whether to use or not use a potential corporate Budget on this Cart
   * @deprecated Use "setUseCorporateBenefitsOnCart" to opt in and out of both discounts and budget at once.
   */
  setUseBudgetOnCart: CartResponse;
  /** Sets whether to use or not use any potential corporate Budget or Corporate Discounts on this Cart */
  setUseCorporateBenefitsOnCart: CartResponse;
  /** Adds or deletes a voucher from the cart */
  setVoucherOnCart: CartResponse;
  /** Set voucher on an order */
  setVoucherOnOrder: OrderResponse;
  /** This mutation allows users to setup up a recurring payment method */
  setupPaymentMethod: PaymentSetupIntent;
  /** Prepare a payment for recurring payments */
  setupRecurringPaymentMethod: PaymentResponseType;
  shareEvent: Scalars['Boolean']['output'];
  shareFamilyMemberWithVenue: CustomerResponseType;
  shareMatch: Scalars['Boolean']['output'];
  shareVenue: Scalars['Boolean']['output'];
  startGeneratingInvoiceDownloadLink: Scalars['String']['output'];
  /** Store a `PaymentMethod` for the currently logged in user. */
  storePaymentMethod: StoredPaymentMethodResponse;
  /** Subscribe the customer to the newsletter. */
  subscribeToNewsletter: Customer;
  /** Terminate the Assigned Membership by assignedMembershipId */
  terminateMembership: AssignedMembershipResponse;
  /** Track the completion of a new checkout for a certain device and session id */
  trackCheckoutComplete: Scalars['Boolean']['output'];
  /** Track the start of a new checkout for a certain device and session id */
  trackCheckoutStart: Scalars['Boolean']['output'];
  /** Update a subset of match properties */
  updateMatch: UpdateMatch;
  updatePrivacySettings: Array<PrivacySetting>;
  updateSpot: Spot;
  /** Update a credit card for the currently logged in user. */
  updateStoredCreditCard: StoredPaymentMethodResponse;
  verifyEmail: AuthResponse;
};


export type MutationAbortOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationAcceptFriendRequestArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAcceptInvitationArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationAcceptVenuePoliciesArgs = {
  venueId: Scalars['ID']['input'];
};


export type MutationAddFamilyMemberArgs = {
  member: Member;
};


export type MutationAddMatchCommentArgs = {
  matchId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationAddMultiplayerUserToBookableItemCartItemArgs = {
  cartId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAddNetPromoterScoreArgs = {
  channel: NetPromoterScoreChannel;
  comment?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Int']['input'];
};


export type MutationAddParticipantOnMatchArgs = {
  answer: AddParticipantToMatchAnswer;
  matchId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationAddParticipantOnMatchV2Args = {
  answer: AddParticipantToMatchAnswer;
  matchId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationAddToWaitingListArgs = {
  eventBookableItemId: Scalars['ID']['input'];
};


export type MutationAddVenueToFavouritesArgs = {
  venueId: Scalars['String']['input'];
};


export type MutationCancelBookingArgs = {
  id: Scalars['ID']['input'];
  isLateCancellation?: InputMaybe<Scalars['Boolean']['input']>;
  origin: Origin;
};


export type MutationCancelFriendRequestArgs = {
  userId: Scalars['String']['input'];
};


export type MutationCancelMatchArgs = {
  matchId: Scalars['ID']['input'];
  origin: Origin;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationCheckInArgs = {
  participationId: Scalars['ID']['input'];
};


export type MutationConfirmNewsletterSubscriptionArgs = {
  token: Scalars['String']['input'];
};


export type MutationConfirmOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationConfirmPaymentWithPaymentMethodArgs = {
  paymentId: Scalars['ID']['input'];
  pspPaymentMethodId: Scalars['String']['input'];
};


export type MutationCreateCartFromCourtBookableItemArgs = {
  clientMetadata?: InputMaybe<ClientMetadataInput>;
  courtId: Scalars['ID']['input'];
  device?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['String']['input'];
  origin: Origin;
  sportId: Scalars['ID']['input'];
  start: Scalars['String']['input'];
};


export type MutationCreateCartFromEventBookableItemArgs = {
  bookableItemId: Scalars['ID']['input'];
  clientMetadata?: InputMaybe<ClientMetadataInput>;
  device?: InputMaybe<Scalars['String']['input']>;
  origin: Origin;
};


export type MutationCreateCartFromPrivateSessionOfferArgs = {
  clientMetadata?: InputMaybe<ClientMetadataInput>;
  device?: InputMaybe<Scalars['String']['input']>;
  origin: Origin;
  privateSessionOfferId: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  trainerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateCartFromProductArgs = {
  clientMetadata?: InputMaybe<ClientMetadataInput>;
  device?: InputMaybe<Scalars['String']['input']>;
  origin: Origin;
  productId: Scalars['ID']['input'];
  venueId: Scalars['ID']['input'];
};


export type MutationCreateCartFromVoucherArgs = {
  amount: Scalars['Int']['input'];
  clientMetadata?: InputMaybe<ClientMetadataInput>;
  device?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  origin: Origin;
  venueId: Scalars['ID']['input'];
};


export type MutationCreateCourtBookableItemArgs = {
  courtId: Scalars['ID']['input'];
  sportId: Scalars['ID']['input'];
  timeRange: TimeRangeInput;
};


export type MutationCreateCustomerSessionArgs = {
  isMobilePaymentElement?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateFamilyArgs = {
  members: Array<Member>;
};


export type MutationCreateMatchFromBookingArgs = {
  bookingId: Scalars['ID']['input'];
  minParticipants?: InputMaybe<Scalars['Int']['input']>;
  organizerNote?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<Array<MatchParticipantInput>>;
};


export type MutationCreateOrderFromCartArgs = {
  cartId: Scalars['ID']['input'];
  skipSetupFutureUsage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreatePrivateFeedbackArgs = {
  rating: Scalars['Float']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};


export type MutationCredentialLoginArgs = {
  credentials: CredentialLoginInput;
  params: AuthParamsInput;
};


export type MutationCredentialRegistrationArgs = {
  params: AuthParamsInput;
  profile: RegistrationProfileInput;
  settings: RegistrationSettingsInput;
};


export type MutationDeclineFriendRequestArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteMatchCommentArgs = {
  commentId: Scalars['ID']['input'];
};


export type MutationDismissNetPromoterScoreV2Args = {
  channel: NetPromoterScoreChannel;
};


export type MutationEndFriendshipArgs = {
  userId: Scalars['String']['input'];
};


export type MutationExternalLoginArgs = {
  credentials: ExternalLoginInput;
  params: AuthParamsInput;
};


export type MutationFamilyLoginArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationInviteFamilyMemberAsEversportsUserArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationJoinMatchArgs = {
  answer: JoinMatchAnswer;
  matchId: Scalars['ID']['input'];
};


export type MutationJoinMatchV2Args = {
  answer: JoinMatchAnswer;
  matchId: Scalars['ID']['input'];
};


export type MutationLeaveMatchArgs = {
  matchId: Scalars['ID']['input'];
};


export type MutationLeaveMatchV2Args = {
  matchId: Scalars['ID']['input'];
};


export type MutationMaskeradeArgs = {
  email: Scalars['String']['input'];
  params: AuthParamsInput;
};


export type MutationPreparePaymentArgs = {
  paymentId: Scalars['ID']['input'];
  paymentMethodType: PaymentMethodType;
};


export type MutationRegisterEndpointArgs = {
  brandedAppId?: InputMaybe<Scalars['String']['input']>;
  platform: Platform;
  token: Scalars['String']['input'];
  type: AppType;
  uuid: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type MutationRemoveFamilyMemberArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRemoveFromWaitingListArgs = {
  eventBookableItemId: Scalars['ID']['input'];
};


export type MutationRemoveMultiplayerUserFromBookableItemCartItemArgs = {
  cartId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveParticipantsFromMatchArgs = {
  matchId: Scalars['ID']['input'];
  matchParticipantIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveParticipantsFromMatchV2Args = {
  matchId: Scalars['ID']['input'];
  matchParticipantIds: Array<Scalars['ID']['input']>;
};


export type MutationRemovePaymentMethodArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationRemoveVenueFromFavouritesArgs = {
  venueId: Scalars['String']['input'];
};


export type MutationRequestFriendshipArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
  queryString?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSeenNotificationsArgs = {
  notificationIds: Array<Scalars['String']['input']>;
};


export type MutationSetAddOnsForBookableItemCartItemArgs = {
  addOns: Array<AddOnInputInput>;
  cartId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
};


export type MutationSetCommentOnBookableItemCartItemArgs = {
  cartId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
};


export type MutationSetMultiAnswerPatronQuestionOnCartArgs = {
  cartId: Scalars['ID']['input'];
  patronageAnswer: PatronageAnswer;
};


export type MutationSetNumberOfGuestsOnBookableItemCartItemArgs = {
  cartId: Scalars['ID']['input'];
  numberOfGuests: Scalars['Int']['input'];
};


export type MutationSetOrganizerNoteOnMatchArgs = {
  matchId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};


export type MutationSetPatronQuestionOnCartArgs = {
  cartId: Scalars['ID']['input'];
  isPatron: Scalars['Boolean']['input'];
};


export type MutationSetPoliciesOnCartArgs = {
  cartId: Scalars['ID']['input'];
  policies: Array<Scalars['ID']['input']>;
};


export type MutationSetProductForBookableItemCartItemArgs = {
  cartId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationSetProductForCartItemArgs = {
  cartId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationSetRequiredInformationOnCartArgs = {
  cartId: Scalars['ID']['input'];
  requiredInformation: RequiredInformationInput;
};


export type MutationSetUseBudgetOnCartArgs = {
  cartId: Scalars['ID']['input'];
  useBudget: Scalars['Boolean']['input'];
};


export type MutationSetUseCorporateBenefitsOnCartArgs = {
  cartId: Scalars['ID']['input'];
  useBenefits: Scalars['Boolean']['input'];
};


export type MutationSetVoucherOnCartArgs = {
  cartId: Scalars['ID']['input'];
  voucher?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetVoucherOnOrderArgs = {
  orderId: Scalars['ID']['input'];
  voucher?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetupRecurringPaymentMethodArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationShareEventArgs = {
  eventId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationShareFamilyMemberWithVenueArgs = {
  companyId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
};


export type MutationShareMatchArgs = {
  matchId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationShareVenueArgs = {
  userIds: Array<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
};


export type MutationStartGeneratingInvoiceDownloadLinkArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationStorePaymentMethodArgs = {
  pspId: Scalars['ID']['input'];
};


export type MutationSubscribeToNewsletterArgs = {
  customerId: Scalars['ID']['input'];
};


export type MutationTerminateMembershipArgs = {
  assignedMembershipId: Scalars['ID']['input'];
};


export type MutationTrackCheckoutCompleteArgs = {
  deviceId: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  sessionId: Scalars['Float']['input'];
  userTrackingId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTrackCheckoutStartArgs = {
  cartId: Scalars['ID']['input'];
  deviceId: Scalars['String']['input'];
  sessionId: Scalars['Float']['input'];
  userTrackingId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMatchArgs = {
  fields: MatchUpdateFields;
  matchId: Scalars['ID']['input'];
};


export type MutationUpdatePrivacySettingsArgs = {
  args: PrivacySettingsInput;
};


export type MutationUpdateSpotArgs = {
  participationId: Scalars['ID']['input'];
  spotId: Scalars['ID']['input'];
};


export type MutationUpdateStoredCreditCardArgs = {
  preferredNetwork: Scalars['String']['input'];
  pspId: Scalars['ID']['input'];
};


export type MutationVerifyEmailArgs = {
  token: Scalars['String']['input'];
};

export enum NetPromoterScoreChannel {
  CHANNEL_ANDROID = 'CHANNEL_ANDROID',
  CHANNEL_IOS = 'CHANNEL_IOS',
  CHANNEL_MARKETPLACE = 'CHANNEL_MARKETPLACE'
}

export type NextPaymentInfo = {
  __typename: 'NextPaymentInfo';
  date: Scalars['DateTime']['output'];
  price: MonetaryValue;
};

export type NonBookableItem = {
  __typename: 'NonBookableItem';
  createdAt: Scalars['DateTime']['output'];
  icon: NonBookableItemIconType;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export enum NonBookableItemIconType {
  ASSISTANT = 'ASSISTANT',
  DOOR = 'DOOR',
  HORIZONTAL_BAR = 'HORIZONTAL_BAR',
  MIRROR = 'MIRROR',
  SCREEN = 'SCREEN',
  SPEAKER = 'SPEAKER',
  TEACHER = 'TEACHER',
  TEACHER_AVATAR = 'TEACHER_AVATAR',
  TEXT = 'TEXT',
  VERTICAL_BAR = 'VERTICAL_BAR',
  WINDOW = 'WINDOW'
}

export type Notification = BaseNotification;

export type NotificationConnection = {
  __typename: 'NotificationConnection';
  edges: Array<NotificationEdge>;
  /** The actual "Notification" items */
  nodes: Array<Notification>;
  pageInfo: PageInfo;
};

export type NotificationEdge = {
  __typename: 'NotificationEdge';
  cursor: Scalars['Cursor']['output'];
  node: Notification;
};

export type NotificationIcon = NotificationIconImage | NotificationIconUser;

export type NotificationIconImage = {
  __typename: 'NotificationIconImage';
  image: Image;
};

export type NotificationIconUser = {
  __typename: 'NotificationIconUser';
  user: PublicUserV2;
};

export type NotificationInterface = {
  contentType: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  headerText: Maybe<Scalars['String']['output']>;
  icon: Maybe<NotificationIcon>;
  id: Scalars['ID']['output'];
  link: Maybe<NotificationLink>;
  seen: Scalars['Boolean']['output'];
  text: Maybe<Scalars['String']['output']>;
};

export type NotificationLink = NotificationLinkEvent | NotificationLinkEventSession | NotificationLinkMatch | NotificationLinkUrl | NotificationLinkUser | NotificationLinkVenue;

export type NotificationLinkEvent = {
  __typename: 'NotificationLinkEvent';
  event: EventBookableItem;
};

export type NotificationLinkEventSession = {
  __typename: 'NotificationLinkEventSession';
  bookableItem: EventBookableItem;
  event: NotificationLinkEventSessionEvent;
  eventSession: EventSession;
};

export type NotificationLinkEventSessionEvent = {
  __typename: 'NotificationLinkEventSessionEvent';
  eventType: EventType;
  id: Scalars['ID']['output'];
  shortId: Scalars['String']['output'];
};

export type NotificationLinkMatch = {
  __typename: 'NotificationLinkMatch';
  match: Match;
};

export type NotificationLinkUrl = {
  __typename: 'NotificationLinkUrl';
  url: Scalars['String']['output'];
};

export type NotificationLinkUser = {
  __typename: 'NotificationLinkUser';
  user: PublicUserV2;
};

export type NotificationLinkVenue = {
  __typename: 'NotificationLinkVenue';
  venue: Venue;
};

export type NumberAddOnField = {
  __typename: 'NumberAddOnField';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Maybe<MonetaryValue>;
};

export type OnlineStream = {
  __typename: 'OnlineStream';
  end: Scalars['DateTime']['output'];
  info: Maybe<OnlineStreamInfo>;
  isWithinStreamingTime: Scalars['Boolean']['output'];
  link: Maybe<Scalars['String']['output']>;
  provider: Maybe<OnlineStreamProvider>;
  start: Scalars['DateTime']['output'];
};

export type OnlineStreamInfo = {
  __typename: 'OnlineStreamInfo';
  externalMeetingPassword: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type OnlineStreamProvider = {
  __typename: 'OnlineStreamProvider';
  id: Scalars['Float']['output'];
  key: OnlineStreamProviderPlatform;
  priority: Scalars['Float']['output'];
  showGDPR: Scalars['Boolean']['output'];
};

/** Online stream provider platform names */
export enum OnlineStreamProviderPlatform {
  HANGOUT = 'HANGOUT',
  INSTAGRAM = 'INSTAGRAM',
  OTHER = 'OTHER',
  SKYPE = 'SKYPE',
  VIMEO = 'VIMEO',
  YOUTUBE = 'YOUTUBE',
  YOUTUBE_LIVE = 'YOUTUBE_LIVE',
  ZOOM = 'ZOOM'
}

export type OpenEndTimeRangeInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
};

export type OpenGraph = SocialInterface & {
  __typename: 'OpenGraph';
  description: Maybe<Scalars['String']['output']>;
  image: Image;
  siteName: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type OpenTimeRange = {
  __typename: 'OpenTimeRange';
  end: Maybe<Scalars['DateTime']['output']>;
  start: Maybe<Scalars['DateTime']['output']>;
};

export type Order = {
  __typename: 'Order';
  amount: MonetaryValue;
  appliedVoucher: Maybe<AppliedVoucher>;
  /** The latest point in time an `Order` can be confirmed. */
  confirmableUntil: Maybe<Scalars['DateTime']['output']>;
  /** The creation `Date` of an `Order`. Can be used together with `confirmableUntil` to calculate the remaining time of confirming an `Order` */
  createdAt: Scalars['DateTime']['output'];
  /** Returns the customer associated with the order */
  customer: Maybe<Customer>;
  id: Scalars['ID']['output'];
  invoice: Maybe<Invoice>;
  isConfirmable: Scalars['Boolean']['output'];
  isSelfCheckinAvailable: Scalars['Boolean']['output'];
  /** `True` if vouchers are enabled for this order, otherwise `false` */
  isVoucherEnabled: Scalars['Boolean']['output'];
  items: Array<OrderItem>;
  payment: Maybe<Payment>;
  priceTable: PriceTable;
  state: OrderState;
  venue: Venue;
};

export type OrderItem = AssignedProductOrderItem | BookingOrderItem | BookingRequestOrderItem;

export type OrderItemInterface = {
  confirmedWith: Maybe<ConfirmWithOption>;
  endPrice: Scalars['Float']['output'];
  purchasedWith: Maybe<PurchasedWith>;
  reduction: Scalars['Float']['output'];
};

export type OrderResponse = ExpectedErrors | Order;

export enum OrderState {
  ORDER_STATE_ABORTED = 'ORDER_STATE_ABORTED',
  ORDER_STATE_CONFIRMED = 'ORDER_STATE_CONFIRMED',
  ORDER_STATE_OPEN = 'ORDER_STATE_OPEN'
}

export enum Origin {
  ORIGIN_ANDROID = 'ORIGIN_ANDROID',
  ORIGIN_IOS = 'ORIGIN_IOS',
  ORIGIN_MARKETPLACE = 'ORIGIN_MARKETPLACE',
  ORIGIN_PROVIDER_API = 'ORIGIN_PROVIDER_API',
  ORIGIN_WIDGET = 'ORIGIN_WIDGET'
}

export type PageInfo = {
  __typename: 'PageInfo';
  /** The `Cursor` of the last item in this page. You can use it as the `after` input argument to retrieve the next page. */
  endCursor: Maybe<Scalars['Cursor']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The `Cursor` of the first item in this page. You can use it as the `before` input argument to retrieve the previous page. */
  startCursor: Maybe<Scalars['Cursor']['output']>;
};

export type PageLink = SportInCityPageLink;

export type PartialBillingInformation = {
  __typename: 'PartialBillingInformation';
  nextBillingStart: Scalars['DateTime']['output'];
  validUntil: Scalars['DateTime']['output'];
};

export type PartialPriceInformation = {
  __typename: 'PartialPriceInformation';
  price: MonetaryValue;
  timeRange: TimeRange;
};

export type Participation = EventSessionParticipation;

export type ParticipationConnection = {
  __typename: 'ParticipationConnection';
  edges: Array<ParticipationEdge>;
  /** The actual "Participation" items */
  nodes: Array<Participation>;
  pageInfo: PageInfo;
};

export type ParticipationEdge = {
  __typename: 'ParticipationEdge';
  cursor: Scalars['Cursor']['output'];
  node: Participation;
};

export type ParticipationInterface = {
  /** Friends of the logged in user who are participating */
  attendingFriends: Maybe<FriendConnection>;
  participationState: Maybe<ParticipationState>;
};


export type ParticipationInterfaceAttendingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum ParticipationState {
  PARTICIPATION_STATE_BOOKED = 'PARTICIPATION_STATE_BOOKED',
  PARTICIPATION_STATE_JOINED = 'PARTICIPATION_STATE_JOINED'
}

export enum PatronQuestionType {
  PATRON_QUESTION_TYPE_CHANNEL = 'PATRON_QUESTION_TYPE_CHANNEL',
  PATRON_QUESTION_TYPE_NONE = 'PATRON_QUESTION_TYPE_NONE',
  PATRON_QUESTION_TYPE_PAST_ATTENDANCE = 'PATRON_QUESTION_TYPE_PAST_ATTENDANCE'
}

export enum PatronageAnswer {
  PATRONAGE_ANSWER_EVERSPORTS = 'PATRONAGE_ANSWER_EVERSPORTS',
  PATRONAGE_ANSWER_VENUE_CHANNELS = 'PATRONAGE_ANSWER_VENUE_CHANNELS',
  PATRONAGE_ANSWER_VENUE_CUSTOMER = 'PATRONAGE_ANSWER_VENUE_CUSTOMER',
  PATRONAGE_ANSWER_VENUE_MEMBERS = 'PATRONAGE_ANSWER_VENUE_MEMBERS'
}

export type Payment = {
  __typename: 'Payment';
  canSetupRecurringPaymentMethod: Scalars['Boolean']['output'];
  customerSessionClientSecret: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastAttemptAt: Maybe<Scalars['DateTime']['output']>;
  /** An optional `Mandate` that is available for this `Payment` */
  mandate: Maybe<Mandate>;
  paymentIntent: Maybe<PaymentIntent>;
  paymentMethods: Array<PaymentMethod>;
  paymentSetupIntent: Maybe<PaymentSetupIntent>;
  state: PaymentState;
  /** Available `StoredPaymentMethod` for this `Payment` */
  storedPaymentMethods: Array<StoredPaymentMethod>;
  /** The `User`  that is charged for this `Payment` */
  user: User;
};

export type PaymentIntent = {
  __typename: 'PaymentIntent';
  amount: Scalars['Float']['output'];
  clientSecret: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type PaymentMethod = {
  __typename: 'PaymentMethod';
  name: Scalars['String']['output'];
  type: PaymentMethodType;
  /** @deprecated The verifyWith property is not used in the payment element anymore */
  verifyWith: Maybe<PaymentMethodVerificationMethod>;
};

export enum PaymentMethodType {
  PAYMENT_METHOD_BANCONTACT = 'PAYMENT_METHOD_BANCONTACT',
  PAYMENT_METHOD_BIZUM = 'PAYMENT_METHOD_BIZUM',
  PAYMENT_METHOD_CREDIT_CARD = 'PAYMENT_METHOD_CREDIT_CARD',
  PAYMENT_METHOD_EPS = 'PAYMENT_METHOD_EPS',
  PAYMENT_METHOD_GIROPAY = 'PAYMENT_METHOD_GIROPAY',
  PAYMENT_METHOD_IDEAL = 'PAYMENT_METHOD_IDEAL',
  PAYMENT_METHOD_MULTIBANCO = 'PAYMENT_METHOD_MULTIBANCO',
  PAYMENT_METHOD_PAYPAL = 'PAYMENT_METHOD_PAYPAL',
  PAYMENT_METHOD_SATISPAY = 'PAYMENT_METHOD_SATISPAY',
  PAYMENT_METHOD_SEPA_ONLINE = 'PAYMENT_METHOD_SEPA_ONLINE',
  PAYMENT_METHOD_SOFORT = 'PAYMENT_METHOD_SOFORT',
  PAYMENT_METHOD_TWINT = 'PAYMENT_METHOD_TWINT'
}

export enum PaymentMethodVerificationMethod {
  PAYMENT_METHOD_IDEAL = 'PAYMENT_METHOD_IDEAL',
  PAYMENT_METHOD_SOFORT = 'PAYMENT_METHOD_SOFORT'
}

export type PaymentPlan = {
  __typename: 'PaymentPlan';
  initial: Maybe<MonetaryValue>;
  interval: Interval;
  offset: Maybe<Scalars['Int']['output']>;
  promotion: Maybe<Promotion>;
  recurring: MonetaryValue;
};

export type PaymentResponseType = ExpectedErrors | Payment;

export enum PaymentServiceType {
  PAYMENT_SERVICE_BANCONTACT = 'PAYMENT_SERVICE_BANCONTACT',
  PAYMENT_SERVICE_BIZUM = 'PAYMENT_SERVICE_BIZUM',
  PAYMENT_SERVICE_CASH = 'PAYMENT_SERVICE_CASH',
  PAYMENT_SERVICE_CHEQUECARD = 'PAYMENT_SERVICE_CHEQUECARD',
  PAYMENT_SERVICE_CHEQUEVACANCE = 'PAYMENT_SERVICE_CHEQUEVACANCE',
  PAYMENT_SERVICE_CREDIT = 'PAYMENT_SERVICE_CREDIT',
  PAYMENT_SERVICE_CREDITCARD = 'PAYMENT_SERVICE_CREDITCARD',
  PAYMENT_SERVICE_CREDITCARD_OTC = 'PAYMENT_SERVICE_CREDITCARD_OTC',
  PAYMENT_SERVICE_DEBITCARD = 'PAYMENT_SERVICE_DEBITCARD',
  PAYMENT_SERVICE_EPS = 'PAYMENT_SERVICE_EPS',
  PAYMENT_SERVICE_GIROPAY = 'PAYMENT_SERVICE_GIROPAY',
  PAYMENT_SERVICE_IDEAL = 'PAYMENT_SERVICE_IDEAL',
  PAYMENT_SERVICE_MANUAL = 'PAYMENT_SERVICE_MANUAL',
  PAYMENT_SERVICE_MARKETINGDISCOUNT = 'PAYMENT_SERVICE_MARKETINGDISCOUNT',
  PAYMENT_SERVICE_PAYPAL = 'PAYMENT_SERVICE_PAYPAL',
  PAYMENT_SERVICE_SATISPAY = 'PAYMENT_SERVICE_SATISPAY',
  PAYMENT_SERVICE_SEPA = 'PAYMENT_SERVICE_SEPA',
  PAYMENT_SERVICE_SEPA_ONLINE = 'PAYMENT_SERVICE_SEPA_ONLINE',
  PAYMENT_SERVICE_SOFORT = 'PAYMENT_SERVICE_SOFORT',
  PAYMENT_SERVICE_TRANSFER = 'PAYMENT_SERVICE_TRANSFER',
  PAYMENT_SERVICE_TWINT = 'PAYMENT_SERVICE_TWINT',
  PAYMENT_SERVICE_TWINT_OTC = 'PAYMENT_SERVICE_TWINT_OTC',
  PAYMENT_SERVICE_VOUCHER = 'PAYMENT_SERVICE_VOUCHER',
  PAYMENT_SERVICE_VOUCHER_OTC = 'PAYMENT_SERVICE_VOUCHER_OTC'
}

export type PaymentSetupIntent = {
  __typename: 'PaymentSetupIntent';
  clientSecret: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paymentMethod: Maybe<StoredPaymentMethod>;
};

export enum PaymentState {
  PAYMENT_STATE_CANCELLED = 'PAYMENT_STATE_CANCELLED',
  PAYMENT_STATE_FAILED = 'PAYMENT_STATE_FAILED',
  PAYMENT_STATE_IN_PROGRESS = 'PAYMENT_STATE_IN_PROGRESS',
  PAYMENT_STATE_ON_HOLD = 'PAYMENT_STATE_ON_HOLD',
  PAYMENT_STATE_OPEN = 'PAYMENT_STATE_OPEN',
  PAYMENT_STATE_SUCCEEDED = 'PAYMENT_STATE_SUCCEEDED'
}

export enum PeriodStartType {
  VALIDITY_START_TYPE_DATE = 'VALIDITY_START_TYPE_DATE',
  VALIDITY_START_TYPE_FIRST_BOOKING = 'VALIDITY_START_TYPE_FIRST_BOOKING',
  VALIDITY_START_TYPE_PURCHASE_DATE = 'VALIDITY_START_TYPE_PURCHASE_DATE'
}

export enum Platform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  IOS_SANDBOX = 'IOS_SANDBOX'
}

export type Policy = {
  __typename: 'Policy';
  id: Scalars['ID']['output'];
  isUpdate: Scalars['Boolean']['output'];
  mandatory: Scalars['Boolean']['output'];
  type: PolicyType;
  url: Scalars['String']['output'];
  validFrom: Scalars['DateTime']['output'];
};

/** Policies can be either terms of service, or privacy policies */
export enum PolicyType {
  POLICY_TYPE_PRIVACY = 'POLICY_TYPE_PRIVACY',
  POLICY_TYPE_TERMS_OF_SERVICE = 'POLICY_TYPE_TERMS_OF_SERVICE'
}

export type PriceTable = {
  __typename: 'PriceTable';
  /** @deprecated For handling Corporate Budgets and Special Prices correctly please switch to `itemsV3` which features a specific type for Corporate Budget */
  items: Array<PriceTableItem>;
  /** @deprecated For handling Special Prices correctly please switch to `itemsV3` which features a specific type for Special Prices */
  itemsV2: Array<PriceTableItemV2>;
  itemsV3: Array<PriceTableItemV3>;
  /**
   *
   * If the price table has any items which reduces the price (discounts, vouchers, special-offers),
   * the original price, without any reductions, will be shown here.
   * If no reduction is present this will be null
   */
  originalPrice: Maybe<MonetaryValue>;
  total: Maybe<MonetaryValue>;
};

export type PriceTableItem = PriceTableItemAddon | PriceTableItemBasic | PriceTableItemMembership | PriceTableItemVoucher;

/** This item represents a addon priceTableItem */
export type PriceTableItemAddon = PriceTableItemInterface & {
  __typename: 'PriceTableItemAddon';
  /** The number of items */
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

/** This item represents a basic priceTableItem, currently this is used for: CourtBooking and EventBooking */
export type PriceTableItemBasic = PriceTableItemInterface & {
  __typename: 'PriceTableItemBasic';
  /** The number of items */
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

/** The corporate budget applied on this cart */
export type PriceTableItemBudget = PriceTableItemInterface & {
  __typename: 'PriceTableItemBudget';
  /** The number of items */
  amount: Scalars['Float']['output'];
  /** The name of the Corporate Budget */
  budgetName: Scalars['String']['output'];
  /** The name of the Corporate providing the Budget */
  corporateName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

export type PriceTableItemInterface = {
  /** The number of items */
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

/** This item represents a price table item for a membership */
export type PriceTableItemMembership = PriceTableItemInterface & {
  __typename: 'PriceTableItemMembership';
  /** The number of items */
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** The time range of the current membership-period if we have a partial price. If no partial price is present this will be null */
  partialPriceTimeRange: Maybe<TimeRange>;
  paymentInterval: Maybe<Interval>;
  promotion: Maybe<Promotion>;
  /** The recurring price of the membership which the user has to pay each membership-period */
  recurringPrice: MonetaryValue;
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

/** This item represents a reduction due to a special price, currently this is used for corporate prices */
export type PriceTableItemSpecialPrice = PriceTableItemInterface & {
  __typename: 'PriceTableItemSpecialPrice';
  /** The number of items */
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  specialPriceType: SpecialPriceType;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

export type PriceTableItemV2 = PriceTableItemAddon | PriceTableItemBasic | PriceTableItemBudget | PriceTableItemMembership | PriceTableItemVoucher;

export type PriceTableItemV3 = PriceTableItemAddon | PriceTableItemBasic | PriceTableItemBudget | PriceTableItemMembership | PriceTableItemSpecialPrice | PriceTableItemVoucher;

export type PriceTableItemVoucher = PriceTableItemInterface & {
  __typename: 'PriceTableItemVoucher';
  /** The number of items */
  amount: Scalars['Float']['output'];
  /** The voucher-code the user applied to the cart/order */
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

export type PrivacySetting = {
  __typename: 'PrivacySetting';
  field: PrivacySettingField;
  visibility: PrivacySettingVisibility;
};

export enum PrivacySettingField {
  FAVORITE_VENUES = 'FAVORITE_VENUES',
  FRIENDS = 'FRIENDS',
  FRIENDS_COUNT = 'FRIENDS_COUNT',
  PROFILE = 'PROFILE',
  SPOT_BOOKING = 'SPOT_BOOKING',
  UPCOMING_BOOKINGS = 'UPCOMING_BOOKINGS'
}

export type PrivacySettingFieldInput = {
  field: PrivacySettingField;
  visibility: PrivacySettingVisibility;
};

export enum PrivacySettingVisibility {
  FRIEND = 'FRIEND',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type PrivacySettingsInput = {
  fieldInputs: Array<PrivacySettingFieldInput>;
};

export type PrivateFeedback = {
  __typename: 'PrivateFeedback';
  id: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  text: Maybe<Scalars['String']['output']>;
  venue: Venue;
};

export type PrivateFeedbackResponse = ExpectedErrors | PrivateFeedback;

export type PrivateMatchOrganizer = MatchOrganizerInterface & UserInterface & {
  __typename: 'PrivateMatchOrganizer';
  bio: Maybe<Scalars['String']['output']>;
  customer: Maybe<Customer>;
  firstName: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  profilePicture: Maybe<Image>;
};

export type PrivateMatchVisibilityValidation = MatchVisibilityValidationInterface & {
  __typename: 'PrivateMatchVisibilityValidation';
  missingFields: Array<MatchMissingField>;
  requiredFields: Array<MatchMissingField>;
};

export type ProductCartItem = CartItemInterface & {
  __typename: 'ProductCartItem';
  appliedBudget: Maybe<AppliedBudget>;
  appliedVoucher: Maybe<AppliedVoucher>;
  confirmWithOptions: Array<ConfirmWithOption>;
  id: Scalars['ID']['output'];
  product: ShopProduct;
  purchaseOptions: Array<PurchaseOption>;
  settleWith: Maybe<SettlementOption>;
};

export type ProductInterface = {
  id: Scalars['ID']['output'];
  productPurchaseInformation: ProductPurchaseInformation;
};

export type ProductPurchaseInformation = {
  __typename: 'ProductPurchaseInformation';
  additionalInformation: Maybe<Scalars['String']['output']>;
  checkoutURL: Maybe<Scalars['URL']['output']>;
  isPurchasableOnline: Scalars['Boolean']['output'];
  purchasable: Scalars['Boolean']['output'];
};


export type ProductPurchaseInformationCheckoutUrlArgs = {
  origin: Origin;
  returnTo?: InputMaybe<Scalars['URL']['input']>;
  venueId: Scalars['ID']['input'];
};

export type Promotion = {
  __typename: 'Promotion';
  period: Interval;
  price: MonetaryValue;
};

export type PublicCourtBooking = BookingInterface & ParticipationInterface & {
  __typename: 'PublicCourtBooking';
  /** Friends of the logged in user who are participating */
  attendingFriends: Maybe<FriendConnection>;
  bookableItem: CourtBookableItem;
  confirmedWith: Maybe<ConfirmWithOption>;
  court: Court;
  id: Scalars['ID']['output'];
  participationState: Maybe<ParticipationState>;
  purchasedWith: Maybe<PurchasedWith>;
  state: CourtBookingState;
  timeRange: TimeRange;
};


export type PublicCourtBookingAttendingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A user's participation in a single event session. Corresponds to an `AppointmentParticipation` in the underlying data model. */
export type PublicEventSessionParticipation = ParticipationInterface & {
  __typename: 'PublicEventSessionParticipation';
  /** Friends of the logged in user who are participating */
  attendingFriends: Maybe<FriendConnection>;
  /** return the full bookableItem, including all session of the bookable item, not just the ones included in the booking. */
  bookableItem: EventBookableItem;
  id: Scalars['ID']['output'];
  /** Whether the session was cancelled by the venue */
  isSessionCancelled: Maybe<Scalars['Boolean']['output']>;
  participationState: Maybe<ParticipationState>;
  session: EventSession;
  timeRange: TimeRange;
};


/** A user's participation in a single event session. Corresponds to an `AppointmentParticipation` in the underlying data model. */
export type PublicEventSessionParticipationAttendingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicMatchOrganizer = MatchOrganizerInterface & UserInterface & {
  __typename: 'PublicMatchOrganizer';
  bio: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  profilePicture: Maybe<Image>;
};

export type PublicMatchVisibilityValidation = MatchVisibilityValidationInterface & {
  __typename: 'PublicMatchVisibilityValidation';
  missingFields: Array<MatchMissingField>;
  requiredFields: Array<MatchMissingField>;
};

export type PublicParticipation = PublicCourtBooking | PublicEventSessionParticipation;

export type PublicParticipationConnection = {
  __typename: 'PublicParticipationConnection';
  edges: Array<PublicParticipationEdge>;
  /** The actual "PublicParticipation" items */
  nodes: Array<PublicParticipation>;
  pageInfo: PageInfo;
};

export type PublicParticipationEdge = {
  __typename: 'PublicParticipationEdge';
  cursor: Scalars['Cursor']['output'];
  node: PublicParticipation;
};

export type PublicParticipationV2 = BallsportMatch | PublicCourtBooking | PublicEventSessionParticipation;

export type PublicParticipationV2Connection = {
  __typename: 'PublicParticipationV2Connection';
  edges: Array<PublicParticipationV2Edge>;
  /** The actual "PublicParticipationV2" items */
  nodes: Array<PublicParticipationV2>;
  pageInfo: PageInfo;
};

export type PublicParticipationV2Edge = {
  __typename: 'PublicParticipationV2Edge';
  cursor: Scalars['Cursor']['output'];
  node: PublicParticipationV2;
};

/** Deprecated in favor of PublicUserV2 */
export type PublicUser = {
  __typename: 'PublicUser';
  name: Scalars['String']['output'];
};

/** Use this type if you want to resolve a user in public queries */
export type PublicUserV2 = UserInterface & {
  __typename: 'PublicUserV2';
  bio: Maybe<Scalars['String']['output']>;
  /** Returns the number of common activities in the last numberOfDays */
  commonActivitiesCount: Maybe<Scalars['Int']['output']>;
  commonFriendsCount: Maybe<Scalars['Int']['output']>;
  /** Returns `null` if the requester is not allowed to see this information according to the privacy settings of the data owner. */
  favouriteVenues: Maybe<FavoriteVenueConnection>;
  firstName: Scalars['String']['output'];
  friends: Maybe<FriendConnection>;
  friendsCount: Maybe<Scalars['Int']['output']>;
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  /** Defines if the public user is a friend of the currently authenticated user */
  isYourFriend: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  pendingFriendRequest: Maybe<FriendRequest>;
  profilePicture: Maybe<Image>;
  /** Returns `null` if the requester is not allowed to see this information according to the privacy settings of the data owner. */
  sportExperience: Maybe<Array<SportExperience>>;
  /** Returns `null` if the requester is not allowed to see this information according to the privacy settings of the data owner. */
  statistics: Maybe<UserStatistics>;
  /**
   * Returns `null` if the requester is not allowed to see this information according to the privacy settings of the data owner.
   * @deprecated Use `upcomingParticipationsV2` instead to include matches
   */
  upcomingParticipations: Maybe<PublicParticipationConnection>;
  /** Returns `null` if the requester is not allowed to see this information according to the privacy settings of the data owner. */
  upcomingParticipationsV2: Maybe<PublicParticipationV2Connection>;
};


/** Use this type if you want to resolve a user in public queries */
export type PublicUserV2FavouriteVenuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Use this type if you want to resolve a user in public queries */
export type PublicUserV2FriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Use this type if you want to resolve a user in public queries */
export type PublicUserV2UpcomingParticipationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Use this type if you want to resolve a user in public queries */
export type PublicUserV2UpcomingParticipationsV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicUserV2Connection = {
  __typename: 'PublicUserV2Connection';
  edges: Array<PublicUserV2Edge>;
  /** The actual "PublicUserV2" items */
  nodes: Array<PublicUserV2>;
  pageInfo: PageInfo;
};

export type PublicUserV2Edge = {
  __typename: 'PublicUserV2Edge';
  cursor: Scalars['Cursor']['output'];
  node: PublicUserV2;
};

/** Options to purchase a cart. This can either be a `Product` or a direct payment (Ticket, SinglePurchase) */
export type PurchaseOption = Card | Membership | SinglePurchase | Ticket;

/** Single purchase of an item without using an existing product */
export type PurchasedWith = SinglePurchase | Ticket;

export type PushNotificationEndpoint = BrandedPushNotificationEndpoint | EversportsPushNotificationEndpoint;

export type Query = {
  __typename: 'Query';
  assignedProduct: AssignedProductsForUserProfileType;
  /** Returns an assigned recording by its id. */
  assignedRecording: AssignedRecording;
  /** Provides a list of assigned recordings. */
  assignedRecordings: AssignedRecordingConnection;
  cart: Cart;
  city: City;
  citySearch: Array<CitySearchResult>;
  company: Company;
  corporateInvitation: CorporateInvitationData;
  /** This will return the CorporatePartner details for the given Company ID. */
  corporatePartner: CorporatePartner;
  countries: Array<Country>;
  discoverContextByCity: DiscoverContextForCity;
  discoverContextByCityAndSportSlug: DiscoverContextForCityAndSport;
  /** This context query is used by the mobile clients instead of discoverContextByCity */
  discoverContextByCoordinate: DiscoverCoordinateContext;
  discoverMatchContext: DiscoverMatchContext;
  featurePreviews: Array<FeaturePreview>;
  /** Retrieve an EventBookableItem by its id. */
  getEventBookableItem: EventBookableItem;
  /** Get the marketplace fee created by a certain order */
  getMarketplaceFeeForOrder: Maybe<MonetaryValue>;
  inventorySearch: Array<InventorySearchResult>;
  invitation: Invitation;
  /** Get a single invoice by its ID */
  invoice: Invoice;
  latestEversportsPolicies: Array<Policy>;
  match: Match;
  /** Find public matches. Currently only future matches, sorted by start asc */
  matches: BallsportMatchConnection;
  me: Maybe<User>;
  /** Allows users to search for fellow members of a club. This is mostly used for Tennis Clubs, where members provide the information with whom they are playing upon reservation of a court */
  multiPlayerSearch: MultiPlayerUser;
  order: Order;
  popularCities: Array<City>;
  privateSessionOfferAvailabilitySlots: Array<Scalars['DateOutput']['output']>;
  product: ShopProduct;
  products: Array<ShopProduct>;
  publicUser: PublicUserV2;
  /** Returns a list of random page links */
  randomPageLinks: Array<PageLink>;
  recap: Recap;
  /** Returns a recording by its id. */
  recording: Recording;
  /** Provides a search for recording categories. */
  recordingCategories: RecordingCategoryConnection;
  /** Returns a recording category by its id. */
  recordingCategory: RecordingCategory;
  /** Provides a search for recordings. */
  recordings: RecordingConnection;
  /** Returns a sport by its id. */
  sport: Sport;
  /** Returns a sport by its slug. */
  sportBySlug: Sport;
  /** Provides a search for sports. */
  sports: SportConnection;
  syncContacts: Array<SyncContactsResponse>;
  /** Paginated version of syncContacts query */
  syncContactsV2: SyncContactsResponseV2Connection;
  userSearch: Array<PublicUserV2>;
  venue: Venue;
  venueContext: VenueContext;
  venueSearch: VenueConnection;
};


export type QueryAssignedProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssignedRecordingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssignedRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCityArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCitySearchArgs = {
  coordinate?: InputMaybe<CoordinateArgs>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCorporateInvitationArgs = {
  corporatePartnerId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCorporatePartnerArgs = {
  corporatePartnerId: Scalars['ID']['input'];
};


export type QueryDiscoverContextByCityArgs = {
  citySlug: Scalars['String']['input'];
};


export type QueryDiscoverContextByCityAndSportSlugArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  coordinate?: InputMaybe<CoordinateArgs>;
  sportSlug: Scalars['String']['input'];
};


export type QueryDiscoverContextByCoordinateArgs = {
  coordinate: CoordinateArgs;
};


export type QueryDiscoverMatchContextArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  coordinate?: InputMaybe<CoordinateArgs>;
  sportSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeaturePreviewsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetEventBookableItemArgs = {
  eventType?: InputMaybe<EventType>;
  id?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMarketplaceFeeForOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryInventorySearchArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  coordinate: CoordinateArgs;
  limit?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvitationArgs = {
  invitationId: Scalars['ID']['input'];
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchArgs = {
  matchId: Scalars['ID']['input'];
};


export type QueryMatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filters: MatchFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMultiPlayerSearchArgs = {
  cartId: Scalars['ID']['input'];
  search: Scalars['ID']['input'];
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPopularCitiesArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryPrivateSessionOfferAvailabilitySlotsArgs = {
  privateSessionOfferId: Scalars['ID']['input'];
  timeRange: TimeRangeInput;
  trainerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  venueId: Scalars['ID']['input'];
};


export type QueryPublicUserArgs = {
  handle: Scalars['String']['input'];
};


export type QueryRandomPageLinksArgs = {
  count?: Scalars['Int']['input'];
};


export type QueryRecapArgs = {
  args: RecapArgs;
};


export type QueryRecordingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecordingCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueId: Scalars['ID']['input'];
};


export type QueryRecordingCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sportId?: InputMaybe<Scalars['ID']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySportArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySportBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueId: Scalars['ID']['input'];
};


export type QuerySyncContactsArgs = {
  telephoneNumbers: Array<Scalars['String']['input']>;
};


export type QuerySyncContactsV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  telephoneNumbers: Array<Scalars['String']['input']>;
};


export type QueryUserSearchArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVenueArgs = {
  venueId?: InputMaybe<Scalars['ID']['input']>;
  venueSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVenueContextArgs = {
  slug: Scalars['String']['input'];
};


export type QueryVenueSearchArgs = {
  city?: InputMaybe<Scalars['ID']['input']>;
  filters: VenueFilters;
  sort?: InputMaybe<VenueSearchSort>;
  userLocation?: InputMaybe<CoordinateArgs>;
};

export type Rating = {
  __typename: 'Rating';
  type: RatingType;
  value: Scalars['Float']['output'];
};

export enum RatingType {
  ATMOSPHERE = 'ATMOSPHERE',
  CLEANLINESS = 'CLEANLINESS',
  FRIENDLINESS_SERVICE = 'FRIENDLINESS_SERVICE',
  PRICE_PERFORMANCE = 'PRICE_PERFORMANCE',
  ROOM_QUALITY = 'ROOM_QUALITY'
}

export type Recap = {
  __typename: 'Recap';
  activeDays: Scalars['Int']['output'];
  activitiesPerMonth: Array<RecapMonth>;
  friends: Array<RecapFriends>;
  from: Scalars['DateTime']['output'];
  longestStreak: LongestStreak;
  minutesActive: Scalars['Int']['output'];
  sports: Array<RecapSport>;
  sportsCount: Scalars['Int']['output'];
  to: Scalars['DateTime']['output'];
  totalBookings: Scalars['Int']['output'];
  trainers: Array<RecapTrainer>;
  user: PublicUserV2;
  venues: Array<RecapVenue>;
  venuesCount: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};


export type RecapFriendsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type RecapSportsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type RecapTrainersArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type RecapVenuesArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type RecapArgs = {
  token: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type RecapFriends = {
  __typename: 'RecapFriends';
  friend: Friend;
  numberOfCommonActivities: Scalars['Int']['output'];
};

export type RecapMonth = {
  __typename: 'RecapMonth';
  /** Number of activities per sport in this month */
  activitiesPerSport: Array<ActivitiesPerSport>;
  activityCount: Scalars['Int']['output'];
  /** @deprecated Use activityCount instead */
  bookingCount: Scalars['Int']['output'];
  /** Month of the year, starting with 1 for January */
  month: Scalars['Float']['output'];
  /** Distinct sports practiced in this month */
  practicedSports: Array<Sport>;
  /** Distinct venues visited in this month */
  visitedVenues: Array<Venue>;
};

export type RecapSport = {
  __typename: 'RecapSport';
  activityCount: Scalars['Int']['output'];
  /** @deprecated Use activityCount instead */
  bookingCount: Scalars['Int']['output'];
  sport: Sport;
};

export type RecapTrainer = {
  __typename: 'RecapTrainer';
  activityCount: Scalars['Int']['output'];
  trainer: Trainer;
};

export type RecapVenue = {
  __typename: 'RecapVenue';
  activityCount: Scalars['Int']['output'];
  /** @deprecated Use activityCount instead */
  bookingCount: Scalars['Int']['output'];
  venue: Venue;
};

export type Recommendation = {
  __typename: 'Recommendation';
  recentTrainers: TrainerConnection;
  venuesWithTrialCards: VenueConnection;
};


export type RecommendationRecentTrainersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RecommendationVenuesWithTrialCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Recording = {
  __typename: 'Recording';
  assignedProducts: Array<AssignedBookingProduct>;
  assignedRecordings: Array<AssignedRecording>;
  /**
   * Nullable, `null` means it will be available indefinitely
   * @deprecated Deprecated, use the field validityV2 instead
   */
  availableUntil: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  duration: Maybe<Scalars['Float']['output']>;
  hasUserBoughtProduct: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Image>;
  language: Maybe<Scalars['String']['output']>;
  level: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated The price of a recording is not mandatory anymore. Use the `SinglePurchase` type of the purchaseOptions instead */
  price: MonetaryValue;
  purchaseOptions: Array<PurchaseOption>;
  recordingEndDate: Maybe<Scalars['DateTime']['output']>;
  recordingStartDate: Maybe<Scalars['DateTime']['output']>;
  sport: Sport;
  trainer: Maybe<Trainer>;
  validityV2: Maybe<RecordingValidity>;
  venue: Venue;
};


export type RecordingAssignedProductsArgs = {
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingCategory = {
  __typename: 'RecordingCategory';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  recordings: RecordingConnection;
};


export type RecordingCategoryRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordingCategoryConnection = {
  __typename: 'RecordingCategoryConnection';
  edges: Array<RecordingCategoryEdge>;
  /** The actual "RecordingCategory" items */
  nodes: Array<RecordingCategory>;
  pageInfo: PageInfo;
};

export type RecordingCategoryEdge = {
  __typename: 'RecordingCategoryEdge';
  cursor: Scalars['Cursor']['output'];
  node: RecordingCategory;
};

export type RecordingConnection = {
  __typename: 'RecordingConnection';
  edges: Array<RecordingEdge>;
  /** The actual "Recording" items */
  nodes: Array<Recording>;
  pageInfo: PageInfo;
};

export type RecordingEdge = {
  __typename: 'RecordingEdge';
  cursor: Scalars['Cursor']['output'];
  node: Recording;
};

export type RecordingValidity = TimePeriod | TimeRange;

export type RegistrationProfileInput = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type RegistrationSettingsInput = {
  subscribeToEversportsNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RegistrationSource {
  REGISTRATION_SOURCE_EXISTING_USER = 'REGISTRATION_SOURCE_EXISTING_USER',
  REGISTRATION_SOURCE_NEW_USER_VIA_APPLE = 'REGISTRATION_SOURCE_NEW_USER_VIA_APPLE',
  REGISTRATION_SOURCE_NEW_USER_VIA_CREDENTIALS = 'REGISTRATION_SOURCE_NEW_USER_VIA_CREDENTIALS',
  REGISTRATION_SOURCE_NEW_USER_VIA_FACEBOOK = 'REGISTRATION_SOURCE_NEW_USER_VIA_FACEBOOK',
  REGISTRATION_SOURCE_NEW_USER_VIA_GOOGLE = 'REGISTRATION_SOURCE_NEW_USER_VIA_GOOGLE',
  REGISTRATION_SOURCE_NEW_USER_VIA_INVITATION = 'REGISTRATION_SOURCE_NEW_USER_VIA_INVITATION'
}

export type RemoveFromWaitingListResponse = ExpectedErrors | WaitingList;

export type RemoveParticipantsFromMatchV2 = BallsportMatch | ExpectedErrors;

export type Renewal = {
  __typename: 'Renewal';
  cancellation: Interval;
  interval: Interval;
};

export type Repeating = {
  __typename: 'Repeating';
  interval: Interval;
  isTransferable: Scalars['Boolean']['output'];
};

export type RequestVerificationResponse = ExpectedErrors | RequestVerificationResult;

export type RequestVerificationResult = {
  __typename: 'RequestVerificationResult';
  /** ONLY DEV: This is needed for e2e tests and convenient for local development */
  activationLink: Maybe<Scalars['String']['output']>;
};

export type RequiredInformation = {
  __typename: 'RequiredInformation';
  address: Maybe<Location>;
  birthday: Maybe<Scalars['Date']['output']>;
  fiscalCode: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
};

export type RequiredInformationInput = {
  address?: InputMaybe<LocationInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum RequiredInformationType {
  REQUIRED_INFORMATION_TYPE_ADDRESS = 'REQUIRED_INFORMATION_TYPE_ADDRESS',
  REQUIRED_INFORMATION_TYPE_BIRTHDAY = 'REQUIRED_INFORMATION_TYPE_BIRTHDAY',
  REQUIRED_INFORMATION_TYPE_FISCAL_CODE = 'REQUIRED_INFORMATION_TYPE_FISCAL_CODE',
  REQUIRED_INFORMATION_TYPE_PHONE_NUMBER = 'REQUIRED_INFORMATION_TYPE_PHONE_NUMBER'
}

export type ResetPasswordResponse = ExpectedErrors | ResetPasswordResult;

export type ResetPasswordResult = {
  __typename: 'ResetPasswordResult';
  /** ONLY DEV: This is needed for e2e tests and convenient for local development */
  activationLink: Maybe<Scalars['String']['output']>;
};

export type Review = {
  __typename: 'Review';
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  user: User;
};

export type ReviewConnection = {
  __typename: 'ReviewConnection';
  edges: Array<ReviewEdge>;
  /** The actual "Review" items */
  nodes: Array<Review>;
  pageInfo: PageInfo;
};

export type ReviewEdge = {
  __typename: 'ReviewEdge';
  cursor: Scalars['Cursor']['output'];
  node: Review;
};

export type Runtime = {
  __typename: 'Runtime';
  initial: Interval;
  pausable: Scalars['Boolean']['output'];
  renewal: Maybe<Renewal>;
};

export type SearchResult = {
  id: Scalars['ID']['output'];
  matchedName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secondaryMatch: Maybe<Scalars['String']['output']>;
};

export type Section = {
  __typename: 'Section';
  heading: Scalars['String']['output'];
  paragraph: Scalars['String']['output'];
};

export type SelectAddOnField = {
  __typename: 'SelectAddOnField';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  options: Array<SelectAddOnFieldOption>;
  selectionType: SelectAddOnFieldSelectionType;
};

export type SelectAddOnFieldOption = {
  __typename: 'SelectAddOnFieldOption';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Maybe<MonetaryValue>;
};

/** Defines whether one or multiple options can be selected. */
export enum SelectAddOnFieldSelectionType {
  SELECTION_TYPE_MULTI = 'SELECTION_TYPE_MULTI',
  SELECTION_TYPE_SINGLE = 'SELECTION_TYPE_SINGLE'
}

export type SelfCheckIn = {
  __typename: 'SelfCheckIn';
  color: Maybe<Scalars['String']['output']>;
  isCheckedIn: Scalars['Boolean']['output'];
  isOpen: Scalars['Boolean']['output'];
  start: Scalars['DateTime']['output'];
};

export type SessionComment = {
  __typename: 'SessionComment';
  comment: FormattedText;
  title: Scalars['String']['output'];
};

/**
 * A settlement option is an option which a user can use during the checkout.
 * It can either be a purchasable product, an assigned product, a ticket or single ticket
 */
export type SettlementOption = AssignedCard | AssignedMembership | Card | GenericAssignedProduct | Membership | SinglePurchase | Ticket;

/** Products that a user can buy in the shop, without booking something */
export type ShopProduct = Card | Membership | Recording | Voucher;

/** Single Booking is a kind of a product used to indicate the user only wants to purchase this 1 booking, without buying a membership or blockcard */
export type SinglePurchase = {
  __typename: 'SinglePurchase';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: MonetaryValue;
  productPurchaseInformation: ProductPurchaseInformation;
};

export type Slot = {
  __typename: 'Slot';
  end: Scalars['DateTime']['output'];
  isAvailable: Scalars['Boolean']['output'];
  start: Scalars['DateTime']['output'];
};

export type SlotToDiscoverFilter = {
  courtAreas?: InputMaybe<Array<CourtAreaType>>;
  courtAvailability: CourtAvailability;
  courtSurfaces?: InputMaybe<Array<CourtSurfaceType>>;
  sport: Scalars['ID']['input'];
};

export type Social = {
  __typename: 'Social';
  openGraph: OpenGraph;
  twitter: Twitter;
};

export type SocialInterface = {
  description: Maybe<Scalars['String']['output']>;
  image: Image;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SpecialPrice = {
  __typename: 'SpecialPrice';
  /** The single price for this item */
  price: Maybe<MonetaryValue>;
  type: SpecialPriceType;
};

export enum SpecialPriceType {
  CORPORATE_EMPLOYEES = 'CORPORATE_EMPLOYEES'
}

export type Sport = {
  __typename: 'Sport';
  category: SportCategory;
  children: Array<Sport>;
  courtTermPlural: Scalars['String']['output'];
  courtTermSingular: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parents: Array<Sport>;
  recordings: RecordingConnection;
  slug: Scalars['String']['output'];
};


export type SportChildrenArgs = {
  showInDiscover?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SportParentsArgs = {
  showInDiscover?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SportRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueId: Scalars['ID']['input'];
};

export enum SportCategory {
  BALLSPORT = 'BALLSPORT',
  FITNESS = 'FITNESS',
  FUNSPORT = 'FUNSPORT'
}

export type SportConnection = {
  __typename: 'SportConnection';
  edges: Array<SportEdge>;
  /** The actual "Sport" items */
  nodes: Array<Sport>;
  pageInfo: PageInfo;
};

export type SportEdge = {
  __typename: 'SportEdge';
  cursor: Scalars['Cursor']['output'];
  node: Sport;
};

export type SportExperience = {
  __typename: 'SportExperience';
  level: SportExperienceLevel;
  sport: Maybe<Sport>;
};

export enum SportExperienceLevel {
  ADVANCED = 'ADVANCED',
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE'
}

/** Everything needed to render a link to a "Sport in City" page */
export type SportInCityPageLink = {
  __typename: 'SportInCityPageLink';
  /** Parameters for  "Sport in City" page link text */
  linkParams: SportInCityPageLinkParams;
  /** URL to the "Sport in City" page */
  linkUrl: Scalars['String']['output'];
};

/** Parameters for city in sport page link text */
export type SportInCityPageLinkParams = {
  __typename: 'SportInCityPageLinkParams';
  /**
   * City name as stored in the DB. Probably in german.
   * @deprecated Use citySlug instead if possible
   */
  cityName: Scalars['String']['output'];
  /** City slug to be used as part of a translation key */
  citySlug: Scalars['String']['output'];
  /**
   * Sport name as stored in the DB. Probably in german.
   * @deprecated Use sportSlug instead if possible
   */
  sportName: Scalars['String']['output'];
  /** Sport slug to be used as part of a translation key */
  sportSlug: Scalars['String']['output'];
};

export type SportSearchResult = SearchResult & {
  __typename: 'SportSearchResult';
  cityId: Scalars['ID']['output'];
  cityName: Scalars['String']['output'];
  citySlug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  matchedName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secondaryMatch: Maybe<Scalars['String']['output']>;
  sportId: Scalars['ID']['output'];
  sportSlug: Scalars['String']['output'];
};

export type Spot = {
  __typename: 'Spot';
  createdAt: Scalars['DateTime']['output'];
  friend: Maybe<Friend>;
  icon: Maybe<BookableSpotIconType>;
  id: Scalars['ID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isBooked: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type SpotLimit = LimitedSpots | UnlimitedSpots;

export type StoredBankAccount = StoredPaymentMethodInterface & {
  __typename: 'StoredBankAccount';
  bankCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isUsedForRecurringPayment: Scalars['Boolean']['output'];
  last4: Scalars['String']['output'];
  mandates: Array<Mandate>;
  /** @deprecated Deprecated in favor of `paymentMethod.name` */
  name: Scalars['String']['output'];
  paymentMethod: PaymentMethod;
  /** A `PaymentMethod` identifier used for external payment providers. */
  pspId: Scalars['ID']['output'];
};

export type StoredCreditCard = StoredPaymentMethodInterface & {
  __typename: 'StoredCreditCard';
  /** List of available networks for the credit card */
  availableNetworks: Maybe<Array<Scalars['String']['output']>>;
  brand: Scalars['String']['output'];
  expirationMonth: Scalars['Float']['output'];
  expirationYear: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isUsedForRecurringPayment: Scalars['Boolean']['output'];
  last4: Scalars['String']['output'];
  /** @deprecated Deprecated in favor of `paymentMethod.name` */
  name: Scalars['String']['output'];
  paymentMethod: PaymentMethod;
  preferredNetwork: Maybe<Scalars['String']['output']>;
  /** A `PaymentMethod` identifier used for external payment providers. */
  pspId: Scalars['ID']['output'];
};

/** A payment method that is attached to a customer and can be used to fulfill payments. */
export type StoredPaymentMethod = StoredBankAccount | StoredCreditCard;

export type StoredPaymentMethodInterface = {
  id: Scalars['ID']['output'];
  isUsedForRecurringPayment: Scalars['Boolean']['output'];
  /** @deprecated Deprecated in favor of `paymentMethod.name` */
  name: Scalars['String']['output'];
  paymentMethod: PaymentMethod;
  /** A `PaymentMethod` identifier used for external payment providers. */
  pspId: Scalars['ID']['output'];
};

export type StoredPaymentMethodResponse = ExpectedErrors | StoredBankAccount | StoredCreditCard;

export enum SuggestedType {
  COMMON_ACTIVITIES = 'COMMON_ACTIVITIES',
  COMMON_FRIENDS = 'COMMON_FRIENDS'
}

export enum Surface {
  ARTIFICIALGRASS = 'ArtificialGrass',
  ARTIFICIALICE = 'ArtificialIce',
  ASH = 'Ash',
  ASPHALT = 'Asphalt',
  CARPET = 'Carpet',
  CARPETGRANULE = 'CarpetGranule',
  CONCRETE = 'Concrete',
  FELT = 'Felt',
  GRANULE = 'Granule',
  GRASS = 'Grass',
  HARDCOURT = 'HardCourt',
  ICE = 'Ice',
  OPTICOURT = 'Opticourt',
  PVC = 'PVC',
  PARQUET = 'Parquet',
  REDCOURT = 'RedCourt',
  SAND = 'Sand',
  SYNTHETIC = 'Synthetic',
  TARTAN = 'Tartan',
  WATER = 'Water'
}

export type SyncContactsResponse = {
  __typename: 'SyncContactsResponse';
  publicUser: Maybe<PublicUserV2>;
  telephoneHash: Scalars['String']['output'];
};

export type SyncContactsResponseV2 = {
  __typename: 'SyncContactsResponseV2';
  id: Scalars['ID']['output'];
  publicUser: PublicUserV2;
  telephoneHash: Scalars['String']['output'];
};

export type SyncContactsResponseV2Connection = {
  __typename: 'SyncContactsResponseV2Connection';
  edges: Array<SyncContactsResponseV2Edge>;
  /** The actual "SyncContactsResponseV2" items */
  nodes: Array<SyncContactsResponseV2>;
  pageInfo: PageInfo;
};

export type SyncContactsResponseV2Edge = {
  __typename: 'SyncContactsResponseV2Edge';
  cursor: Scalars['Cursor']['output'];
  node: SyncContactsResponseV2;
};

export type TextAddOnField = {
  __typename: 'TextAddOnField';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Maybe<MonetaryValue>;
};

export type Ticket = ProductInterface & {
  __typename: 'Ticket';
  currentPriceType: TicketPriceType;
  earlyBirdPrice: Maybe<MonetaryValue>;
  /** The date until when the early bird price is available */
  earlyBirdUntil: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** The date from when on the last minute price is available */
  lastMinuteFrom: Maybe<Scalars['Date']['output']>;
  lastMinutePrice: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  /** @deprecated Use standardPrice, earlyBirdPrice and lastMinutePrice in combination with the currentPriceType instead */
  price: MonetaryValue;
  /** @deprecated Use currentPriceType instead */
  priceType: TicketPriceType;
  productPurchaseInformation: ProductPurchaseInformation;
  standardPrice: MonetaryValue;
  /** The List of sessions for which this ticket is valid */
  validForSessions: Array<EventSession>;
};

/** Until a certain date, there might be an "Early Bird" price, after a certain date, there might be a "Last Minute" price */
export enum TicketPriceType {
  TICKET_PRICE_TYPE_EARLY_BIRD = 'TICKET_PRICE_TYPE_EARLY_BIRD',
  TICKET_PRICE_TYPE_LAST_MINUTE = 'TICKET_PRICE_TYPE_LAST_MINUTE',
  TICKET_PRICE_TYPE_STANDARD = 'TICKET_PRICE_TYPE_STANDARD'
}

export type TimePeriod = {
  __typename: 'TimePeriod';
  duration: Interval;
  /** The start date is only valid when the `startType` is `VALIDITY_START_TYPE_DATE`. */
  startDate: Maybe<Scalars['Date']['output']>;
  startType: PeriodStartType;
};

export type TimeRange = {
  __typename: 'TimeRange';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type TimeRangeInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type Trainer = {
  __typename: 'Trainer';
  description: Maybe<Scalars['String']['output']>;
  education: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image: Maybe<Image>;
  lastName: Maybe<Scalars['String']['output']>;
  nickname: Scalars['String']['output'];
  recentlyTrainedUserAt: Maybe<Venue>;
  sports: Array<Sport>;
  venues: Array<Venue>;
};

export type TrainerConnection = {
  __typename: 'TrainerConnection';
  edges: Array<TrainerEdge>;
  /** The actual "Trainer" items */
  nodes: Array<Trainer>;
  pageInfo: PageInfo;
};

export type TrainerEdge = {
  __typename: 'TrainerEdge';
  cursor: Scalars['Cursor']['output'];
  node: Trainer;
};

export type Twitter = SocialInterface & {
  __typename: 'Twitter';
  description: Maybe<Scalars['String']['output']>;
  image: Image;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Has no real properties, but its type denotes unlimited available budget */
export type Unlimited = {
  __typename: 'Unlimited';
  type: Scalars['String']['output'];
};

/** Has no properties, but its type denotes unlimited available spots */
export type UnlimitedSpots = {
  __typename: 'UnlimitedSpots';
  type: Scalars['String']['output'];
};

export type UpdateMatch = BallsportMatch | ExpectedErrors;

export type UsageLimit = {
  __typename: 'UsageLimit';
  currency: Maybe<Scalars['String']['output']>;
  repeating: Maybe<Repeating>;
  type: UsageLimitType;
  unit: UsageLimitUnit;
  usageLimit: Scalars['Float']['output'];
};

export type UsageLimitPeriod = {
  __typename: 'UsageLimitPeriod';
  allowedBookings: Scalars['Float']['output'];
  end: Scalars['Date']['output'];
  start: Scalars['Date']['output'];
  usedBookings: Scalars['Float']['output'];
};

export type UsageLimitPeriodV2 = {
  __typename: 'UsageLimitPeriodV2';
  allowedBookings: Scalars['Float']['output'];
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
  usedBookings: Scalars['Float']['output'];
};

/**
 *
 *   - `TOTAL` means `value` is to be interpreted as a limit which applies to the entire card over the entirity of its lifetime.
 *   - `REPEATING` means `value` is to be interpreted as a limit which applies on an Interval Basis, where `repeating` provides information on this interval.
 *   - `PER BOOKING` means `value` is to be interpreted as a limit which applies on the basis of a single booking, like no more than 1.5 hours per booking.
 *
 */
export enum UsageLimitType {
  USAGE_LIMIT_TYPE_PER_BOOKING = 'USAGE_LIMIT_TYPE_PER_BOOKING',
  USAGE_LIMIT_TYPE_REPEATING = 'USAGE_LIMIT_TYPE_REPEATING',
  USAGE_LIMIT_TYPE_TOTAL = 'USAGE_LIMIT_TYPE_TOTAL'
}

/**
 *
 *   - `HOURS` means `value` is given in hours. E.g. a limit of 5 hours per week.
 *   - `MONETARY` means `value` is given as financial value, where `currency` provides the currency. E.g. a card allowing 100 € worth of bookings to be made.
 *   - `UNITS` means `value` is given as generic units, usually equal to bookings of activities, however some activities may cost more units than others.
 *
 */
export enum UsageLimitUnit {
  USAGE_LIMIT_UNIT_HOURS = 'USAGE_LIMIT_UNIT_HOURS',
  USAGE_LIMIT_UNIT_MONETARY = 'USAGE_LIMIT_UNIT_MONETARY',
  USAGE_LIMIT_UNIT_UNITS = 'USAGE_LIMIT_UNIT_UNITS'
}

/** This type represents an authorized user. */
export type User = UserInterface & {
  __typename: 'User';
  /** A list of active push notification Endpoints */
  activePushNotificationEndpoints: Array<PushNotificationEndpoint>;
  assignedProducts: Array<AssignedProductsForUserProfileType>;
  /** Provides a list of user assigned recordings, which can be filtered by company. */
  assignedRecordings: AssignedRecordingConnection;
  availableBudget: Maybe<AvailableBudget>;
  bio: Maybe<Scalars['String']['output']>;
  corporateBenefits: Maybe<CorporateBenefits>;
  customers: CustomerConnection;
  dateOfBirth: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  family: Maybe<Family>;
  familyRole: Maybe<FamilyRole>;
  favouriteVenues: VenueConnection;
  firstName: Scalars['String']['output'];
  friends: FriendConnection;
  friendsCount: Scalars['Int']['output'];
  gender: Maybe<Gender>;
  handle: Scalars['String']['output'];
  hasAcceptedPublicProfileTerms: Scalars['Boolean']['output'];
  hasVerifiedEmail: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastLogin: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  locale: Maybe<Scalars['String']['output']>;
  location: Maybe<Location>;
  missingCompanyPolicies: Array<Policy>;
  missingEversportsPolicies: Array<Policy>;
  notifications: NotificationConnection;
  participations: ParticipationConnection;
  /** @deprecated Use `storedPaymentMethods` and `usableStoredPaymentMethods` instead.  */
  paymentMethods: Array<StoredPaymentMethod>;
  privacySettings: Array<PrivacySetting>;
  privateFeedbacks: Array<PrivateFeedback>;
  profilePicture: Maybe<Image>;
  /** The recap token for the user. Will be null if no recap has to be shown for this user */
  recapToken: Maybe<Scalars['String']['output']>;
  receivedFriendRequests: FriendRequestConnection;
  receivedFriendRequestsCount: Scalars['Int']['output'];
  recommendation: Maybe<Recommendation>;
  sentFriendRequests: FriendRequestConnection;
  sentFriendRequestsCount: Scalars['Int']['output'];
  showNetPromoterScoreQuestion: Scalars['Boolean']['output'];
  /** All payment methods that are attached to this user */
  storedPaymentMethods: Array<StoredPaymentMethod>;
  suggestedFriends: PublicUserV2Connection;
  telephone: Maybe<Scalars['String']['output']>;
  unreadNotificationsCount: Maybe<Scalars['Int']['output']>;
  upcomingFriendsParticipations: PublicParticipationV2Connection;
  /** Stored payment methods a user can use */
  usableStoredPaymentMethods: Array<StoredPaymentMethod>;
  /** The infrastructure type this user is rolled out to */
  usedInfrastructureType: Scalars['String']['output'];
};


/** This type represents an authorized user. */
export type UserAssignedProductsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  isValidInFuture?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This type represents an authorized user. */
export type UserAssignedRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  recordingId?: InputMaybe<Scalars['ID']['input']>;
};


/** This type represents an authorized user. */
export type UserCustomersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};


/** This type represents an authorized user. */
export type UserFavouriteVenuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** This type represents an authorized user. */
export type UserFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** This type represents an authorized user. */
export type UserMissingCompanyPoliciesArgs = {
  venueId: Scalars['ID']['input'];
};


/** This type represents an authorized user. */
export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** This type represents an authorized user. */
export type UserParticipationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  endsInFuture?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** This type represents an authorized user. */
export type UserRecapTokenArgs = {
  year: Scalars['Float']['input'];
};


/** This type represents an authorized user. */
export type UserReceivedFriendRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** This type represents an authorized user. */
export type UserSentFriendRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** This type represents an authorized user. */
export type UserSuggestedFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  suggestedTypes?: InputMaybe<Array<SuggestedType>>;
};


/** This type represents an authorized user. */
export type UserUpcomingFriendsParticipationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserInterface = {
  bio: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  profilePicture: Maybe<Image>;
};

export type UserResponseType = ExpectedErrors | User;

export type UserStatistics = {
  __typename: 'UserStatistics';
  activityCount: Scalars['Float']['output'];
  lastActivityDate: Maybe<Scalars['DateTime']['output']>;
  mostPlayedSport: Maybe<Sport>;
  totalActivities: Scalars['Float']['output'];
};


export type UserStatisticsActivityCountArgs = {
  timeRange: OpenEndTimeRangeInput;
};

export type Validity = {
  __typename: 'Validity';
  duration: Interval;
  /** The start date is only valid when the `startType` is `VALIDITY_START_TYPE_DATE`. */
  startDate: Maybe<Scalars['Date']['output']>;
  startType: ValidityStartType;
};

export enum ValidityStartType {
  VALIDITY_START_TYPE_DATE = 'VALIDITY_START_TYPE_DATE',
  VALIDITY_START_TYPE_FIRST_BOOKING = 'VALIDITY_START_TYPE_FIRST_BOOKING',
  VALIDITY_START_TYPE_PURCHASE_DATE = 'VALIDITY_START_TYPE_PURCHASE_DATE'
}

export type Venue = {
  __typename: 'Venue';
  about: About;
  address: Scalars['String']['output'];
  amenities: Array<VenueAmenityType>;
  cheapestPrice: Maybe<MonetaryValue>;
  cheapestTrialProductPrice: Maybe<MonetaryValue>;
  city: City;
  company: Company;
  contact: Contact;
  enabledFeatures: Array<FeaturePreview>;
  externalTrackingIds: ExternalTrackingIds;
  faqs: Array<VenueFaq>;
  hideAddress: Scalars['Boolean']['output'];
  hideNewsletterOnRegistration: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images: Array<Image>;
  isFavourite: Scalars['Boolean']['output'];
  isFeatureEnabled: Scalars['Boolean']['output'];
  /** @deprecated Deprecated in favor of venue.company.latestPolicies */
  latestPolicies: Array<Policy>;
  location: Location;
  logo: Maybe<Image>;
  name: Scalars['String']['output'];
  offerings: Array<VenueOfferingType>;
  profileImage: Maybe<Image>;
  /** Overall rating of an venue */
  rating: Maybe<Scalars['Float']['output']>;
  ratings: Array<Rating>;
  reviewCount: Scalars['Int']['output'];
  reviews: ReviewConnection;
  sessions: EventSessionConnection;
  shortId: Scalars['String']['output'];
  slotsToDiscover: Array<Slot>;
  slug: Scalars['String']['output'];
  specialPriceTypes: Array<SpecialPriceType>;
  sports: Array<Sport>;
  suggestedProducts: VenueSuggestedProducts;
  tags: Array<VenueTag>;
  timeZone: Scalars['TimeZone']['output'];
  trainers: TrainerConnection;
  /**
   * This is used in `recommendation page` to show trial cards not bought by the user at a venue
   * @deprecated Dont use this property anymore, as we will deprecate it in favour of venueUser connection
   */
  trialCards: CardConnection;
  type: Maybe<VenueType>;
  venueSearchDebugInformation: Maybe<VenueSearchDebugInformation>;
  widgetSettings: Maybe<WidgetSettings>;
};


export type VenueCheapestPriceArgs = {
  excludeTrialCards?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VenueIsFeatureEnabledArgs = {
  name: Scalars['String']['input'];
};


export type VenueOfferingsArgs = {
  ignoreCache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VenueReviewsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timeRange: TimeRangeInput;
};


export type VenueSlotsToDiscoverArgs = {
  filters: SlotToDiscoverFilter;
};


export type VenueTrainersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueTrialCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum VenueAmenityType {
  VENUE_AMENITY_ACCESSIBLE = 'VENUE_AMENITY_ACCESSIBLE',
  VENUE_AMENITY_AIR_CONDITIONING = 'VENUE_AMENITY_AIR_CONDITIONING',
  VENUE_AMENITY_CARDIO = 'VENUE_AMENITY_CARDIO',
  VENUE_AMENITY_CARDPAYMENT = 'VENUE_AMENITY_CARDPAYMENT',
  VENUE_AMENITY_COURSES = 'VENUE_AMENITY_COURSES',
  VENUE_AMENITY_FITNESSDEVICES = 'VENUE_AMENITY_FITNESSDEVICES',
  VENUE_AMENITY_GASTRONOMY = 'VENUE_AMENITY_GASTRONOMY',
  VENUE_AMENITY_LOCKERROOM = 'VENUE_AMENITY_LOCKERROOM',
  VENUE_AMENITY_OTHER = 'VENUE_AMENITY_OTHER',
  VENUE_AMENITY_PARKING = 'VENUE_AMENITY_PARKING',
  VENUE_AMENITY_POOL = 'VENUE_AMENITY_POOL',
  VENUE_AMENITY_SANITARY = 'VENUE_AMENITY_SANITARY',
  VENUE_AMENITY_SHOP = 'VENUE_AMENITY_SHOP',
  VENUE_AMENITY_WELLNESS = 'VENUE_AMENITY_WELLNESS'
}

export enum VenueAttributes {
  VENUE_ATTRIBUTES_CORPORATE_DISCOUNT = 'VENUE_ATTRIBUTES_CORPORATE_DISCOUNT',
  VENUE_ATTRIBUTES_FREE_TRIAL = 'VENUE_ATTRIBUTES_FREE_TRIAL',
  VENUE_ATTRIBUTES_INTRO_OFFER = 'VENUE_ATTRIBUTES_INTRO_OFFER',
  VENUE_ATTRIBUTES_NEW_VENUE = 'VENUE_ATTRIBUTES_NEW_VENUE'
}

export type VenueConnection = {
  __typename: 'VenueConnection';
  edges: Array<VenueEdge>;
  /** The actual "Venue" items */
  nodes: Array<Venue>;
  pageInfo: PageInfo;
};

export type VenueContext = {
  __typename: 'VenueContext';
  meta: MetaData;
  venue: Venue;
};

export type VenueEdge = {
  __typename: 'VenueEdge';
  cursor: Scalars['Cursor']['output'];
  node: Venue;
};

export type VenueFaq = {
  __typename: 'VenueFaq';
  answer: Scalars['String']['output'];
  question: VenueFaqQuestionType;
};

export enum VenueFaqQuestionType {
  CANCEL_INFO = 'CANCEL_INFO',
  EQUIPMENT = 'EQUIPMENT',
  EXTRA_INFO = 'EXTRA_INFO',
  FIRST_TIME = 'FIRST_TIME',
  USP = 'USP'
}

export type VenueFilters = {
  activityAvailabilities?: InputMaybe<Array<ActivityAvailability>>;
  boundingBox: BoundingBoxArgs;
  courtAreas?: InputMaybe<Array<CourtAreaType>>;
  courtAvailability?: InputMaybe<CourtAvailability>;
  courtSurfaces?: InputMaybe<Array<CourtSurfaceType>>;
  districts?: InputMaybe<Array<Scalars['ID']['input']>>;
  reviewCount?: InputMaybe<IntegerValueQuery>;
  /** Introduce minor randomness into the order of venues to make the page appear more recent and ever-changing to search engines. */
  seoShuffle?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueAmenities?: InputMaybe<Array<VenueAmenityType>>;
  venueAttributes?: InputMaybe<Array<VenueAttributes>>;
  venueOfferingTypes?: InputMaybe<Array<VenueOfferingType>>;
};

export enum VenueOfferingType {
  VENUE_OFFERING_CAMP_ACTIVITY = 'VENUE_OFFERING_CAMP_ACTIVITY',
  VENUE_OFFERING_CLASS_ACTIVITY = 'VENUE_OFFERING_CLASS_ACTIVITY',
  VENUE_OFFERING_COURSE_ACTIVITY = 'VENUE_OFFERING_COURSE_ACTIVITY',
  VENUE_OFFERING_EDUCATION_ACTIVITY = 'VENUE_OFFERING_EDUCATION_ACTIVITY',
  VENUE_OFFERING_EVENT_ACTIVITY = 'VENUE_OFFERING_EVENT_ACTIVITY',
  VENUE_OFFERING_INDOOR_ACTIVITY = 'VENUE_OFFERING_INDOOR_ACTIVITY',
  VENUE_OFFERING_LIVESTREAM = 'VENUE_OFFERING_LIVESTREAM',
  VENUE_OFFERING_OPENTRAINING_ACTIVITY = 'VENUE_OFFERING_OPENTRAINING_ACTIVITY',
  VENUE_OFFERING_OUTDOOR_ACTIVITY = 'VENUE_OFFERING_OUTDOOR_ACTIVITY',
  VENUE_OFFERING_PUBLIC_MATCHES = 'VENUE_OFFERING_PUBLIC_MATCHES',
  VENUE_OFFERING_RETREAT_ACTIVITY = 'VENUE_OFFERING_RETREAT_ACTIVITY',
  VENUE_OFFERING_SHOP = 'VENUE_OFFERING_SHOP',
  VENUE_OFFERING_SPORTS_FIELDS = 'VENUE_OFFERING_SPORTS_FIELDS',
  VENUE_OFFERING_TEAM = 'VENUE_OFFERING_TEAM',
  VENUE_OFFERING_TRAINING_ACTIVITY = 'VENUE_OFFERING_TRAINING_ACTIVITY',
  VENUE_OFFERING_VIDEO = 'VENUE_OFFERING_VIDEO',
  VENUE_OFFERING_WORKSHOP_ACTIVITY = 'VENUE_OFFERING_WORKSHOP_ACTIVITY'
}

export type VenueSearchDebugInformation = {
  __typename: 'VenueSearchDebugInformation';
  score: Scalars['Float']['output'];
  usedRelevancies: Maybe<Array<VenueSearchRelevance>>;
};

export type VenueSearchRelevance = {
  __typename: 'VenueSearchRelevance';
  label: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type VenueSearchResult = SearchResult & {
  __typename: 'VenueSearchResult';
  cityId: Scalars['ID']['output'];
  citySlug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: Location;
  matchedName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  online: Scalars['Boolean']['output'];
  secondaryMatch: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export enum VenueSearchSort {
  CONSIDER_DISTANCE = 'CONSIDER_DISTANCE',
  DEFAULT = 'DEFAULT'
}

export type VenueSuggestedProducts = {
  __typename: 'VenueSuggestedProducts';
  cheapest: Maybe<CheapestProduct>;
  popular: Maybe<Card>;
};

export type VenueTag = {
  __typename: 'VenueTag';
  name: Scalars['String']['output'];
};

export enum VenueType {
  BALLSPORTCLUB = 'BALLSPORTCLUB',
  BALLSPORTCOMMERCIAL = 'BALLSPORTCOMMERCIAL',
  CORPORATESPORTS = 'CORPORATESPORTS',
  DEMOTEST = 'DEMOTEST',
  FUNSPORT = 'FUNSPORT',
  KEINKUNDE = 'KEINKUNDE',
  SMILEINTERFACE = 'SMILEINTERFACE',
  STUDIODANCE = 'STUDIODANCE',
  STUDIOFITNESS = 'STUDIOFITNESS',
  STUDIOONLINE = 'STUDIOONLINE',
  STUDIOYOGA = 'STUDIOYOGA'
}

/** Voucher is a giftcard you can buy. Once bought a code is generated for anyone to redeem the value with that code */
export type Voucher = {
  __typename: 'Voucher';
  /** The conditions on how the voucher can be applied on the venue */
  conditions: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: Maybe<Image>;
  name: Scalars['String']['output'];
  /** The date until this voucher is valid. If null the voucher is valid forever */
  validityInterval: Maybe<Interval>;
  value: MonetaryValue;
};

export type WaitingList = {
  __typename: 'WaitingList';
  id: Scalars['ID']['output'];
};

export enum Weekday {
  WEEKDAY_FRIDAY = 'WEEKDAY_FRIDAY',
  WEEKDAY_MONDAY = 'WEEKDAY_MONDAY',
  WEEKDAY_SATURDAY = 'WEEKDAY_SATURDAY',
  WEEKDAY_SUNDAY = 'WEEKDAY_SUNDAY',
  WEEKDAY_THURSDAY = 'WEEKDAY_THURSDAY',
  WEEKDAY_TUESDAY = 'WEEKDAY_TUESDAY',
  WEEKDAY_WEDNESDAY = 'WEEKDAY_WEDNESDAY'
}

export type WidgetSettings = {
  __typename: 'WidgetSettings';
  activitySpotLimitDisplayType: Maybe<ActivitySpotLimitDisplayType>;
  cardsFontColor: Maybe<Scalars['String']['output']>;
  colorBackground: Maybe<Scalars['String']['output']>;
  colorButton: Maybe<Scalars['String']['output']>;
  colorFont: Maybe<Scalars['String']['output']>;
  showActivityLevel: Scalars['Boolean']['output'];
  showActivityPrice: Scalars['Boolean']['output'];
  showActivityResource: Scalars['Boolean']['output'];
  showActivityTrainer: Scalars['Boolean']['output'];
};

export type EnsureLoggedInUserMeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type EnsureLoggedInUserMeQueryQuery = { me: { __typename: 'User', id: string, firstName: string, hasVerifiedEmail: boolean } | null };

export type AddOnsCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type AddOnsCartQuery = { cart: { __typename: 'Cart', id: string, valid: boolean, items: Array<{ __typename: 'BookableItemCartItem', id: string, addOns: Array<{ __typename: 'AddOn', id: string, description: string, mandatory: boolean, fields: Array<{ __typename: 'NumberAddOnField', id: string, description: string, price: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'SelectAddOnField', id: string, description: string, selectionType: SelectAddOnFieldSelectionType, options: Array<{ __typename: 'SelectAddOnFieldOption', id: string, description: string, price: { __typename: 'MonetaryValue', value: number, currency: string } | null }> } | { __typename: 'TextAddOnField', id: string, description: string, price: { __typename: 'MonetaryValue', value: number, currency: string } | null }> }>, addOnsInput: Array<{ __typename: 'AddOnInput', id: string, fields: Array<{ __typename: 'AddOnFieldInput', id: string, numberValue: number | null, textValue: string | null, singleSelectionValue: string | null, multiSelectionValue: Array<string> | null }> }> } | { __typename: 'ProductCartItem' }> } };

export type AddOnsSetAddOnsForBookableItemCartItemMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
  addOns: Array<AddOnInputInput> | AddOnInputInput;
}>;


export type AddOnsSetAddOnsForBookableItemCartItemMutation = { setAddOnsForBookableItemCartItem: { __typename: 'Cart', id: string, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number, currency: string } | null, itemsV3: Array<{ __typename: 'PriceTableItemAddon', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemBasic', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemBudget', name: string, amount: number, budgetName: string, corporateName: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemMembership', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurringPrice: { __typename: 'MonetaryValue', value: number, currency: string }, partialPriceTimeRange: { __typename: 'TimeRange', start: string, end: string } | null, paymentInterval: { __typename: 'Interval', value: number, type: IntervalUnit } | null, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null } | { __typename: 'PriceTableItemSpecialPrice', name: string, amount: number, specialPriceType: SpecialPriceType, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemVoucher', name: string, amount: number, code: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null }> } | null, items: Array<{ __typename: 'BookableItemCartItem', id: string, addOnsInput: Array<{ __typename: 'AddOnInput', id: string, fields: Array<{ __typename: 'AddOnFieldInput', id: string, numberValue: number | null, textValue: string | null, singleSelectionValue: string | null, multiSelectionValue: Array<string> | null }> }> } | { __typename: 'ProductCartItem' }> } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type MultiAnswerPatronQuestionCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type MultiAnswerPatronQuestionCartQuery = { cart: { __typename: 'Cart', id: string, patronQuestionType: PatronQuestionType, multiAnswerPatronQuestionInput: PatronageAnswer | null, venue: { __typename: 'Venue', id: string, name: string } } };

export type MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  patronageAnswer: PatronageAnswer;
}>;


export type MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation = { setMultiAnswerPatronQuestionOnCart: { __typename: 'Cart', id: string, multiAnswerPatronQuestionInput: PatronageAnswer | null } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type PatronQuestionCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type PatronQuestionCartQuery = { cart: { __typename: 'Cart', id: string, patronQuestionType: PatronQuestionType, patronQuestionInput: boolean | null, venue: { __typename: 'Venue', id: string, name: string } } };

export type PatronQuestionSetPatronQuestionOnCartMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  isPatron: Scalars['Boolean']['input'];
}>;


export type PatronQuestionSetPatronQuestionOnCartMutation = { setPatronQuestionOnCart: { __typename: 'Cart', id: string, patronQuestionInput: boolean | null } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type PoliciesCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type PoliciesCartQuery = { cart: { __typename: 'Cart', id: string, policiesInput: Array<string>, policies: Array<{ __typename: 'Policy', id: string, url: string, type: PolicyType, mandatory: boolean }>, venue: { __typename: 'Venue', id: string, name: string } } };

export type PoliciesSetPoliciesOnCartMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  policies: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PoliciesSetPoliciesOnCartMutation = { setPoliciesOnCart: { __typename: 'Cart', id: string, policiesInput: Array<string> } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type RequiredInformationCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type RequiredInformationCartQuery = { me: { __typename: 'User', id: string, location: { __typename: 'Location', country: string } | null } | null, cart: { __typename: 'Cart', id: string, requiredInformation: Array<RequiredInformationType>, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number, currency: string } | null } | null, customer: { __typename: 'Customer', id: string, location: { __typename: 'Location', country: string } | null } | null, requiredInformationInput: { __typename: 'RequiredInformation', phoneNumber: string | null, birthday: string | null, fiscalCode: string | null, address: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', country: string } }, items: Array<{ __typename: 'BookableItemCartItem', bookableItem: { __typename: 'CourtBookableItem' } | { __typename: 'EventBookableItem', id: string, eventType: EventType } } | { __typename: 'ProductCartItem' }> } };

export type RequiredInformationSetRequiredInformationOnCartMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  requiredInformation: RequiredInformationInput;
}>;


export type RequiredInformationSetRequiredInformationOnCartMutation = { setRequiredInformationOnCart: { __typename: 'Cart', id: string, requiredInformationInput: { __typename: 'RequiredInformation', phoneNumber: string | null, birthday: string | null, fiscalCode: string | null, address: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null } } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type AvailablePaymentMethodsCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type AvailablePaymentMethodsCartQuery = { cart: { __typename: 'Cart', id: string, paymentMethods: Array<{ __typename: 'PaymentMethod', type: PaymentMethodType, name: string }> | null } };

export type AvailablePaymentMethodsOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type AvailablePaymentMethodsOrderQuery = { order: { __typename: 'Order', id: string, payment: { __typename: 'Payment', id: string, paymentMethods: Array<{ __typename: 'PaymentMethod', type: PaymentMethodType, name: string }> } | null } };

export type BackButtonAbortOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type BackButtonAbortOrderMutation = { abortOrder: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } | { __typename: 'Order', id: string } };

export type ConfirmationOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type ConfirmationOrderQuery = { order: { __typename: 'Order', id: string, isSelfCheckinAvailable: boolean, state: OrderState, amount: { __typename: 'MonetaryValue', value: number }, invoice: { __typename: 'Invoice', downloadLink: string | null } | null, items: Array<{ __typename: 'AssignedProductOrderItem', assignedProduct: { __typename: 'AssignedCard', id: string } | { __typename: 'AssignedMembership', id: string } | { __typename: 'AssignedRecording', id: string } | { __typename: 'AssignedVoucher', id: string, code: string } | { __typename: 'GenericAssignedProduct', id: string } } | { __typename: 'BookingOrderItem', booking: { __typename: 'CourtBooking' } | { __typename: 'EventBooking', id: string, bookableItem: { __typename: 'EventBookableItem', id: string, eventType: EventType } } } | { __typename: 'BookingRequestOrderItem', endPrice: number, confirmedWith: { __typename: 'AssignedCard' } | { __typename: 'AssignedMembership' } | null }>, venue: { __typename: 'Venue', id: string, name: string, shortId: string, slug: string, logo: { __typename: 'Image', large: string } | null }, customer: { __typename: 'Customer', id: string, isSubscribedToNewsletter: boolean } | null } };

export type InviteFriendsMeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type InviteFriendsMeQuery = { me: { __typename: 'User', id: string, handle: string, friendsCount: number, friends: { __typename: 'FriendConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'FriendEdge', cursor: any, node: { __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string, handle: string, profilePicture: { __typename: 'Image', small: string } | null } } }> } } | null };

export type InviteFriendsShareEventMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type InviteFriendsShareEventMutation = { shareEvent: boolean };

export type UseSharingMessageQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type UseSharingMessageQuery = { order: { __typename: 'Order', id: string, items: Array<{ __typename: 'AssignedProductOrderItem' } | { __typename: 'BookingOrderItem', booking: { __typename: 'CourtBooking' } | { __typename: 'EventBooking', id: string, purchasedWith: { __typename: 'SinglePurchase' } | { __typename: 'Ticket', id: string, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string }> } | null, bookableItemV2: { __typename: 'EventBookableItem', id: string, activityName: string, shortId: string, eventType: EventType, venue: { __typename: 'Venue', id: string, name: string }, eventSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string }> } } } | { __typename: 'BookingRequestOrderItem' }> } };

export type NewsletterBannerSubscribeToNewsletterMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type NewsletterBannerSubscribeToNewsletterMutation = { subscribeToNewsletter: { __typename: 'Customer', id: string } };

export type HeaderMeQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaderMeQuery = { me: { __typename: 'User', id: string, firstName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } | null };

export type PaymentOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type PaymentOrderQuery = { order: { __typename: 'Order', id: string, isConfirmable: boolean, state: OrderState, appliedVoucher: { __typename: 'AppliedVoucher', code: string } | null, payment: { __typename: 'Payment', id: string, state: PaymentState, lastAttemptAt: string | null, customerSessionClientSecret: string, canSetupRecurringPaymentMethod: boolean, paymentMethods: Array<{ __typename: 'PaymentMethod', type: PaymentMethodType, name: string, verifyWith: PaymentMethodVerificationMethod | null }>, user: { __typename: 'User', id: string, firstName: string, lastName: string, email: string, family: { __typename: 'Family', id: string, owner: { __typename: 'User', id: string, firstName: string, lastName: string, email: string, profilePicture: { __typename: 'Image', small: string } | null } } | null, profilePicture: { __typename: 'Image', small: string } | null }, storedPaymentMethods: Array<{ __typename: 'StoredBankAccount', id: string, pspId: string, last4: string, mandates: Array<{ __typename: 'Mandate', isVerified: boolean }> } | { __typename: 'StoredCreditCard', id: string, name: string, brand: string, pspId: string, expirationMonth: number, expirationYear: number, last4: string, preferredNetwork: string | null }>, mandate: { __typename: 'Mandate', isVerified: boolean, bankAccount: { __typename: 'StoredBankAccount', id: string, pspId: string, last4: string } } | null, paymentIntent: { __typename: 'PaymentIntent', id: string, amount: number, currency: string, clientSecret: string } | null } | null, venue: { __typename: 'Venue', id: string, location: { __typename: 'Location', country: string } }, items: Array<{ __typename: 'AssignedProductOrderItem', assignedProduct: { __typename: 'AssignedCard', id: string } | { __typename: 'AssignedMembership', id: string } | { __typename: 'AssignedRecording', id: string } | { __typename: 'AssignedVoucher', id: string } | { __typename: 'GenericAssignedProduct', id: string } } | { __typename: 'BookingOrderItem' } | { __typename: 'BookingRequestOrderItem' }> } };

export type PaymentAbortOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type PaymentAbortOrderMutation = { abortOrder: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } | { __typename: 'Order', id: string, state: OrderState } };

export type PaymentTrackCheckoutCompleteMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  deviceId: Scalars['String']['input'];
  sessionId: Scalars['Float']['input'];
  userTrackingId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentTrackCheckoutCompleteMutation = { trackCheckoutComplete: boolean };

export type PaymentGetMarketplaceFeeQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type PaymentGetMarketplaceFeeQuery = { getMarketplaceFeeForOrder: { __typename: 'MonetaryValue', value: number, currency: string } | null };

export type ConfirmOrderConfirmOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type ConfirmOrderConfirmOrderMutation = { confirmOrder: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } | { __typename: 'Order', id: string } };

export type ConfirmPaymentConfirmPaymentMutationVariables = Exact<{
  paymentId: Scalars['ID']['input'];
  pspPaymentMethodId: Scalars['String']['input'];
}>;


export type ConfirmPaymentConfirmPaymentMutation = { confirmPaymentWithPaymentMethod: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } | { __typename: 'Payment' } };

export type PollPaymentOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type PollPaymentOrderQuery = { order: { __typename: 'Order', id: string, state: OrderState, payment: { __typename: 'Payment', id: string, state: PaymentState, lastAttemptAt: string | null } | null } };

export type PreparePaymentPreparePaymentMutationVariables = Exact<{
  paymentId: Scalars['ID']['input'];
  paymentMethodType: PaymentMethodType;
}>;


export type PreparePaymentPreparePaymentMutation = { preparePayment: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } | { __typename: 'Payment', id: string, paymentIntent: { __typename: 'PaymentIntent', clientSecret: string } | null } };

export type SetupRecurringPaymentMethodMutationVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type SetupRecurringPaymentMethodMutation = { setupRecurringPaymentMethod: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } | { __typename: 'Payment', id: string, paymentSetupIntent: { __typename: 'PaymentSetupIntent', id: string, clientSecret: string | null, paymentMethod: { __typename: 'StoredBankAccount', id: string, pspId: string, mandates: Array<{ __typename: 'Mandate', isVerified: boolean }> } | { __typename: 'StoredCreditCard', id: string, pspId: string } | null } | null } };

export type PaymentTimerOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type PaymentTimerOrderQuery = { order: { __typename: 'Order', id: string, confirmableUntil: string | null, createdAt: string, state: OrderState, payment: { __typename: 'Payment', id: string, state: PaymentState } | null } };

export type PaymentTimerAbortOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type PaymentTimerAbortOrderMutation = { abortOrder: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } | { __typename: 'Order', id: string } };

export type ProductSelectionCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type ProductSelectionCartQuery = { cart: { __typename: 'Cart', id: string, isPayAtVenueAllowed: boolean, items: Array<{ __typename: 'BookableItemCartItem', id: string, settleWith: { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } } | { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'GenericAssignedProduct', id: string } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } } | null, purchaseOptions: Array<{ __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null }, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } }>, confirmWithOptions: Array<{ __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } }>, bookableItem: { __typename: 'CourtBookableItem' } | { __typename: 'EventBookableItem', id: string, eventType: EventType } } | { __typename: 'ProductCartItem', id: string, settleWith: { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } } | { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'GenericAssignedProduct', id: string } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } } | null, purchaseOptions: Array<{ __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null }, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } }>, confirmWithOptions: Array<{ __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } }>, product: { __typename: 'Card' } | { __typename: 'Membership' } | { __typename: 'Recording', id: string } | { __typename: 'Voucher' } }> } };

export type ProductSelectionSetProductForCartItemMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}>;


export type ProductSelectionSetProductForCartItemMutation = { setProductForCartItem: { __typename: 'Cart', id: string, isVoucherEnabled: boolean, availableCorporateBenefits: { __typename: 'AvailableBenefits', isBudgetAvailable: boolean, isSpecialPriceAvailable: boolean, corporatePartner: { __typename: 'CorporatePartner', name: string } | null }, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number, currency: string } | null, itemsV3: Array<{ __typename: 'PriceTableItemAddon', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemBasic', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemBudget', name: string, amount: number, budgetName: string, corporateName: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemMembership', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurringPrice: { __typename: 'MonetaryValue', value: number, currency: string }, partialPriceTimeRange: { __typename: 'TimeRange', start: string, end: string } | null, paymentInterval: { __typename: 'Interval', value: number, type: IntervalUnit } | null, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null } | { __typename: 'PriceTableItemSpecialPrice', name: string, amount: number, specialPriceType: SpecialPriceType, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemVoucher', name: string, amount: number, code: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null }> } | null, items: Array<{ __typename: 'BookableItemCartItem', id: string, settleWith: { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } } | { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'GenericAssignedProduct', id: string } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } } | null } | { __typename: 'ProductCartItem', id: string, settleWith: { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } } | { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'GenericAssignedProduct', id: string } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } } | null }> } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type StepperCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type StepperCartQuery = { cart: { __typename: 'Cart', id: string, patronQuestionType: PatronQuestionType, requiredInformation: Array<RequiredInformationType>, quickCheckoutAvailable: boolean, isVoucherEnabled: boolean, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number } | null, originalPrice: { __typename: 'MonetaryValue', value: number } | null } | null, policies: Array<{ __typename: 'Policy', id: string, url: string, type: PolicyType, mandatory: boolean }>, items: Array<{ __typename: 'BookableItemCartItem', purchaseOptions: Array<{ __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } }>, confirmWithOptions: Array<{ __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } }>, settleWith: { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } } | { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'GenericAssignedProduct', id: string } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } } | null, addOns: Array<{ __typename: 'AddOn', id: string }> } | { __typename: 'ProductCartItem', id: string, purchaseOptions: Array<{ __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } }>, confirmWithOptions: Array<{ __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } }>, product: { __typename: 'Card', id: string } | { __typename: 'Membership', id: string } | { __typename: 'Recording', id: string } | { __typename: 'Voucher', id: string } }> } };

export type StepperOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type StepperOrderQuery = { order: { __typename: 'Order', id: string, payment: { __typename: 'Payment', id: string, state: PaymentState } | null, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number, currency: string } | null } } };

export type CorporateBenefitsSetBenefitsOnCartMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  useBenefits: Scalars['Boolean']['input'];
}>;


export type CorporateBenefitsSetBenefitsOnCartMutation = { setUseCorporateBenefitsOnCart: { __typename: 'Cart', id: string, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number, currency: string } | null, itemsV3: Array<{ __typename: 'PriceTableItemAddon', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemBasic', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemBudget', name: string, amount: number, budgetName: string, corporateName: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemMembership', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurringPrice: { __typename: 'MonetaryValue', value: number, currency: string }, partialPriceTimeRange: { __typename: 'TimeRange', start: string, end: string } | null, paymentInterval: { __typename: 'Interval', value: number, type: IntervalUnit } | null, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null } | { __typename: 'PriceTableItemSpecialPrice', name: string, amount: number, specialPriceType: SpecialPriceType, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemVoucher', name: string, amount: number, code: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null }> } | null } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | null }> } };

export type CorporateInfoItemCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type CorporateInfoItemCartQuery = { cart: { __typename: 'Cart', id: string, availableBudget: { __typename: 'AvailableBudget', employeeBudgetDepleted: boolean, totalBudgetDepleted: boolean } | null, availableCorporateBenefits: { __typename: 'AvailableBenefits', isBudgetAvailable: boolean, isSpecialPriceAvailable: boolean, corporatePartner: { __typename: 'CorporatePartner', name: string } | null } } };

export type SummaryButtonCreateOrderFromCartMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type SummaryButtonCreateOrderFromCartMutation = { createOrderFromCart: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } | { __typename: 'Order', id: string, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number } | null, items: Array<{ __typename: 'PriceTableItemAddon' } | { __typename: 'PriceTableItemBasic' } | { __typename: 'PriceTableItemMembership' } | { __typename: 'PriceTableItemVoucher' }> } } };

export type SummaryButtonTrackCheckoutCompleteMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  deviceId: Scalars['String']['input'];
  sessionId: Scalars['Float']['input'];
  userTrackingId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SummaryButtonTrackCheckoutCompleteMutation = { trackCheckoutComplete: boolean };

export type SummaryButtonGetMarketplaceFeeQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type SummaryButtonGetMarketplaceFeeQuery = { getMarketplaceFeeForOrder: { __typename: 'MonetaryValue', value: number, currency: string } | null };

export type VoucherSelectionSetVoucherOnCartMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  voucher?: InputMaybe<Scalars['String']['input']>;
}>;


export type VoucherSelectionSetVoucherOnCartMutation = { setVoucherOnCart: { __typename: 'Cart', id: string, isVoucherEnabled: boolean, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number, currency: string } | null, itemsV3: Array<{ __typename: 'PriceTableItemAddon', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemBasic', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemBudget', name: string, amount: number, budgetName: string, corporateName: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemMembership', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurringPrice: { __typename: 'MonetaryValue', value: number, currency: string }, partialPriceTimeRange: { __typename: 'TimeRange', start: string, end: string } | null, paymentInterval: { __typename: 'Interval', value: number, type: IntervalUnit } | null, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null } | { __typename: 'PriceTableItemSpecialPrice', name: string, amount: number, specialPriceType: SpecialPriceType, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemVoucher', name: string, amount: number, code: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null }> } | null } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | null }> } };

export type VoucherSelectionCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type VoucherSelectionCartQuery = { cart: { __typename: 'Cart', id: string, isVoucherEnabled: boolean, priceTable: { __typename: 'PriceTable', itemsV3: Array<{ __typename: 'PriceTableItemAddon' } | { __typename: 'PriceTableItemBasic' } | { __typename: 'PriceTableItemBudget' } | { __typename: 'PriceTableItemMembership' } | { __typename: 'PriceTableItemSpecialPrice' } | { __typename: 'PriceTableItemVoucher', code: string }> } | null } };

export type CreateOrderFromCartHandlerCreateOrderFromCartMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type CreateOrderFromCartHandlerCreateOrderFromCartMutation = { createOrderFromCart: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } | { __typename: 'Order', id: string } };

export type GetVenueTrackingIdPaymentOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetVenueTrackingIdPaymentOrderQuery = { order: { __typename: 'Order', id: string, venue: { __typename: 'Venue', externalTrackingIds: { __typename: 'ExternalTrackingIds', googleAnalyticsId: string | null } } } };

export type PurchaseDataForGooglePaymentOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type PurchaseDataForGooglePaymentOrderQuery = { order: { __typename: 'Order', id: string, amount: { __typename: 'MonetaryValue', value: number, currency: string } } };

export type InitialDataLoaderCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type InitialDataLoaderCartQuery = { cart: { __typename: 'Cart', id: string, patronQuestionType: PatronQuestionType, requiredInformation: Array<RequiredInformationType>, quickCheckoutAvailable: boolean, isVoucherEnabled: boolean, availableBudget: { __typename: 'AvailableBudget', employeeBudgetDepleted: boolean, totalBudgetDepleted: boolean } | null, availableCorporateBenefits: { __typename: 'AvailableBenefits', isBudgetAvailable: boolean, isSpecialPriceAvailable: boolean, corporatePartner: { __typename: 'CorporatePartner', name: string } | null }, policies: Array<{ __typename: 'Policy', id: string, url: string, type: PolicyType, mandatory: boolean }>, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number } | null, originalPrice: { __typename: 'MonetaryValue', value: number } | null } | null, items: Array<{ __typename: 'BookableItemCartItem', id: string, settleWith: { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } } | { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'GenericAssignedProduct', id: string } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } } | null, purchaseOptions: Array<{ __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } }>, confirmWithOptions: Array<{ __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } }>, addOns: Array<{ __typename: 'AddOn', id: string }> } | { __typename: 'ProductCartItem', id: string, settleWith: { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } } | { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'GenericAssignedProduct', id: string } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } } | null, product: { __typename: 'Card', id: string } | { __typename: 'Membership', id: string } | { __typename: 'Recording', id: string } | { __typename: 'Voucher', id: string }, purchaseOptions: Array<{ __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } }>, confirmWithOptions: Array<{ __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } }> }> } };

export type InitialDataLoaderOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type InitialDataLoaderOrderQuery = { order: { __typename: 'Order', id: string, state: OrderState, payment: { __typename: 'Payment', state: PaymentState } | null, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number, currency: string } | null } } };

export type OrderAbortHandlerAbortOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type OrderAbortHandlerAbortOrderMutation = { abortOrder: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } | { __typename: 'Order', id: string, state: OrderState } };

export type OrderCreationHandlerCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type OrderCreationHandlerCartQuery = { cart: { __typename: 'Cart', id: string, patronQuestionType: PatronQuestionType, requiredInformation: Array<RequiredInformationType>, quickCheckoutAvailable: boolean, isVoucherEnabled: boolean, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number } | null, originalPrice: { __typename: 'MonetaryValue', value: number } | null } | null, policies: Array<{ __typename: 'Policy', id: string, url: string, type: PolicyType, mandatory: boolean }>, items: Array<{ __typename: 'BookableItemCartItem', purchaseOptions: Array<{ __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } }>, confirmWithOptions: Array<{ __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } }>, addOns: Array<{ __typename: 'AddOn', id: string }> } | { __typename: 'ProductCartItem', id: string, purchaseOptions: Array<{ __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } }>, confirmWithOptions: Array<{ __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } }>, product: { __typename: 'Card' } | { __typename: 'Membership' } | { __typename: 'Recording' } | { __typename: 'Voucher' } }> } };

export type CourtBookableItemAttributesFragment = { __typename: 'CourtBookableItem', id: string, cancellationCondition: string, sport: { __typename: 'Sport', name: string }, court: { __typename: 'Court', name: string }, timeRange: { __typename: 'TimeRange', start: string, end: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string } }, activityImage: { __typename: 'Image', large: string } | null };

export type EventBookableItemAttributesFragment = { __typename: 'EventBookableItem', id: string, activityName: string, eventType: EventType, cancellationCondition: string, description: { __typename: 'FormattedText', plainText: string } | null, sport: { __typename: 'Sport', name: string }, eventSessions: Array<{ __typename: 'EventSession', id: string, name: string, start: string, end: string, hasOnlineStream: boolean, court: { __typename: 'Court', id: string, name: string } | null, trainer: { __typename: 'Trainer', id: string, nickname: string } | null }>, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } }, trainer: Array<{ __typename: 'Trainer', id: string, firstName: string | null, nickname: string }> | null, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string }, activityImage: { __typename: 'Image', large: string } | null, floorPlan: { __typename: 'AssignedFloorPlan', id: string } | null };

export type PriceTableItemBasicAttributesFragment = { __typename: 'PriceTableItemBasic', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null };

export type PriceTableItemAddonAttributesFragment = { __typename: 'PriceTableItemAddon', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null };

export type PriceTableItemVoucherAttributesFragment = { __typename: 'PriceTableItemVoucher', name: string, amount: number, code: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null };

export type PriceTableItemMembershipAttributesFragment = { __typename: 'PriceTableItemMembership', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurringPrice: { __typename: 'MonetaryValue', value: number, currency: string }, partialPriceTimeRange: { __typename: 'TimeRange', start: string, end: string } | null, paymentInterval: { __typename: 'Interval', value: number, type: IntervalUnit } | null, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null };

export type PriceTableItemBudgetAttributesFragment = { __typename: 'PriceTableItemBudget', name: string, amount: number, budgetName: string, corporateName: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null };

export type PriceTableItemSpecialPriceAttributesFragment = { __typename: 'PriceTableItemSpecialPrice', name: string, amount: number, specialPriceType: SpecialPriceType, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null };

export type CardAttributesFragment = { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> };

export type MembershipAttributesFragment = { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> };

export type VoucherAttributesFragment = { __typename: 'Voucher', id: string, name: string, conditions: string | null, value: { __typename: 'MonetaryValue', value: number, currency: string }, validityInterval: { __typename: 'Interval', type: IntervalUnit, value: number } | null, image: { __typename: 'Image', large: string } | null };

export type TicketAttributesFragment = { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } };

export type SinglePurchaseAttributesFragment = { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } };

export type RecordingAttributesFragment = { __typename: 'Recording', id: string, description: string | null, availableUntil: string | null, name: string, recordingStartDate: string | null, recordingEndDate: string | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, image: { __typename: 'Image', large: string } | null, trainer: { __typename: 'Trainer', id: string, nickname: string } | null };

export type AssignedCardAttributesFragment = { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } };

export type AssignedMembershipAttributesFragment = { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } };

export type BaseUserAttributesFragment = { __typename: 'User', id: string, firstName: string, lastName: string, email: string, profilePicture: { __typename: 'Image', small: string } | null };

export type UserAttributesFragment = { __typename: 'User', id: string, firstName: string, lastName: string, email: string, family: { __typename: 'Family', id: string, owner: { __typename: 'User', id: string, firstName: string, lastName: string, email: string, profilePicture: { __typename: 'Image', small: string } | null } } | null, profilePicture: { __typename: 'Image', small: string } | null };

export type UseBookingDetailsCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type UseBookingDetailsCartQuery = { cart: { __typename: 'Cart', id: string, venue: { __typename: 'Venue', id: string, name: string, isFeatureEnabled: boolean, images: Array<{ __typename: 'Image', large: string }> }, items: Array<{ __typename: 'BookableItemCartItem', id: string, settleWith: { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } } | { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'GenericAssignedProduct', id: string } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } } | null, bookableItem: { __typename: 'CourtBookableItem' } | { __typename: 'EventBookableItem', id: string, activityName: string, eventType: EventType, cancellationCondition: string, description: { __typename: 'FormattedText', plainText: string } | null, sport: { __typename: 'Sport', name: string }, eventSessions: Array<{ __typename: 'EventSession', id: string, name: string, start: string, end: string, hasOnlineStream: boolean, court: { __typename: 'Court', id: string, name: string } | null, trainer: { __typename: 'Trainer', id: string, nickname: string } | null }>, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } }, trainer: Array<{ __typename: 'Trainer', id: string, firstName: string | null, nickname: string }> | null, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string }, activityImage: { __typename: 'Image', large: string } | null, floorPlan: { __typename: 'AssignedFloorPlan', id: string } | null }, trainer: { __typename: 'Trainer', id: string, nickname: string, firstName: string | null } | null, timeRange: { __typename: 'TimeRange', start: string, end: string } | null } | { __typename: 'ProductCartItem', id: string, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } | { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } | { __typename: 'Recording', id: string, description: string | null, availableUntil: string | null, name: string, recordingStartDate: string | null, recordingEndDate: string | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, image: { __typename: 'Image', large: string } | null, trainer: { __typename: 'Trainer', id: string, nickname: string } | null } | { __typename: 'Voucher', id: string, name: string, conditions: string | null, value: { __typename: 'MonetaryValue', value: number, currency: string }, validityInterval: { __typename: 'Interval', type: IntervalUnit, value: number } | null, image: { __typename: 'Image', large: string } | null } }> } };

export type UseBookingDetailsOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type UseBookingDetailsOrderQuery = { order: { __typename: 'Order', id: string, invoice: { __typename: 'Invoice', number: string } | null, venue: { __typename: 'Venue', id: string, name: string, images: Array<{ __typename: 'Image', large: string }>, location: { __typename: 'Location', street: string, zip: string, city: string, detail: string } }, items: Array<{ __typename: 'AssignedProductOrderItem', endPrice: number, reduction: number, quantity: number, confirmedWith: { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } } | null, purchasedWith: { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket' } | null, assignedProduct: { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } } | { __typename: 'AssignedRecording', id: string, product: { __typename: 'Recording', id: string, description: string | null, availableUntil: string | null, name: string, recordingStartDate: string | null, recordingEndDate: string | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, image: { __typename: 'Image', large: string } | null, trainer: { __typename: 'Trainer', id: string, nickname: string } | null } } | { __typename: 'AssignedVoucher', id: string, product: { __typename: 'Voucher', id: string, name: string, conditions: string | null, value: { __typename: 'MonetaryValue', value: number, currency: string }, validityInterval: { __typename: 'Interval', type: IntervalUnit, value: number } | null, image: { __typename: 'Image', large: string } | null } } | { __typename: 'GenericAssignedProduct', id: string } } | { __typename: 'BookingOrderItem', confirmedWith: { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } } | null, purchasedWith: { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, earlyBirdUntil: string | null, lastMinuteFrom: string | null, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } | null }>, standardPrice: { __typename: 'MonetaryValue', value: number, currency: string }, earlyBirdPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, lastMinutePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, productPurchaseInformation: { __typename: 'ProductPurchaseInformation', purchasable: boolean, additionalInformation: string | null } } | null, booking: { __typename: 'CourtBooking' } | { __typename: 'EventBooking', assignedSpot: { __typename: 'Spot', id: string, label: string } | null, bookableItem: { __typename: 'EventBookableItem', id: string, activityName: string, eventType: EventType, cancellationCondition: string, description: { __typename: 'FormattedText', plainText: string } | null, sport: { __typename: 'Sport', name: string }, eventSessions: Array<{ __typename: 'EventSession', id: string, name: string, start: string, end: string, hasOnlineStream: boolean, court: { __typename: 'Court', id: string, name: string } | null, trainer: { __typename: 'Trainer', id: string, nickname: string } | null }>, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } }, trainer: Array<{ __typename: 'Trainer', id: string, firstName: string | null, nickname: string }> | null, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string }, activityImage: { __typename: 'Image', large: string } | null, floorPlan: { __typename: 'AssignedFloorPlan', id: string } | null } } } | { __typename: 'BookingRequestOrderItem', bookableItem: { __typename: 'EventBookableItem', id: string, activityName: string, eventType: EventType, cancellationCondition: string, description: { __typename: 'FormattedText', plainText: string } | null, sport: { __typename: 'Sport', name: string }, eventSessions: Array<{ __typename: 'EventSession', id: string, name: string, start: string, end: string, hasOnlineStream: boolean, court: { __typename: 'Court', id: string, name: string } | null, trainer: { __typename: 'Trainer', id: string, nickname: string } | null }>, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string } }, trainer: Array<{ __typename: 'Trainer', id: string, firstName: string | null, nickname: string }> | null, location: { __typename: 'Location', street: string, zip: string, city: string, country: string, detail: string }, activityImage: { __typename: 'Image', large: string } | null, floorPlan: { __typename: 'AssignedFloorPlan', id: string } | null }, trainer: { __typename: 'Trainer', id: string, nickname: string, firstName: string | null } | null, timeRange: { __typename: 'TimeRange', start: string, end: string } | null, confirmedWith: { __typename: 'AssignedCard', id: string, validUntil: string | null, usagesLeft: number | null, totalUsages: number | null, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Card', id: string, name: string, cardType: CardType, description: string | null, isTrialCard: boolean, isCorporatePrice: boolean, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, validity: { __typename: 'Validity', startType: ValidityStartType, startDate: string | null, duration: { __typename: 'Interval', type: IntervalUnit, value: number } } | null, price: { __typename: 'MonetaryValue', value: number, currency: string }, originalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, venues: Array<{ __typename: 'Venue', name: string }>, activities: Array<{ __typename: 'Activity', id: string, name: string }>, sports: Array<{ __typename: 'Sport', name: string }>, availabilities: Array<{ __typename: 'Availability', start: string, end: string, periods: Array<{ __typename: 'AvailabilityPeriod', weekdays: Array<Weekday>, start: string, end: string }> }> } } | { __typename: 'AssignedMembership', id: string, assignedProductValidity: { __typename: 'AssignedProductValidity', isValid: boolean, additionalInformation: string | null, usageLimitPeriod: { __typename: 'UsageLimitPeriod', start: string, end: string, allowedBookings: number, usedBookings: number } | null }, product: { __typename: 'Membership', id: string, name: string, description: string | null, conditions: string | null, paymentAndCancellationTerms: string | null, activities: Array<{ __typename: 'Activity', id: string, name: string }>, usages: Array<{ __typename: 'UsageLimit', usageLimit: number, type: UsageLimitType, unit: UsageLimitUnit, currency: string | null, repeating: { __typename: 'Repeating', isTransferable: boolean, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }>, runtime: { __typename: 'Runtime', pausable: boolean, initial: { __typename: 'Interval', type: IntervalUnit, value: number }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', type: IntervalUnit, value: number }, cancellation: { __typename: 'Interval', type: IntervalUnit, value: number } } | null }, paymentPlan: { __typename: 'PaymentPlan', offset: number | null, initial: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurring: { __typename: 'MonetaryValue', value: number, currency: string }, interval: { __typename: 'Interval', type: IntervalUnit, value: number }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null }, partialPriceInformation: { __typename: 'PartialPriceInformation', price: { __typename: 'MonetaryValue', value: number, currency: string }, timeRange: { __typename: 'TimeRange', start: string, end: string } } | null, venues: Array<{ __typename: 'Venue', name: string }> } } | null }> } };

export type UseCartCreationHandlerCreateCartFromEventBookableItemMutationVariables = Exact<{
  bookableItemId: Scalars['ID']['input'];
  origin: Origin;
  clientMetadata?: InputMaybe<ClientMetadataInput>;
}>;


export type UseCartCreationHandlerCreateCartFromEventBookableItemMutation = { createCartFromEventBookableItem: { __typename: 'Cart', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutationVariables = Exact<{
  privateSessionOfferId: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  origin: Origin;
  clientMetadata?: InputMaybe<ClientMetadataInput>;
  trainerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutation = { createCartFromPrivateSessionOffer: { __typename: 'Cart', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type UseCartCreationHandlerCreateCartFromCourtBookableItemMutationVariables = Exact<{
  courtId: Scalars['ID']['input'];
  sportId: Scalars['ID']['input'];
  start: Scalars['String']['input'];
  end: Scalars['String']['input'];
  origin: Origin;
  clientMetadata?: InputMaybe<ClientMetadataInput>;
}>;


export type UseCartCreationHandlerCreateCartFromCourtBookableItemMutation = { createCartFromCourtBookableItem: { __typename: 'Cart', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type UseCartCreationHandlerCreateCartFromProductMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  origin: Origin;
  venueId: Scalars['ID']['input'];
  clientMetadata?: InputMaybe<ClientMetadataInput>;
}>;


export type UseCartCreationHandlerCreateCartFromProductMutation = { createCartFromProduct: { __typename: 'Cart', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type UseCartCreationHandlerCreateCartFromVoucherMutationVariables = Exact<{
  amount: Scalars['Int']['input'];
  venueId: Scalars['ID']['input'];
  imageId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  origin: Origin;
  clientMetadata?: InputMaybe<ClientMetadataInput>;
}>;


export type UseCartCreationHandlerCreateCartFromVoucherMutation = { createCartFromVoucher: { __typename: 'Cart', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type UseCartCreationHandlerTrackCheckoutStartMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  deviceId: Scalars['String']['input'];
  sessionId: Scalars['Float']['input'];
  userTrackingId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UseCartCreationHandlerTrackCheckoutStartMutation = { trackCheckoutStart: boolean };

export type UseConfirmationActionsOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type UseConfirmationActionsOrderQuery = { order: { __typename: 'Order', id: string, items: Array<{ __typename: 'AssignedProductOrderItem', assignedProduct: { __typename: 'AssignedCard', id: string } | { __typename: 'AssignedMembership', id: string } | { __typename: 'AssignedRecording', id: string, product: { __typename: 'Recording', id: string } } | { __typename: 'AssignedVoucher', id: string, code: string } | { __typename: 'GenericAssignedProduct', id: string } } | { __typename: 'BookingOrderItem', booking: { __typename: 'CourtBooking' } | { __typename: 'EventBooking', id: string, participations: { __typename: 'EventSessionParticipationConnection', nodes: Array<{ __typename: 'EventSessionParticipation', id: string }> }, bookableItem: { __typename: 'EventBookableItem', eventType: EventType, floorPlan: { __typename: 'AssignedFloorPlan', id: string } | null } } } | { __typename: 'BookingRequestOrderItem', endPrice: number }>, venue: { __typename: 'Venue', id: string, name: string, shortId: string, slug: string, company: { __typename: 'Company', id: string } } } };

export type UseCountriesCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type UseCountriesCountriesQuery = { countries: Array<{ __typename: 'Country', iso: string, name: string }> };

export type UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables = Exact<{ [key: string]: never; }>;


export type UseEnabledFeaturePreviewsFeaturePreviewsQuery = { featurePreviews: Array<{ __typename: 'FeaturePreview', id: string, name: string }> };

export type UseFamilyAccountMeQueryVariables = Exact<{ [key: string]: never; }>;


export type UseFamilyAccountMeQuery = { me: { __typename: 'User', id: string, firstName: string, lastName: string, email: string, family: { __typename: 'Family', id: string, owner: { __typename: 'User', id: string, firstName: string, lastName: string, email: string, profilePicture: { __typename: 'Image', small: string } | null } } | null, profilePicture: { __typename: 'Image', small: string } | null } | null };

export type MedicalCertificateCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type MedicalCertificateCartQuery = { cart: { __typename: 'Cart', medicalCertificateRequired: boolean, customer: { __typename: 'Customer', medicalCertificate: { __typename: 'CustomerMedicalCertificate', status: CustomerMedicalCertificateStatus, validityDate: string | null } | null } | null } };

export type UseSummaryCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type UseSummaryCartQuery = { cart: { __typename: 'Cart', id: string, isVoucherEnabled: boolean, items: Array<{ __typename: 'BookableItemCartItem', id: string, settleWith: { __typename: 'AssignedCard', id: string } | { __typename: 'AssignedMembership', id: string } | { __typename: 'Card', id: string } | { __typename: 'GenericAssignedProduct', id: string } | { __typename: 'Membership', id: string } | { __typename: 'SinglePurchase', id: string } | { __typename: 'Ticket', id: string } | null, bookableItem: { __typename: 'CourtBookableItem' } | { __typename: 'EventBookableItem', id: string, floorPlan: { __typename: 'AssignedFloorPlan', id: string } | null } } | { __typename: 'ProductCartItem', id: string, settleWith: { __typename: 'AssignedCard', id: string } | { __typename: 'AssignedMembership', id: string } | { __typename: 'Card', id: string } | { __typename: 'GenericAssignedProduct', id: string } | { __typename: 'Membership', id: string } | { __typename: 'SinglePurchase', id: string } | { __typename: 'Ticket', id: string } | null }>, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number, currency: string } | null, itemsV3: Array<{ __typename: 'PriceTableItemAddon', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemBasic', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemBudget', name: string, amount: number, budgetName: string, corporateName: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemMembership', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurringPrice: { __typename: 'MonetaryValue', value: number, currency: string }, partialPriceTimeRange: { __typename: 'TimeRange', start: string, end: string } | null, paymentInterval: { __typename: 'Interval', value: number, type: IntervalUnit } | null, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null } | { __typename: 'PriceTableItemSpecialPrice', name: string, amount: number, specialPriceType: SpecialPriceType, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemVoucher', name: string, amount: number, code: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null }> } | null } };

export type UseSummaryOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type UseSummaryOrderQuery = { order: { __typename: 'Order', id: string, isVoucherEnabled: boolean, priceTable: { __typename: 'PriceTable', total: { __typename: 'MonetaryValue', value: number, currency: string } | null, itemsV3: Array<{ __typename: 'PriceTableItemAddon', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemBasic', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemBudget', name: string, amount: number, budgetName: string, corporateName: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemMembership', name: string, amount: number, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, recurringPrice: { __typename: 'MonetaryValue', value: number, currency: string }, partialPriceTimeRange: { __typename: 'TimeRange', start: string, end: string } | null, paymentInterval: { __typename: 'Interval', value: number, type: IntervalUnit } | null, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | null } | { __typename: 'PriceTableItemSpecialPrice', name: string, amount: number, specialPriceType: SpecialPriceType, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null } | { __typename: 'PriceTableItemVoucher', name: string, amount: number, code: string, singlePrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, totalPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null }> }, items: Array<{ __typename: 'AssignedProductOrderItem' } | { __typename: 'BookingOrderItem', booking: { __typename: 'CourtBooking' } | { __typename: 'EventBooking', bookableItem: { __typename: 'EventBookableItem', id: string, floorPlan: { __typename: 'AssignedFloorPlan', id: string } | null } } } | { __typename: 'BookingRequestOrderItem' }> } };

export type UseVenueEnabledFeaturePreviewsVenueQueryVariables = Exact<{
  venueId: Scalars['ID']['input'];
}>;


export type UseVenueEnabledFeaturePreviewsVenueQuery = { venue: { __typename: 'Venue', id: string, enabledFeatures: Array<{ __typename: 'FeaturePreview', id: string, name: string }> } };

export const CourtBookableItemAttributesFragmentDoc = gql`
    fragment courtBookableItemAttributes on CourtBookableItem {
  id
  sport {
    name
  }
  court {
    name
  }
  timeRange {
    start
    end
  }
  venue {
    id
    name
    location {
      street
      zip
      city
      country
    }
  }
  activityImage {
    large
  }
  cancellationCondition
}
    `;
export const EventBookableItemAttributesFragmentDoc = gql`
    fragment eventBookableItemAttributes on EventBookableItem {
  id
  activityName
  eventType
  description {
    plainText
  }
  sport {
    name
  }
  eventSessions {
    id
    name
    start
    end
    hasOnlineStream
    court {
      id
      name
    }
    trainer {
      id
      nickname
    }
  }
  venue {
    id
    name
    location {
      street
      zip
      city
      country
      detail
    }
  }
  trainer {
    id
    firstName
    nickname
  }
  location {
    street
    zip
    city
    country
    detail
  }
  activityImage {
    large
  }
  cancellationCondition
  floorPlan {
    id
  }
}
    `;
export const PriceTableItemBasicAttributesFragmentDoc = gql`
    fragment priceTableItemBasicAttributes on PriceTableItemBasic {
  name
  amount
  singlePrice {
    value
    currency
  }
  totalPrice {
    value
    currency
  }
}
    `;
export const PriceTableItemAddonAttributesFragmentDoc = gql`
    fragment priceTableItemAddonAttributes on PriceTableItemAddon {
  name
  amount
  singlePrice {
    value
    currency
  }
  totalPrice {
    value
    currency
  }
}
    `;
export const PriceTableItemVoucherAttributesFragmentDoc = gql`
    fragment priceTableItemVoucherAttributes on PriceTableItemVoucher {
  name
  amount
  singlePrice {
    value
    currency
  }
  totalPrice {
    value
    currency
  }
  code
}
    `;
export const PriceTableItemMembershipAttributesFragmentDoc = gql`
    fragment priceTableItemMembershipAttributes on PriceTableItemMembership {
  name
  amount
  singlePrice {
    value
    currency
  }
  totalPrice {
    value
    currency
  }
  recurringPrice {
    value
    currency
  }
  partialPriceTimeRange {
    start
    end
  }
  paymentInterval {
    value
    type
  }
  promotion {
    period {
      type
      value
    }
    price {
      value
      currency
    }
  }
}
    `;
export const PriceTableItemBudgetAttributesFragmentDoc = gql`
    fragment priceTableItemBudgetAttributes on PriceTableItemBudget {
  name
  amount
  budgetName
  corporateName
  singlePrice {
    value
    currency
  }
  totalPrice {
    value
    currency
  }
}
    `;
export const PriceTableItemSpecialPriceAttributesFragmentDoc = gql`
    fragment priceTableItemSpecialPriceAttributes on PriceTableItemSpecialPrice {
  name
  amount
  singlePrice {
    value
    currency
  }
  totalPrice {
    value
    currency
  }
  specialPriceType
}
    `;
export const VoucherAttributesFragmentDoc = gql`
    fragment voucherAttributes on Voucher {
  id
  value {
    value
    currency
  }
  name
  validityInterval {
    type
    value
  }
  conditions
  image {
    large
  }
}
    `;
export const TicketAttributesFragmentDoc = gql`
    fragment ticketAttributes on Ticket {
  id
  name
  currentPriceType
  earlyBirdUntil
  lastMinuteFrom
  validForSessions {
    id
    start
    end
    name
    location {
      street
      zip
      city
      country
      detail
    }
  }
  standardPrice {
    value
    currency
  }
  earlyBirdPrice {
    value
    currency
  }
  lastMinutePrice {
    value
    currency
  }
  productPurchaseInformation {
    purchasable
    additionalInformation
  }
}
    `;
export const SinglePurchaseAttributesFragmentDoc = gql`
    fragment singlePurchaseAttributes on SinglePurchase {
  id
  price {
    value
    currency
  }
  name
}
    `;
export const RecordingAttributesFragmentDoc = gql`
    fragment recordingAttributes on Recording {
  id
  price {
    value
    currency
  }
  description
  availableUntil
  name
  recordingStartDate
  recordingEndDate
  image {
    large
  }
  trainer {
    id
    nickname
  }
}
    `;
export const CardAttributesFragmentDoc = gql`
    fragment cardAttributes on Card {
  id
  name
  cardType
  description
  isTrialCard
  isCorporatePrice
  usages {
    usageLimit
    type
    unit
    currency
    repeating {
      interval {
        type
        value
      }
      isTransferable
    }
  }
  validity {
    startType
    startDate
    duration {
      type
      value
    }
  }
  price {
    value
    currency
  }
  originalPrice {
    value
    currency
  }
  venues {
    name
  }
  activities {
    id
    name
  }
  sports {
    name
  }
  availabilities {
    start
    end
    periods {
      weekdays
      start
      end
    }
  }
}
    `;
export const AssignedCardAttributesFragmentDoc = gql`
    fragment assignedCardAttributes on AssignedCard {
  id
  assignedProductValidity {
    isValid
    additionalInformation
    usageLimitPeriod {
      start
      end
      allowedBookings
      usedBookings
    }
  }
  validUntil
  usagesLeft
  totalUsages
  product {
    ...cardAttributes
  }
}
    ${CardAttributesFragmentDoc}`;
export const MembershipAttributesFragmentDoc = gql`
    fragment membershipAttributes on Membership {
  id
  name
  description
  conditions
  paymentAndCancellationTerms
  activities {
    id
    name
  }
  usages {
    usageLimit
    type
    unit
    currency
    repeating {
      interval {
        type
        value
      }
      isTransferable
    }
  }
  runtime {
    initial {
      type
      value
    }
    renewal {
      interval {
        type
        value
      }
      cancellation {
        type
        value
      }
    }
    pausable
  }
  paymentPlan {
    initial {
      value
      currency
    }
    recurring {
      value
      currency
    }
    interval {
      type
      value
    }
    promotion {
      period {
        type
        value
      }
      price {
        value
        currency
      }
    }
    offset
  }
  partialPriceInformation {
    price {
      value
      currency
    }
    timeRange {
      start
      end
    }
  }
  venues {
    name
  }
}
    `;
export const AssignedMembershipAttributesFragmentDoc = gql`
    fragment assignedMembershipAttributes on AssignedMembership {
  id
  assignedProductValidity {
    isValid
    additionalInformation
    usageLimitPeriod {
      start
      end
      allowedBookings
      usedBookings
    }
  }
  product {
    ...membershipAttributes
  }
}
    ${MembershipAttributesFragmentDoc}`;
export const BaseUserAttributesFragmentDoc = gql`
    fragment baseUserAttributes on User {
  id
  firstName
  lastName
  email
  profilePicture {
    small
  }
}
    `;
export const UserAttributesFragmentDoc = gql`
    fragment userAttributes on User {
  ...baseUserAttributes
  family {
    id
    owner {
      ...baseUserAttributes
    }
  }
}
    ${BaseUserAttributesFragmentDoc}`;
export const EnsureLoggedInUserMeQueryDocument = gql`
    query EnsureLoggedInUserMeQuery {
  me {
    id
    firstName
    hasVerifiedEmail
  }
}
    `;

/**
 * __useEnsureLoggedInUserMeQueryQuery__
 *
 * To run a query within a React component, call `useEnsureLoggedInUserMeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnsureLoggedInUserMeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnsureLoggedInUserMeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnsureLoggedInUserMeQueryQuery(baseOptions?: Apollo.QueryHookOptions<EnsureLoggedInUserMeQueryQuery, EnsureLoggedInUserMeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnsureLoggedInUserMeQueryQuery, EnsureLoggedInUserMeQueryQueryVariables>(EnsureLoggedInUserMeQueryDocument, options);
      }
export function useEnsureLoggedInUserMeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnsureLoggedInUserMeQueryQuery, EnsureLoggedInUserMeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnsureLoggedInUserMeQueryQuery, EnsureLoggedInUserMeQueryQueryVariables>(EnsureLoggedInUserMeQueryDocument, options);
        }
export function useEnsureLoggedInUserMeQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnsureLoggedInUserMeQueryQuery, EnsureLoggedInUserMeQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnsureLoggedInUserMeQueryQuery, EnsureLoggedInUserMeQueryQueryVariables>(EnsureLoggedInUserMeQueryDocument, options);
        }
export type EnsureLoggedInUserMeQueryQueryHookResult = ReturnType<typeof useEnsureLoggedInUserMeQueryQuery>;
export type EnsureLoggedInUserMeQueryLazyQueryHookResult = ReturnType<typeof useEnsureLoggedInUserMeQueryLazyQuery>;
export type EnsureLoggedInUserMeQuerySuspenseQueryHookResult = ReturnType<typeof useEnsureLoggedInUserMeQuerySuspenseQuery>;
export type EnsureLoggedInUserMeQueryQueryResult = Apollo.QueryResult<EnsureLoggedInUserMeQueryQuery, EnsureLoggedInUserMeQueryQueryVariables>;
export const AddOnsCartDocument = gql`
    query AddOnsCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    valid
    items {
      ... on BookableItemCartItem {
        id
        addOns {
          id
          description
          fields {
            ... on NumberAddOnField {
              id
              description
              price {
                value
                currency
              }
            }
            ... on TextAddOnField {
              id
              description
              price {
                value
                currency
              }
            }
            ... on SelectAddOnField {
              id
              description
              selectionType
              options {
                id
                description
                price {
                  value
                  currency
                }
              }
            }
          }
          mandatory
        }
        addOnsInput {
          id
          fields {
            id
            numberValue
            textValue
            singleSelectionValue
            multiSelectionValue
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAddOnsCartQuery__
 *
 * To run a query within a React component, call `useAddOnsCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddOnsCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddOnsCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useAddOnsCartQuery(baseOptions: Apollo.QueryHookOptions<AddOnsCartQuery, AddOnsCartQueryVariables> & ({ variables: AddOnsCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddOnsCartQuery, AddOnsCartQueryVariables>(AddOnsCartDocument, options);
      }
export function useAddOnsCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddOnsCartQuery, AddOnsCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddOnsCartQuery, AddOnsCartQueryVariables>(AddOnsCartDocument, options);
        }
export function useAddOnsCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddOnsCartQuery, AddOnsCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddOnsCartQuery, AddOnsCartQueryVariables>(AddOnsCartDocument, options);
        }
export type AddOnsCartQueryHookResult = ReturnType<typeof useAddOnsCartQuery>;
export type AddOnsCartLazyQueryHookResult = ReturnType<typeof useAddOnsCartLazyQuery>;
export type AddOnsCartSuspenseQueryHookResult = ReturnType<typeof useAddOnsCartSuspenseQuery>;
export type AddOnsCartQueryResult = Apollo.QueryResult<AddOnsCartQuery, AddOnsCartQueryVariables>;
export const AddOnsSetAddOnsForBookableItemCartItemDocument = gql`
    mutation AddOnsSetAddOnsForBookableItemCartItem($cartId: ID!, $itemId: ID!, $addOns: [AddOnInputInput!]!) {
  setAddOnsForBookableItemCartItem(
    cartId: $cartId
    itemId: $itemId
    addOns: $addOns
  ) {
    ... on Cart {
      id
      priceTable {
        total {
          value
          currency
        }
        itemsV3 {
          ... on PriceTableItemBasic {
            ...priceTableItemBasicAttributes
          }
          ... on PriceTableItemAddon {
            ...priceTableItemAddonAttributes
          }
          ... on PriceTableItemVoucher {
            ...priceTableItemVoucherAttributes
          }
          ... on PriceTableItemMembership {
            ...priceTableItemMembershipAttributes
          }
          ... on PriceTableItemBudget {
            ...priceTableItemBudgetAttributes
          }
          ... on PriceTableItemSpecialPrice {
            ...priceTableItemSpecialPriceAttributes
          }
        }
      }
      items {
        ... on BookableItemCartItem {
          id
          addOnsInput {
            id
            fields {
              id
              numberValue
              textValue
              singleSelectionValue
              multiSelectionValue
            }
          }
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    ${PriceTableItemBasicAttributesFragmentDoc}
${PriceTableItemAddonAttributesFragmentDoc}
${PriceTableItemVoucherAttributesFragmentDoc}
${PriceTableItemMembershipAttributesFragmentDoc}
${PriceTableItemBudgetAttributesFragmentDoc}
${PriceTableItemSpecialPriceAttributesFragmentDoc}`;
export type AddOnsSetAddOnsForBookableItemCartItemMutationFn = Apollo.MutationFunction<AddOnsSetAddOnsForBookableItemCartItemMutation, AddOnsSetAddOnsForBookableItemCartItemMutationVariables>;

/**
 * __useAddOnsSetAddOnsForBookableItemCartItemMutation__
 *
 * To run a mutation, you first call `useAddOnsSetAddOnsForBookableItemCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOnsSetAddOnsForBookableItemCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOnsSetAddOnsForBookableItemCartItemMutation, { data, loading, error }] = useAddOnsSetAddOnsForBookableItemCartItemMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      itemId: // value for 'itemId'
 *      addOns: // value for 'addOns'
 *   },
 * });
 */
export function useAddOnsSetAddOnsForBookableItemCartItemMutation(baseOptions?: Apollo.MutationHookOptions<AddOnsSetAddOnsForBookableItemCartItemMutation, AddOnsSetAddOnsForBookableItemCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOnsSetAddOnsForBookableItemCartItemMutation, AddOnsSetAddOnsForBookableItemCartItemMutationVariables>(AddOnsSetAddOnsForBookableItemCartItemDocument, options);
      }
export type AddOnsSetAddOnsForBookableItemCartItemMutationHookResult = ReturnType<typeof useAddOnsSetAddOnsForBookableItemCartItemMutation>;
export type AddOnsSetAddOnsForBookableItemCartItemMutationResult = Apollo.MutationResult<AddOnsSetAddOnsForBookableItemCartItemMutation>;
export type AddOnsSetAddOnsForBookableItemCartItemMutationOptions = Apollo.BaseMutationOptions<AddOnsSetAddOnsForBookableItemCartItemMutation, AddOnsSetAddOnsForBookableItemCartItemMutationVariables>;
export const MultiAnswerPatronQuestionCartDocument = gql`
    query MultiAnswerPatronQuestionCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    patronQuestionType
    multiAnswerPatronQuestionInput
    venue {
      id
      name
    }
  }
}
    `;

/**
 * __useMultiAnswerPatronQuestionCartQuery__
 *
 * To run a query within a React component, call `useMultiAnswerPatronQuestionCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultiAnswerPatronQuestionCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultiAnswerPatronQuestionCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useMultiAnswerPatronQuestionCartQuery(baseOptions: Apollo.QueryHookOptions<MultiAnswerPatronQuestionCartQuery, MultiAnswerPatronQuestionCartQueryVariables> & ({ variables: MultiAnswerPatronQuestionCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MultiAnswerPatronQuestionCartQuery, MultiAnswerPatronQuestionCartQueryVariables>(MultiAnswerPatronQuestionCartDocument, options);
      }
export function useMultiAnswerPatronQuestionCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MultiAnswerPatronQuestionCartQuery, MultiAnswerPatronQuestionCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MultiAnswerPatronQuestionCartQuery, MultiAnswerPatronQuestionCartQueryVariables>(MultiAnswerPatronQuestionCartDocument, options);
        }
export function useMultiAnswerPatronQuestionCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MultiAnswerPatronQuestionCartQuery, MultiAnswerPatronQuestionCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MultiAnswerPatronQuestionCartQuery, MultiAnswerPatronQuestionCartQueryVariables>(MultiAnswerPatronQuestionCartDocument, options);
        }
export type MultiAnswerPatronQuestionCartQueryHookResult = ReturnType<typeof useMultiAnswerPatronQuestionCartQuery>;
export type MultiAnswerPatronQuestionCartLazyQueryHookResult = ReturnType<typeof useMultiAnswerPatronQuestionCartLazyQuery>;
export type MultiAnswerPatronQuestionCartSuspenseQueryHookResult = ReturnType<typeof useMultiAnswerPatronQuestionCartSuspenseQuery>;
export type MultiAnswerPatronQuestionCartQueryResult = Apollo.QueryResult<MultiAnswerPatronQuestionCartQuery, MultiAnswerPatronQuestionCartQueryVariables>;
export const MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartDocument = gql`
    mutation MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCart($cartId: ID!, $patronageAnswer: PatronageAnswer!) {
  setMultiAnswerPatronQuestionOnCart(
    cartId: $cartId
    patronageAnswer: $patronageAnswer
  ) {
    ... on Cart {
      id
      multiAnswerPatronQuestionInput
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutationFn = Apollo.MutationFunction<MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation, MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutationVariables>;

/**
 * __useMultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation__
 *
 * To run a mutation, you first call `useMultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [multiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation, { data, loading, error }] = useMultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      patronageAnswer: // value for 'patronageAnswer'
 *   },
 * });
 */
export function useMultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation(baseOptions?: Apollo.MutationHookOptions<MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation, MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation, MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutationVariables>(MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartDocument, options);
      }
export type MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutationHookResult = ReturnType<typeof useMultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation>;
export type MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutationResult = Apollo.MutationResult<MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation>;
export type MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutationOptions = Apollo.BaseMutationOptions<MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutation, MultiAnswerPatronQuestionSetMultiAnswerPatronQuestionOnCartMutationVariables>;
export const PatronQuestionCartDocument = gql`
    query PatronQuestionCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    patronQuestionType
    patronQuestionInput
    venue {
      id
      name
    }
  }
}
    `;

/**
 * __usePatronQuestionCartQuery__
 *
 * To run a query within a React component, call `usePatronQuestionCartQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatronQuestionCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatronQuestionCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function usePatronQuestionCartQuery(baseOptions: Apollo.QueryHookOptions<PatronQuestionCartQuery, PatronQuestionCartQueryVariables> & ({ variables: PatronQuestionCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatronQuestionCartQuery, PatronQuestionCartQueryVariables>(PatronQuestionCartDocument, options);
      }
export function usePatronQuestionCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatronQuestionCartQuery, PatronQuestionCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatronQuestionCartQuery, PatronQuestionCartQueryVariables>(PatronQuestionCartDocument, options);
        }
export function usePatronQuestionCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PatronQuestionCartQuery, PatronQuestionCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PatronQuestionCartQuery, PatronQuestionCartQueryVariables>(PatronQuestionCartDocument, options);
        }
export type PatronQuestionCartQueryHookResult = ReturnType<typeof usePatronQuestionCartQuery>;
export type PatronQuestionCartLazyQueryHookResult = ReturnType<typeof usePatronQuestionCartLazyQuery>;
export type PatronQuestionCartSuspenseQueryHookResult = ReturnType<typeof usePatronQuestionCartSuspenseQuery>;
export type PatronQuestionCartQueryResult = Apollo.QueryResult<PatronQuestionCartQuery, PatronQuestionCartQueryVariables>;
export const PatronQuestionSetPatronQuestionOnCartDocument = gql`
    mutation PatronQuestionSetPatronQuestionOnCart($cartId: ID!, $isPatron: Boolean!) {
  setPatronQuestionOnCart(cartId: $cartId, isPatron: $isPatron) {
    ... on Cart {
      id
      patronQuestionInput
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type PatronQuestionSetPatronQuestionOnCartMutationFn = Apollo.MutationFunction<PatronQuestionSetPatronQuestionOnCartMutation, PatronQuestionSetPatronQuestionOnCartMutationVariables>;

/**
 * __usePatronQuestionSetPatronQuestionOnCartMutation__
 *
 * To run a mutation, you first call `usePatronQuestionSetPatronQuestionOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatronQuestionSetPatronQuestionOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patronQuestionSetPatronQuestionOnCartMutation, { data, loading, error }] = usePatronQuestionSetPatronQuestionOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      isPatron: // value for 'isPatron'
 *   },
 * });
 */
export function usePatronQuestionSetPatronQuestionOnCartMutation(baseOptions?: Apollo.MutationHookOptions<PatronQuestionSetPatronQuestionOnCartMutation, PatronQuestionSetPatronQuestionOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatronQuestionSetPatronQuestionOnCartMutation, PatronQuestionSetPatronQuestionOnCartMutationVariables>(PatronQuestionSetPatronQuestionOnCartDocument, options);
      }
export type PatronQuestionSetPatronQuestionOnCartMutationHookResult = ReturnType<typeof usePatronQuestionSetPatronQuestionOnCartMutation>;
export type PatronQuestionSetPatronQuestionOnCartMutationResult = Apollo.MutationResult<PatronQuestionSetPatronQuestionOnCartMutation>;
export type PatronQuestionSetPatronQuestionOnCartMutationOptions = Apollo.BaseMutationOptions<PatronQuestionSetPatronQuestionOnCartMutation, PatronQuestionSetPatronQuestionOnCartMutationVariables>;
export const PoliciesCartDocument = gql`
    query PoliciesCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    policiesInput
    policies {
      id
      url
      type
      mandatory
    }
    venue {
      id
      name
    }
  }
}
    `;

/**
 * __usePoliciesCartQuery__
 *
 * To run a query within a React component, call `usePoliciesCartQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoliciesCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoliciesCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function usePoliciesCartQuery(baseOptions: Apollo.QueryHookOptions<PoliciesCartQuery, PoliciesCartQueryVariables> & ({ variables: PoliciesCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PoliciesCartQuery, PoliciesCartQueryVariables>(PoliciesCartDocument, options);
      }
export function usePoliciesCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PoliciesCartQuery, PoliciesCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PoliciesCartQuery, PoliciesCartQueryVariables>(PoliciesCartDocument, options);
        }
export function usePoliciesCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PoliciesCartQuery, PoliciesCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PoliciesCartQuery, PoliciesCartQueryVariables>(PoliciesCartDocument, options);
        }
export type PoliciesCartQueryHookResult = ReturnType<typeof usePoliciesCartQuery>;
export type PoliciesCartLazyQueryHookResult = ReturnType<typeof usePoliciesCartLazyQuery>;
export type PoliciesCartSuspenseQueryHookResult = ReturnType<typeof usePoliciesCartSuspenseQuery>;
export type PoliciesCartQueryResult = Apollo.QueryResult<PoliciesCartQuery, PoliciesCartQueryVariables>;
export const PoliciesSetPoliciesOnCartDocument = gql`
    mutation PoliciesSetPoliciesOnCart($cartId: ID!, $policies: [ID!]!) {
  setPoliciesOnCart(cartId: $cartId, policies: $policies) {
    ... on Cart {
      id
      policiesInput
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type PoliciesSetPoliciesOnCartMutationFn = Apollo.MutationFunction<PoliciesSetPoliciesOnCartMutation, PoliciesSetPoliciesOnCartMutationVariables>;

/**
 * __usePoliciesSetPoliciesOnCartMutation__
 *
 * To run a mutation, you first call `usePoliciesSetPoliciesOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePoliciesSetPoliciesOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [policiesSetPoliciesOnCartMutation, { data, loading, error }] = usePoliciesSetPoliciesOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      policies: // value for 'policies'
 *   },
 * });
 */
export function usePoliciesSetPoliciesOnCartMutation(baseOptions?: Apollo.MutationHookOptions<PoliciesSetPoliciesOnCartMutation, PoliciesSetPoliciesOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PoliciesSetPoliciesOnCartMutation, PoliciesSetPoliciesOnCartMutationVariables>(PoliciesSetPoliciesOnCartDocument, options);
      }
export type PoliciesSetPoliciesOnCartMutationHookResult = ReturnType<typeof usePoliciesSetPoliciesOnCartMutation>;
export type PoliciesSetPoliciesOnCartMutationResult = Apollo.MutationResult<PoliciesSetPoliciesOnCartMutation>;
export type PoliciesSetPoliciesOnCartMutationOptions = Apollo.BaseMutationOptions<PoliciesSetPoliciesOnCartMutation, PoliciesSetPoliciesOnCartMutationVariables>;
export const RequiredInformationCartDocument = gql`
    query RequiredInformationCart($cartId: ID!) {
  me {
    id
    location {
      country
    }
  }
  cart(id: $cartId) {
    id
    requiredInformation
    priceTable {
      total {
        value
        currency
      }
    }
    customer {
      id
      location {
        country
      }
    }
    requiredInformationInput {
      address {
        street
        zip
        city
        country
        detail
      }
      phoneNumber
      birthday
      fiscalCode
    }
    venue {
      id
      name
      location {
        country
      }
    }
    items {
      __typename
      ... on BookableItemCartItem {
        bookableItem {
          __typename
          ... on EventBookableItem {
            id
            eventType
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRequiredInformationCartQuery__
 *
 * To run a query within a React component, call `useRequiredInformationCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequiredInformationCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequiredInformationCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useRequiredInformationCartQuery(baseOptions: Apollo.QueryHookOptions<RequiredInformationCartQuery, RequiredInformationCartQueryVariables> & ({ variables: RequiredInformationCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequiredInformationCartQuery, RequiredInformationCartQueryVariables>(RequiredInformationCartDocument, options);
      }
export function useRequiredInformationCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequiredInformationCartQuery, RequiredInformationCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequiredInformationCartQuery, RequiredInformationCartQueryVariables>(RequiredInformationCartDocument, options);
        }
export function useRequiredInformationCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequiredInformationCartQuery, RequiredInformationCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequiredInformationCartQuery, RequiredInformationCartQueryVariables>(RequiredInformationCartDocument, options);
        }
export type RequiredInformationCartQueryHookResult = ReturnType<typeof useRequiredInformationCartQuery>;
export type RequiredInformationCartLazyQueryHookResult = ReturnType<typeof useRequiredInformationCartLazyQuery>;
export type RequiredInformationCartSuspenseQueryHookResult = ReturnType<typeof useRequiredInformationCartSuspenseQuery>;
export type RequiredInformationCartQueryResult = Apollo.QueryResult<RequiredInformationCartQuery, RequiredInformationCartQueryVariables>;
export const RequiredInformationSetRequiredInformationOnCartDocument = gql`
    mutation RequiredInformationSetRequiredInformationOnCart($cartId: ID!, $requiredInformation: RequiredInformationInput!) {
  setRequiredInformationOnCart(
    cartId: $cartId
    requiredInformation: $requiredInformation
  ) {
    ... on Cart {
      id
      requiredInformationInput {
        address {
          street
          zip
          city
          country
          detail
        }
        phoneNumber
        birthday
        fiscalCode
      }
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type RequiredInformationSetRequiredInformationOnCartMutationFn = Apollo.MutationFunction<RequiredInformationSetRequiredInformationOnCartMutation, RequiredInformationSetRequiredInformationOnCartMutationVariables>;

/**
 * __useRequiredInformationSetRequiredInformationOnCartMutation__
 *
 * To run a mutation, you first call `useRequiredInformationSetRequiredInformationOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequiredInformationSetRequiredInformationOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requiredInformationSetRequiredInformationOnCartMutation, { data, loading, error }] = useRequiredInformationSetRequiredInformationOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      requiredInformation: // value for 'requiredInformation'
 *   },
 * });
 */
export function useRequiredInformationSetRequiredInformationOnCartMutation(baseOptions?: Apollo.MutationHookOptions<RequiredInformationSetRequiredInformationOnCartMutation, RequiredInformationSetRequiredInformationOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequiredInformationSetRequiredInformationOnCartMutation, RequiredInformationSetRequiredInformationOnCartMutationVariables>(RequiredInformationSetRequiredInformationOnCartDocument, options);
      }
export type RequiredInformationSetRequiredInformationOnCartMutationHookResult = ReturnType<typeof useRequiredInformationSetRequiredInformationOnCartMutation>;
export type RequiredInformationSetRequiredInformationOnCartMutationResult = Apollo.MutationResult<RequiredInformationSetRequiredInformationOnCartMutation>;
export type RequiredInformationSetRequiredInformationOnCartMutationOptions = Apollo.BaseMutationOptions<RequiredInformationSetRequiredInformationOnCartMutation, RequiredInformationSetRequiredInformationOnCartMutationVariables>;
export const AvailablePaymentMethodsCartDocument = gql`
    query AvailablePaymentMethodsCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    paymentMethods {
      type
      name
    }
  }
}
    `;

/**
 * __useAvailablePaymentMethodsCartQuery__
 *
 * To run a query within a React component, call `useAvailablePaymentMethodsCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePaymentMethodsCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePaymentMethodsCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useAvailablePaymentMethodsCartQuery(baseOptions: Apollo.QueryHookOptions<AvailablePaymentMethodsCartQuery, AvailablePaymentMethodsCartQueryVariables> & ({ variables: AvailablePaymentMethodsCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailablePaymentMethodsCartQuery, AvailablePaymentMethodsCartQueryVariables>(AvailablePaymentMethodsCartDocument, options);
      }
export function useAvailablePaymentMethodsCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailablePaymentMethodsCartQuery, AvailablePaymentMethodsCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailablePaymentMethodsCartQuery, AvailablePaymentMethodsCartQueryVariables>(AvailablePaymentMethodsCartDocument, options);
        }
export function useAvailablePaymentMethodsCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailablePaymentMethodsCartQuery, AvailablePaymentMethodsCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailablePaymentMethodsCartQuery, AvailablePaymentMethodsCartQueryVariables>(AvailablePaymentMethodsCartDocument, options);
        }
export type AvailablePaymentMethodsCartQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsCartQuery>;
export type AvailablePaymentMethodsCartLazyQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsCartLazyQuery>;
export type AvailablePaymentMethodsCartSuspenseQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsCartSuspenseQuery>;
export type AvailablePaymentMethodsCartQueryResult = Apollo.QueryResult<AvailablePaymentMethodsCartQuery, AvailablePaymentMethodsCartQueryVariables>;
export const AvailablePaymentMethodsOrderDocument = gql`
    query AvailablePaymentMethodsOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    payment {
      id
      paymentMethods {
        type
        name
      }
    }
  }
}
    `;

/**
 * __useAvailablePaymentMethodsOrderQuery__
 *
 * To run a query within a React component, call `useAvailablePaymentMethodsOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePaymentMethodsOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePaymentMethodsOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAvailablePaymentMethodsOrderQuery(baseOptions: Apollo.QueryHookOptions<AvailablePaymentMethodsOrderQuery, AvailablePaymentMethodsOrderQueryVariables> & ({ variables: AvailablePaymentMethodsOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailablePaymentMethodsOrderQuery, AvailablePaymentMethodsOrderQueryVariables>(AvailablePaymentMethodsOrderDocument, options);
      }
export function useAvailablePaymentMethodsOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailablePaymentMethodsOrderQuery, AvailablePaymentMethodsOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailablePaymentMethodsOrderQuery, AvailablePaymentMethodsOrderQueryVariables>(AvailablePaymentMethodsOrderDocument, options);
        }
export function useAvailablePaymentMethodsOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailablePaymentMethodsOrderQuery, AvailablePaymentMethodsOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailablePaymentMethodsOrderQuery, AvailablePaymentMethodsOrderQueryVariables>(AvailablePaymentMethodsOrderDocument, options);
        }
export type AvailablePaymentMethodsOrderQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsOrderQuery>;
export type AvailablePaymentMethodsOrderLazyQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsOrderLazyQuery>;
export type AvailablePaymentMethodsOrderSuspenseQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsOrderSuspenseQuery>;
export type AvailablePaymentMethodsOrderQueryResult = Apollo.QueryResult<AvailablePaymentMethodsOrderQuery, AvailablePaymentMethodsOrderQueryVariables>;
export const BackButtonAbortOrderDocument = gql`
    mutation BackButtonAbortOrder($orderId: ID!) {
  abortOrder(orderId: $orderId) {
    ... on Order {
      id
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export type BackButtonAbortOrderMutationFn = Apollo.MutationFunction<BackButtonAbortOrderMutation, BackButtonAbortOrderMutationVariables>;

/**
 * __useBackButtonAbortOrderMutation__
 *
 * To run a mutation, you first call `useBackButtonAbortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackButtonAbortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backButtonAbortOrderMutation, { data, loading, error }] = useBackButtonAbortOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useBackButtonAbortOrderMutation(baseOptions?: Apollo.MutationHookOptions<BackButtonAbortOrderMutation, BackButtonAbortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackButtonAbortOrderMutation, BackButtonAbortOrderMutationVariables>(BackButtonAbortOrderDocument, options);
      }
export type BackButtonAbortOrderMutationHookResult = ReturnType<typeof useBackButtonAbortOrderMutation>;
export type BackButtonAbortOrderMutationResult = Apollo.MutationResult<BackButtonAbortOrderMutation>;
export type BackButtonAbortOrderMutationOptions = Apollo.BaseMutationOptions<BackButtonAbortOrderMutation, BackButtonAbortOrderMutationVariables>;
export const ConfirmationOrderDocument = gql`
    query ConfirmationOrder($orderId: ID!) {
  order(id: $orderId) {
    ... on Order {
      id
      amount {
        value
      }
      invoice {
        downloadLink
      }
      items {
        ... on AssignedProductOrderItem {
          assignedProduct {
            ... on AssignedProductInterface {
              id
            }
            ... on AssignedRecording {
              id
            }
            ... on AssignedVoucher {
              code
            }
            ... on GenericAssignedProduct {
              id
            }
          }
        }
        ... on BookingOrderItem {
          booking {
            ... on EventBooking {
              id
              bookableItem {
                id
                eventType
              }
            }
          }
        }
        ... on BookingRequestOrderItem {
          __typename
          confirmedWith {
            __typename
          }
          endPrice
        }
      }
      venue {
        id
        name
        shortId
        slug
        logo {
          large
        }
      }
      customer {
        id
        isSubscribedToNewsletter
      }
      isSelfCheckinAvailable
      state
    }
  }
}
    `;

/**
 * __useConfirmationOrderQuery__
 *
 * To run a query within a React component, call `useConfirmationOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmationOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmationOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useConfirmationOrderQuery(baseOptions: Apollo.QueryHookOptions<ConfirmationOrderQuery, ConfirmationOrderQueryVariables> & ({ variables: ConfirmationOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfirmationOrderQuery, ConfirmationOrderQueryVariables>(ConfirmationOrderDocument, options);
      }
export function useConfirmationOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfirmationOrderQuery, ConfirmationOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfirmationOrderQuery, ConfirmationOrderQueryVariables>(ConfirmationOrderDocument, options);
        }
export function useConfirmationOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfirmationOrderQuery, ConfirmationOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfirmationOrderQuery, ConfirmationOrderQueryVariables>(ConfirmationOrderDocument, options);
        }
export type ConfirmationOrderQueryHookResult = ReturnType<typeof useConfirmationOrderQuery>;
export type ConfirmationOrderLazyQueryHookResult = ReturnType<typeof useConfirmationOrderLazyQuery>;
export type ConfirmationOrderSuspenseQueryHookResult = ReturnType<typeof useConfirmationOrderSuspenseQuery>;
export type ConfirmationOrderQueryResult = Apollo.QueryResult<ConfirmationOrderQuery, ConfirmationOrderQueryVariables>;
export const InviteFriendsMeDocument = gql`
    query InviteFriendsMe($first: Int, $after: Cursor) {
  me {
    id
    handle
    friendsCount
    friends(first: $first, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          publicUser {
            id
            firstName
            lastName
            handle
            profilePicture {
              small
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useInviteFriendsMeQuery__
 *
 * To run a query within a React component, call `useInviteFriendsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteFriendsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteFriendsMeQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInviteFriendsMeQuery(baseOptions?: Apollo.QueryHookOptions<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>(InviteFriendsMeDocument, options);
      }
export function useInviteFriendsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>(InviteFriendsMeDocument, options);
        }
export function useInviteFriendsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>(InviteFriendsMeDocument, options);
        }
export type InviteFriendsMeQueryHookResult = ReturnType<typeof useInviteFriendsMeQuery>;
export type InviteFriendsMeLazyQueryHookResult = ReturnType<typeof useInviteFriendsMeLazyQuery>;
export type InviteFriendsMeSuspenseQueryHookResult = ReturnType<typeof useInviteFriendsMeSuspenseQuery>;
export type InviteFriendsMeQueryResult = Apollo.QueryResult<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>;
export const InviteFriendsShareEventDocument = gql`
    mutation InviteFriendsShareEvent($eventId: ID!, $userIds: [ID!]!) {
  shareEvent(eventId: $eventId, userIds: $userIds)
}
    `;
export type InviteFriendsShareEventMutationFn = Apollo.MutationFunction<InviteFriendsShareEventMutation, InviteFriendsShareEventMutationVariables>;

/**
 * __useInviteFriendsShareEventMutation__
 *
 * To run a mutation, you first call `useInviteFriendsShareEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteFriendsShareEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteFriendsShareEventMutation, { data, loading, error }] = useInviteFriendsShareEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useInviteFriendsShareEventMutation(baseOptions?: Apollo.MutationHookOptions<InviteFriendsShareEventMutation, InviteFriendsShareEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteFriendsShareEventMutation, InviteFriendsShareEventMutationVariables>(InviteFriendsShareEventDocument, options);
      }
export type InviteFriendsShareEventMutationHookResult = ReturnType<typeof useInviteFriendsShareEventMutation>;
export type InviteFriendsShareEventMutationResult = Apollo.MutationResult<InviteFriendsShareEventMutation>;
export type InviteFriendsShareEventMutationOptions = Apollo.BaseMutationOptions<InviteFriendsShareEventMutation, InviteFriendsShareEventMutationVariables>;
export const UseSharingMessageDocument = gql`
    query UseSharingMessage($orderId: ID!) {
  order(id: $orderId) {
    id
    items {
      ... on BookingOrderItem {
        booking {
          ... on EventBooking {
            id
            purchasedWith {
              ... on Ticket {
                id
                validForSessions {
                  id
                  start
                  end
                }
              }
            }
            bookableItemV2 {
              id
              activityName
              venue {
                id
                name
              }
              shortId
              eventType
              eventSessions {
                id
                start
                end
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUseSharingMessageQuery__
 *
 * To run a query within a React component, call `useUseSharingMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseSharingMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseSharingMessageQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useUseSharingMessageQuery(baseOptions: Apollo.QueryHookOptions<UseSharingMessageQuery, UseSharingMessageQueryVariables> & ({ variables: UseSharingMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseSharingMessageQuery, UseSharingMessageQueryVariables>(UseSharingMessageDocument, options);
      }
export function useUseSharingMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseSharingMessageQuery, UseSharingMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseSharingMessageQuery, UseSharingMessageQueryVariables>(UseSharingMessageDocument, options);
        }
export function useUseSharingMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseSharingMessageQuery, UseSharingMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseSharingMessageQuery, UseSharingMessageQueryVariables>(UseSharingMessageDocument, options);
        }
export type UseSharingMessageQueryHookResult = ReturnType<typeof useUseSharingMessageQuery>;
export type UseSharingMessageLazyQueryHookResult = ReturnType<typeof useUseSharingMessageLazyQuery>;
export type UseSharingMessageSuspenseQueryHookResult = ReturnType<typeof useUseSharingMessageSuspenseQuery>;
export type UseSharingMessageQueryResult = Apollo.QueryResult<UseSharingMessageQuery, UseSharingMessageQueryVariables>;
export const NewsletterBannerSubscribeToNewsletterDocument = gql`
    mutation NewsletterBannerSubscribeToNewsletter($customerId: ID!) {
  subscribeToNewsletter(customerId: $customerId) {
    ... on Customer {
      id
    }
  }
}
    `;
export type NewsletterBannerSubscribeToNewsletterMutationFn = Apollo.MutationFunction<NewsletterBannerSubscribeToNewsletterMutation, NewsletterBannerSubscribeToNewsletterMutationVariables>;

/**
 * __useNewsletterBannerSubscribeToNewsletterMutation__
 *
 * To run a mutation, you first call `useNewsletterBannerSubscribeToNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewsletterBannerSubscribeToNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newsletterBannerSubscribeToNewsletterMutation, { data, loading, error }] = useNewsletterBannerSubscribeToNewsletterMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useNewsletterBannerSubscribeToNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<NewsletterBannerSubscribeToNewsletterMutation, NewsletterBannerSubscribeToNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewsletterBannerSubscribeToNewsletterMutation, NewsletterBannerSubscribeToNewsletterMutationVariables>(NewsletterBannerSubscribeToNewsletterDocument, options);
      }
export type NewsletterBannerSubscribeToNewsletterMutationHookResult = ReturnType<typeof useNewsletterBannerSubscribeToNewsletterMutation>;
export type NewsletterBannerSubscribeToNewsletterMutationResult = Apollo.MutationResult<NewsletterBannerSubscribeToNewsletterMutation>;
export type NewsletterBannerSubscribeToNewsletterMutationOptions = Apollo.BaseMutationOptions<NewsletterBannerSubscribeToNewsletterMutation, NewsletterBannerSubscribeToNewsletterMutationVariables>;
export const HeaderMeDocument = gql`
    query HeaderMe {
  me {
    id
    firstName
    profilePicture {
      xSmall
    }
  }
}
    `;

/**
 * __useHeaderMeQuery__
 *
 * To run a query within a React component, call `useHeaderMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeaderMeQuery(baseOptions?: Apollo.QueryHookOptions<HeaderMeQuery, HeaderMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderMeQuery, HeaderMeQueryVariables>(HeaderMeDocument, options);
      }
export function useHeaderMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderMeQuery, HeaderMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderMeQuery, HeaderMeQueryVariables>(HeaderMeDocument, options);
        }
export function useHeaderMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HeaderMeQuery, HeaderMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeaderMeQuery, HeaderMeQueryVariables>(HeaderMeDocument, options);
        }
export type HeaderMeQueryHookResult = ReturnType<typeof useHeaderMeQuery>;
export type HeaderMeLazyQueryHookResult = ReturnType<typeof useHeaderMeLazyQuery>;
export type HeaderMeSuspenseQueryHookResult = ReturnType<typeof useHeaderMeSuspenseQuery>;
export type HeaderMeQueryResult = Apollo.QueryResult<HeaderMeQuery, HeaderMeQueryVariables>;
export const PaymentOrderDocument = gql`
    query PaymentOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    isConfirmable
    appliedVoucher {
      code
    }
    payment {
      id
      state
      lastAttemptAt
      customerSessionClientSecret
      canSetupRecurringPaymentMethod
      paymentMethods {
        type
        name
        verifyWith
      }
      user {
        ...userAttributes
      }
      storedPaymentMethods {
        __typename
        ... on StoredCreditCard {
          id
          name
          brand
          pspId
          expirationMonth
          expirationYear
          last4
          preferredNetwork
        }
        ... on StoredBankAccount {
          id
          pspId
          last4
          mandates {
            isVerified
          }
        }
      }
      mandate {
        isVerified
        bankAccount {
          id
          pspId
          last4
        }
      }
      paymentIntent {
        id
        amount
        currency
        clientSecret
      }
    }
    state
    venue {
      id
      location {
        country
      }
    }
    items {
      ... on AssignedProductOrderItem {
        assignedProduct {
          __typename
          ... on AssignedProductInterface {
            id
          }
          ... on AssignedRecording {
            id
          }
          ... on GenericAssignedProduct {
            id
          }
        }
      }
    }
  }
}
    ${UserAttributesFragmentDoc}`;

/**
 * __usePaymentOrderQuery__
 *
 * To run a query within a React component, call `usePaymentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePaymentOrderQuery(baseOptions: Apollo.QueryHookOptions<PaymentOrderQuery, PaymentOrderQueryVariables> & ({ variables: PaymentOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentOrderQuery, PaymentOrderQueryVariables>(PaymentOrderDocument, options);
      }
export function usePaymentOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentOrderQuery, PaymentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentOrderQuery, PaymentOrderQueryVariables>(PaymentOrderDocument, options);
        }
export function usePaymentOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentOrderQuery, PaymentOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentOrderQuery, PaymentOrderQueryVariables>(PaymentOrderDocument, options);
        }
export type PaymentOrderQueryHookResult = ReturnType<typeof usePaymentOrderQuery>;
export type PaymentOrderLazyQueryHookResult = ReturnType<typeof usePaymentOrderLazyQuery>;
export type PaymentOrderSuspenseQueryHookResult = ReturnType<typeof usePaymentOrderSuspenseQuery>;
export type PaymentOrderQueryResult = Apollo.QueryResult<PaymentOrderQuery, PaymentOrderQueryVariables>;
export const PaymentAbortOrderDocument = gql`
    mutation PaymentAbortOrder($orderId: ID!) {
  abortOrder(orderId: $orderId) {
    ... on Order {
      id
      state
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export type PaymentAbortOrderMutationFn = Apollo.MutationFunction<PaymentAbortOrderMutation, PaymentAbortOrderMutationVariables>;

/**
 * __usePaymentAbortOrderMutation__
 *
 * To run a mutation, you first call `usePaymentAbortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentAbortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentAbortOrderMutation, { data, loading, error }] = usePaymentAbortOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePaymentAbortOrderMutation(baseOptions?: Apollo.MutationHookOptions<PaymentAbortOrderMutation, PaymentAbortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentAbortOrderMutation, PaymentAbortOrderMutationVariables>(PaymentAbortOrderDocument, options);
      }
export type PaymentAbortOrderMutationHookResult = ReturnType<typeof usePaymentAbortOrderMutation>;
export type PaymentAbortOrderMutationResult = Apollo.MutationResult<PaymentAbortOrderMutation>;
export type PaymentAbortOrderMutationOptions = Apollo.BaseMutationOptions<PaymentAbortOrderMutation, PaymentAbortOrderMutationVariables>;
export const PaymentTrackCheckoutCompleteDocument = gql`
    mutation PaymentTrackCheckoutComplete($orderId: ID!, $deviceId: String!, $sessionId: Float!, $userTrackingId: String) {
  trackCheckoutComplete(
    orderId: $orderId
    deviceId: $deviceId
    sessionId: $sessionId
    userTrackingId: $userTrackingId
  )
}
    `;
export type PaymentTrackCheckoutCompleteMutationFn = Apollo.MutationFunction<PaymentTrackCheckoutCompleteMutation, PaymentTrackCheckoutCompleteMutationVariables>;

/**
 * __usePaymentTrackCheckoutCompleteMutation__
 *
 * To run a mutation, you first call `usePaymentTrackCheckoutCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentTrackCheckoutCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentTrackCheckoutCompleteMutation, { data, loading, error }] = usePaymentTrackCheckoutCompleteMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      deviceId: // value for 'deviceId'
 *      sessionId: // value for 'sessionId'
 *      userTrackingId: // value for 'userTrackingId'
 *   },
 * });
 */
export function usePaymentTrackCheckoutCompleteMutation(baseOptions?: Apollo.MutationHookOptions<PaymentTrackCheckoutCompleteMutation, PaymentTrackCheckoutCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentTrackCheckoutCompleteMutation, PaymentTrackCheckoutCompleteMutationVariables>(PaymentTrackCheckoutCompleteDocument, options);
      }
export type PaymentTrackCheckoutCompleteMutationHookResult = ReturnType<typeof usePaymentTrackCheckoutCompleteMutation>;
export type PaymentTrackCheckoutCompleteMutationResult = Apollo.MutationResult<PaymentTrackCheckoutCompleteMutation>;
export type PaymentTrackCheckoutCompleteMutationOptions = Apollo.BaseMutationOptions<PaymentTrackCheckoutCompleteMutation, PaymentTrackCheckoutCompleteMutationVariables>;
export const PaymentGetMarketplaceFeeDocument = gql`
    query PaymentGetMarketplaceFee($orderId: ID!) {
  getMarketplaceFeeForOrder(orderId: $orderId) {
    value
    currency
  }
}
    `;

/**
 * __usePaymentGetMarketplaceFeeQuery__
 *
 * To run a query within a React component, call `usePaymentGetMarketplaceFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentGetMarketplaceFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentGetMarketplaceFeeQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePaymentGetMarketplaceFeeQuery(baseOptions: Apollo.QueryHookOptions<PaymentGetMarketplaceFeeQuery, PaymentGetMarketplaceFeeQueryVariables> & ({ variables: PaymentGetMarketplaceFeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentGetMarketplaceFeeQuery, PaymentGetMarketplaceFeeQueryVariables>(PaymentGetMarketplaceFeeDocument, options);
      }
export function usePaymentGetMarketplaceFeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentGetMarketplaceFeeQuery, PaymentGetMarketplaceFeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentGetMarketplaceFeeQuery, PaymentGetMarketplaceFeeQueryVariables>(PaymentGetMarketplaceFeeDocument, options);
        }
export function usePaymentGetMarketplaceFeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentGetMarketplaceFeeQuery, PaymentGetMarketplaceFeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentGetMarketplaceFeeQuery, PaymentGetMarketplaceFeeQueryVariables>(PaymentGetMarketplaceFeeDocument, options);
        }
export type PaymentGetMarketplaceFeeQueryHookResult = ReturnType<typeof usePaymentGetMarketplaceFeeQuery>;
export type PaymentGetMarketplaceFeeLazyQueryHookResult = ReturnType<typeof usePaymentGetMarketplaceFeeLazyQuery>;
export type PaymentGetMarketplaceFeeSuspenseQueryHookResult = ReturnType<typeof usePaymentGetMarketplaceFeeSuspenseQuery>;
export type PaymentGetMarketplaceFeeQueryResult = Apollo.QueryResult<PaymentGetMarketplaceFeeQuery, PaymentGetMarketplaceFeeQueryVariables>;
export const ConfirmOrderConfirmOrderDocument = gql`
    mutation ConfirmOrderConfirmOrder($orderId: ID!) {
  confirmOrder(orderId: $orderId) {
    ... on Order {
      id
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type ConfirmOrderConfirmOrderMutationFn = Apollo.MutationFunction<ConfirmOrderConfirmOrderMutation, ConfirmOrderConfirmOrderMutationVariables>;

/**
 * __useConfirmOrderConfirmOrderMutation__
 *
 * To run a mutation, you first call `useConfirmOrderConfirmOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOrderConfirmOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOrderConfirmOrderMutation, { data, loading, error }] = useConfirmOrderConfirmOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useConfirmOrderConfirmOrderMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmOrderConfirmOrderMutation, ConfirmOrderConfirmOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmOrderConfirmOrderMutation, ConfirmOrderConfirmOrderMutationVariables>(ConfirmOrderConfirmOrderDocument, options);
      }
export type ConfirmOrderConfirmOrderMutationHookResult = ReturnType<typeof useConfirmOrderConfirmOrderMutation>;
export type ConfirmOrderConfirmOrderMutationResult = Apollo.MutationResult<ConfirmOrderConfirmOrderMutation>;
export type ConfirmOrderConfirmOrderMutationOptions = Apollo.BaseMutationOptions<ConfirmOrderConfirmOrderMutation, ConfirmOrderConfirmOrderMutationVariables>;
export const ConfirmPaymentConfirmPaymentDocument = gql`
    mutation ConfirmPaymentConfirmPayment($paymentId: ID!, $pspPaymentMethodId: String!) {
  confirmPaymentWithPaymentMethod(
    paymentId: $paymentId
    pspPaymentMethodId: $pspPaymentMethodId
  ) {
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type ConfirmPaymentConfirmPaymentMutationFn = Apollo.MutationFunction<ConfirmPaymentConfirmPaymentMutation, ConfirmPaymentConfirmPaymentMutationVariables>;

/**
 * __useConfirmPaymentConfirmPaymentMutation__
 *
 * To run a mutation, you first call `useConfirmPaymentConfirmPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPaymentConfirmPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPaymentConfirmPaymentMutation, { data, loading, error }] = useConfirmPaymentConfirmPaymentMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      pspPaymentMethodId: // value for 'pspPaymentMethodId'
 *   },
 * });
 */
export function useConfirmPaymentConfirmPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmPaymentConfirmPaymentMutation, ConfirmPaymentConfirmPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmPaymentConfirmPaymentMutation, ConfirmPaymentConfirmPaymentMutationVariables>(ConfirmPaymentConfirmPaymentDocument, options);
      }
export type ConfirmPaymentConfirmPaymentMutationHookResult = ReturnType<typeof useConfirmPaymentConfirmPaymentMutation>;
export type ConfirmPaymentConfirmPaymentMutationResult = Apollo.MutationResult<ConfirmPaymentConfirmPaymentMutation>;
export type ConfirmPaymentConfirmPaymentMutationOptions = Apollo.BaseMutationOptions<ConfirmPaymentConfirmPaymentMutation, ConfirmPaymentConfirmPaymentMutationVariables>;
export const PollPaymentOrderDocument = gql`
    query PollPaymentOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    state
    payment {
      id
      state
      lastAttemptAt
    }
  }
}
    `;

/**
 * __usePollPaymentOrderQuery__
 *
 * To run a query within a React component, call `usePollPaymentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollPaymentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollPaymentOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePollPaymentOrderQuery(baseOptions: Apollo.QueryHookOptions<PollPaymentOrderQuery, PollPaymentOrderQueryVariables> & ({ variables: PollPaymentOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollPaymentOrderQuery, PollPaymentOrderQueryVariables>(PollPaymentOrderDocument, options);
      }
export function usePollPaymentOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollPaymentOrderQuery, PollPaymentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollPaymentOrderQuery, PollPaymentOrderQueryVariables>(PollPaymentOrderDocument, options);
        }
export function usePollPaymentOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PollPaymentOrderQuery, PollPaymentOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PollPaymentOrderQuery, PollPaymentOrderQueryVariables>(PollPaymentOrderDocument, options);
        }
export type PollPaymentOrderQueryHookResult = ReturnType<typeof usePollPaymentOrderQuery>;
export type PollPaymentOrderLazyQueryHookResult = ReturnType<typeof usePollPaymentOrderLazyQuery>;
export type PollPaymentOrderSuspenseQueryHookResult = ReturnType<typeof usePollPaymentOrderSuspenseQuery>;
export type PollPaymentOrderQueryResult = Apollo.QueryResult<PollPaymentOrderQuery, PollPaymentOrderQueryVariables>;
export const PreparePaymentPreparePaymentDocument = gql`
    mutation PreparePaymentPreparePayment($paymentId: ID!, $paymentMethodType: PaymentMethodType!) {
  preparePayment(paymentId: $paymentId, paymentMethodType: $paymentMethodType) {
    ... on Payment {
      id
      paymentIntent {
        clientSecret
      }
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type PreparePaymentPreparePaymentMutationFn = Apollo.MutationFunction<PreparePaymentPreparePaymentMutation, PreparePaymentPreparePaymentMutationVariables>;

/**
 * __usePreparePaymentPreparePaymentMutation__
 *
 * To run a mutation, you first call `usePreparePaymentPreparePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreparePaymentPreparePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preparePaymentPreparePaymentMutation, { data, loading, error }] = usePreparePaymentPreparePaymentMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      paymentMethodType: // value for 'paymentMethodType'
 *   },
 * });
 */
export function usePreparePaymentPreparePaymentMutation(baseOptions?: Apollo.MutationHookOptions<PreparePaymentPreparePaymentMutation, PreparePaymentPreparePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreparePaymentPreparePaymentMutation, PreparePaymentPreparePaymentMutationVariables>(PreparePaymentPreparePaymentDocument, options);
      }
export type PreparePaymentPreparePaymentMutationHookResult = ReturnType<typeof usePreparePaymentPreparePaymentMutation>;
export type PreparePaymentPreparePaymentMutationResult = Apollo.MutationResult<PreparePaymentPreparePaymentMutation>;
export type PreparePaymentPreparePaymentMutationOptions = Apollo.BaseMutationOptions<PreparePaymentPreparePaymentMutation, PreparePaymentPreparePaymentMutationVariables>;
export const SetupRecurringPaymentMethodDocument = gql`
    mutation SetupRecurringPaymentMethod($paymentId: ID!) {
  setupRecurringPaymentMethod(paymentId: $paymentId) {
    ... on Payment {
      id
      paymentSetupIntent {
        id
        clientSecret
        paymentMethod {
          ... on StoredBankAccount {
            id
            pspId
            mandates {
              isVerified
            }
          }
          ... on StoredCreditCard {
            id
            pspId
          }
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type SetupRecurringPaymentMethodMutationFn = Apollo.MutationFunction<SetupRecurringPaymentMethodMutation, SetupRecurringPaymentMethodMutationVariables>;

/**
 * __useSetupRecurringPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetupRecurringPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupRecurringPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupRecurringPaymentMethodMutation, { data, loading, error }] = useSetupRecurringPaymentMethodMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useSetupRecurringPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetupRecurringPaymentMethodMutation, SetupRecurringPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupRecurringPaymentMethodMutation, SetupRecurringPaymentMethodMutationVariables>(SetupRecurringPaymentMethodDocument, options);
      }
export type SetupRecurringPaymentMethodMutationHookResult = ReturnType<typeof useSetupRecurringPaymentMethodMutation>;
export type SetupRecurringPaymentMethodMutationResult = Apollo.MutationResult<SetupRecurringPaymentMethodMutation>;
export type SetupRecurringPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetupRecurringPaymentMethodMutation, SetupRecurringPaymentMethodMutationVariables>;
export const PaymentTimerOrderDocument = gql`
    query PaymentTimerOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    confirmableUntil
    createdAt
    state
    payment {
      id
      state
    }
  }
}
    `;

/**
 * __usePaymentTimerOrderQuery__
 *
 * To run a query within a React component, call `usePaymentTimerOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentTimerOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentTimerOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePaymentTimerOrderQuery(baseOptions: Apollo.QueryHookOptions<PaymentTimerOrderQuery, PaymentTimerOrderQueryVariables> & ({ variables: PaymentTimerOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentTimerOrderQuery, PaymentTimerOrderQueryVariables>(PaymentTimerOrderDocument, options);
      }
export function usePaymentTimerOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentTimerOrderQuery, PaymentTimerOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentTimerOrderQuery, PaymentTimerOrderQueryVariables>(PaymentTimerOrderDocument, options);
        }
export function usePaymentTimerOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentTimerOrderQuery, PaymentTimerOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentTimerOrderQuery, PaymentTimerOrderQueryVariables>(PaymentTimerOrderDocument, options);
        }
export type PaymentTimerOrderQueryHookResult = ReturnType<typeof usePaymentTimerOrderQuery>;
export type PaymentTimerOrderLazyQueryHookResult = ReturnType<typeof usePaymentTimerOrderLazyQuery>;
export type PaymentTimerOrderSuspenseQueryHookResult = ReturnType<typeof usePaymentTimerOrderSuspenseQuery>;
export type PaymentTimerOrderQueryResult = Apollo.QueryResult<PaymentTimerOrderQuery, PaymentTimerOrderQueryVariables>;
export const PaymentTimerAbortOrderDocument = gql`
    mutation PaymentTimerAbortOrder($orderId: ID!) {
  abortOrder(orderId: $orderId) {
    ... on Order {
      id
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export type PaymentTimerAbortOrderMutationFn = Apollo.MutationFunction<PaymentTimerAbortOrderMutation, PaymentTimerAbortOrderMutationVariables>;

/**
 * __usePaymentTimerAbortOrderMutation__
 *
 * To run a mutation, you first call `usePaymentTimerAbortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentTimerAbortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentTimerAbortOrderMutation, { data, loading, error }] = usePaymentTimerAbortOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePaymentTimerAbortOrderMutation(baseOptions?: Apollo.MutationHookOptions<PaymentTimerAbortOrderMutation, PaymentTimerAbortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentTimerAbortOrderMutation, PaymentTimerAbortOrderMutationVariables>(PaymentTimerAbortOrderDocument, options);
      }
export type PaymentTimerAbortOrderMutationHookResult = ReturnType<typeof usePaymentTimerAbortOrderMutation>;
export type PaymentTimerAbortOrderMutationResult = Apollo.MutationResult<PaymentTimerAbortOrderMutation>;
export type PaymentTimerAbortOrderMutationOptions = Apollo.BaseMutationOptions<PaymentTimerAbortOrderMutation, PaymentTimerAbortOrderMutationVariables>;
export const ProductSelectionCartDocument = gql`
    query ProductSelectionCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    isPayAtVenueAllowed
    items {
      ... on BookableItemCartItem {
        id
        settleWith {
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
          ... on GenericAssignedProduct {
            id
          }
        }
        purchaseOptions {
          ... on Card {
            ...cardAttributes
            productPurchaseInformation {
              purchasable
              additionalInformation
            }
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
        }
        confirmWithOptions {
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
        }
        bookableItem {
          ... on EventBookableItem {
            id
            eventType
          }
        }
      }
      ... on ProductCartItem {
        id
        settleWith {
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
          ... on GenericAssignedProduct {
            id
          }
        }
        purchaseOptions {
          ... on Card {
            ...cardAttributes
            productPurchaseInformation {
              purchasable
              additionalInformation
            }
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
        }
        confirmWithOptions {
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
        }
        product {
          ... on Recording {
            id
          }
        }
      }
    }
  }
}
    ${CardAttributesFragmentDoc}
${MembershipAttributesFragmentDoc}
${TicketAttributesFragmentDoc}
${SinglePurchaseAttributesFragmentDoc}
${AssignedCardAttributesFragmentDoc}
${AssignedMembershipAttributesFragmentDoc}`;

/**
 * __useProductSelectionCartQuery__
 *
 * To run a query within a React component, call `useProductSelectionCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSelectionCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSelectionCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useProductSelectionCartQuery(baseOptions: Apollo.QueryHookOptions<ProductSelectionCartQuery, ProductSelectionCartQueryVariables> & ({ variables: ProductSelectionCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSelectionCartQuery, ProductSelectionCartQueryVariables>(ProductSelectionCartDocument, options);
      }
export function useProductSelectionCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSelectionCartQuery, ProductSelectionCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSelectionCartQuery, ProductSelectionCartQueryVariables>(ProductSelectionCartDocument, options);
        }
export function useProductSelectionCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductSelectionCartQuery, ProductSelectionCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductSelectionCartQuery, ProductSelectionCartQueryVariables>(ProductSelectionCartDocument, options);
        }
export type ProductSelectionCartQueryHookResult = ReturnType<typeof useProductSelectionCartQuery>;
export type ProductSelectionCartLazyQueryHookResult = ReturnType<typeof useProductSelectionCartLazyQuery>;
export type ProductSelectionCartSuspenseQueryHookResult = ReturnType<typeof useProductSelectionCartSuspenseQuery>;
export type ProductSelectionCartQueryResult = Apollo.QueryResult<ProductSelectionCartQuery, ProductSelectionCartQueryVariables>;
export const ProductSelectionSetProductForCartItemDocument = gql`
    mutation ProductSelectionSetProductForCartItem($cartId: ID!, $itemId: ID!, $productId: ID!) {
  setProductForCartItem(cartId: $cartId, itemId: $itemId, productId: $productId) {
    ... on Cart {
      id
      isVoucherEnabled
      availableCorporateBenefits {
        corporatePartner {
          name
        }
        isBudgetAvailable
        isSpecialPriceAvailable
      }
      priceTable {
        total {
          value
          currency
        }
        itemsV3 {
          ... on PriceTableItemBasic {
            ...priceTableItemBasicAttributes
          }
          ... on PriceTableItemAddon {
            ...priceTableItemAddonAttributes
          }
          ... on PriceTableItemVoucher {
            ...priceTableItemVoucherAttributes
          }
          ... on PriceTableItemMembership {
            ...priceTableItemMembershipAttributes
          }
          ... on PriceTableItemBudget {
            ...priceTableItemBudgetAttributes
          }
          ... on PriceTableItemSpecialPrice {
            ...priceTableItemSpecialPriceAttributes
          }
        }
      }
      items {
        ... on BookableItemCartItem {
          id
          settleWith {
            ... on Card {
              ...cardAttributes
            }
            ... on Membership {
              ...membershipAttributes
            }
            ... on Ticket {
              ...ticketAttributes
            }
            ... on SinglePurchase {
              ...singlePurchaseAttributes
            }
            ... on AssignedCard {
              ...assignedCardAttributes
            }
            ... on AssignedMembership {
              ...assignedMembershipAttributes
            }
            ... on GenericAssignedProduct {
              id
            }
          }
        }
        ... on ProductCartItem {
          id
          settleWith {
            ... on Card {
              ...cardAttributes
            }
            ... on Membership {
              ...membershipAttributes
            }
            ... on Ticket {
              ...ticketAttributes
            }
            ... on SinglePurchase {
              ...singlePurchaseAttributes
            }
            ... on AssignedCard {
              ...assignedCardAttributes
            }
            ... on AssignedMembership {
              ...assignedMembershipAttributes
            }
            ... on GenericAssignedProduct {
              id
            }
          }
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    ${PriceTableItemBasicAttributesFragmentDoc}
${PriceTableItemAddonAttributesFragmentDoc}
${PriceTableItemVoucherAttributesFragmentDoc}
${PriceTableItemMembershipAttributesFragmentDoc}
${PriceTableItemBudgetAttributesFragmentDoc}
${PriceTableItemSpecialPriceAttributesFragmentDoc}
${CardAttributesFragmentDoc}
${MembershipAttributesFragmentDoc}
${TicketAttributesFragmentDoc}
${SinglePurchaseAttributesFragmentDoc}
${AssignedCardAttributesFragmentDoc}
${AssignedMembershipAttributesFragmentDoc}`;
export type ProductSelectionSetProductForCartItemMutationFn = Apollo.MutationFunction<ProductSelectionSetProductForCartItemMutation, ProductSelectionSetProductForCartItemMutationVariables>;

/**
 * __useProductSelectionSetProductForCartItemMutation__
 *
 * To run a mutation, you first call `useProductSelectionSetProductForCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductSelectionSetProductForCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productSelectionSetProductForCartItemMutation, { data, loading, error }] = useProductSelectionSetProductForCartItemMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      itemId: // value for 'itemId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductSelectionSetProductForCartItemMutation(baseOptions?: Apollo.MutationHookOptions<ProductSelectionSetProductForCartItemMutation, ProductSelectionSetProductForCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductSelectionSetProductForCartItemMutation, ProductSelectionSetProductForCartItemMutationVariables>(ProductSelectionSetProductForCartItemDocument, options);
      }
export type ProductSelectionSetProductForCartItemMutationHookResult = ReturnType<typeof useProductSelectionSetProductForCartItemMutation>;
export type ProductSelectionSetProductForCartItemMutationResult = Apollo.MutationResult<ProductSelectionSetProductForCartItemMutation>;
export type ProductSelectionSetProductForCartItemMutationOptions = Apollo.BaseMutationOptions<ProductSelectionSetProductForCartItemMutation, ProductSelectionSetProductForCartItemMutationVariables>;
export const StepperCartDocument = gql`
    query StepperCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    patronQuestionType
    requiredInformation
    quickCheckoutAvailable
    isVoucherEnabled
    priceTable {
      total {
        value
      }
      originalPrice {
        value
      }
    }
    policies {
      id
      url
      type
      mandatory
    }
    items {
      __typename
      ... on BookableItemCartItem {
        purchaseOptions {
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
        }
        confirmWithOptions {
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
        }
        settleWith {
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
          ... on GenericAssignedProduct {
            id
          }
        }
        addOns {
          id
        }
      }
      ... on ProductCartItem {
        id
        purchaseOptions {
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
        }
        confirmWithOptions {
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
        }
        product {
          __typename
          ... on Card {
            id
          }
          ... on Membership {
            id
          }
          ... on Voucher {
            id
          }
          ... on Recording {
            id
          }
        }
      }
    }
  }
}
    ${CardAttributesFragmentDoc}
${MembershipAttributesFragmentDoc}
${TicketAttributesFragmentDoc}
${SinglePurchaseAttributesFragmentDoc}
${AssignedCardAttributesFragmentDoc}
${AssignedMembershipAttributesFragmentDoc}`;

/**
 * __useStepperCartQuery__
 *
 * To run a query within a React component, call `useStepperCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useStepperCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStepperCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useStepperCartQuery(baseOptions: Apollo.QueryHookOptions<StepperCartQuery, StepperCartQueryVariables> & ({ variables: StepperCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StepperCartQuery, StepperCartQueryVariables>(StepperCartDocument, options);
      }
export function useStepperCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StepperCartQuery, StepperCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StepperCartQuery, StepperCartQueryVariables>(StepperCartDocument, options);
        }
export function useStepperCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StepperCartQuery, StepperCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StepperCartQuery, StepperCartQueryVariables>(StepperCartDocument, options);
        }
export type StepperCartQueryHookResult = ReturnType<typeof useStepperCartQuery>;
export type StepperCartLazyQueryHookResult = ReturnType<typeof useStepperCartLazyQuery>;
export type StepperCartSuspenseQueryHookResult = ReturnType<typeof useStepperCartSuspenseQuery>;
export type StepperCartQueryResult = Apollo.QueryResult<StepperCartQuery, StepperCartQueryVariables>;
export const StepperOrderDocument = gql`
    query StepperOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    payment {
      id
      state
    }
    priceTable {
      total {
        value
        currency
      }
    }
  }
}
    `;

/**
 * __useStepperOrderQuery__
 *
 * To run a query within a React component, call `useStepperOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useStepperOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStepperOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useStepperOrderQuery(baseOptions: Apollo.QueryHookOptions<StepperOrderQuery, StepperOrderQueryVariables> & ({ variables: StepperOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StepperOrderQuery, StepperOrderQueryVariables>(StepperOrderDocument, options);
      }
export function useStepperOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StepperOrderQuery, StepperOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StepperOrderQuery, StepperOrderQueryVariables>(StepperOrderDocument, options);
        }
export function useStepperOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StepperOrderQuery, StepperOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StepperOrderQuery, StepperOrderQueryVariables>(StepperOrderDocument, options);
        }
export type StepperOrderQueryHookResult = ReturnType<typeof useStepperOrderQuery>;
export type StepperOrderLazyQueryHookResult = ReturnType<typeof useStepperOrderLazyQuery>;
export type StepperOrderSuspenseQueryHookResult = ReturnType<typeof useStepperOrderSuspenseQuery>;
export type StepperOrderQueryResult = Apollo.QueryResult<StepperOrderQuery, StepperOrderQueryVariables>;
export const CorporateBenefitsSetBenefitsOnCartDocument = gql`
    mutation CorporateBenefitsSetBenefitsOnCart($cartId: ID!, $useBenefits: Boolean!) {
  setUseCorporateBenefitsOnCart(cartId: $cartId, useBenefits: $useBenefits) {
    ... on Cart {
      id
      priceTable {
        total {
          value
          currency
        }
        itemsV3 {
          ... on PriceTableItemBasic {
            ...priceTableItemBasicAttributes
          }
          ... on PriceTableItemAddon {
            ...priceTableItemAddonAttributes
          }
          ... on PriceTableItemVoucher {
            ...priceTableItemVoucherAttributes
          }
          ... on PriceTableItemMembership {
            ...priceTableItemMembershipAttributes
          }
          ... on PriceTableItemBudget {
            ...priceTableItemBudgetAttributes
          }
          ... on PriceTableItemSpecialPrice {
            ...priceTableItemSpecialPriceAttributes
          }
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        id
        message
        path
      }
    }
  }
}
    ${PriceTableItemBasicAttributesFragmentDoc}
${PriceTableItemAddonAttributesFragmentDoc}
${PriceTableItemVoucherAttributesFragmentDoc}
${PriceTableItemMembershipAttributesFragmentDoc}
${PriceTableItemBudgetAttributesFragmentDoc}
${PriceTableItemSpecialPriceAttributesFragmentDoc}`;
export type CorporateBenefitsSetBenefitsOnCartMutationFn = Apollo.MutationFunction<CorporateBenefitsSetBenefitsOnCartMutation, CorporateBenefitsSetBenefitsOnCartMutationVariables>;

/**
 * __useCorporateBenefitsSetBenefitsOnCartMutation__
 *
 * To run a mutation, you first call `useCorporateBenefitsSetBenefitsOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCorporateBenefitsSetBenefitsOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [corporateBenefitsSetBenefitsOnCartMutation, { data, loading, error }] = useCorporateBenefitsSetBenefitsOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      useBenefits: // value for 'useBenefits'
 *   },
 * });
 */
export function useCorporateBenefitsSetBenefitsOnCartMutation(baseOptions?: Apollo.MutationHookOptions<CorporateBenefitsSetBenefitsOnCartMutation, CorporateBenefitsSetBenefitsOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CorporateBenefitsSetBenefitsOnCartMutation, CorporateBenefitsSetBenefitsOnCartMutationVariables>(CorporateBenefitsSetBenefitsOnCartDocument, options);
      }
export type CorporateBenefitsSetBenefitsOnCartMutationHookResult = ReturnType<typeof useCorporateBenefitsSetBenefitsOnCartMutation>;
export type CorporateBenefitsSetBenefitsOnCartMutationResult = Apollo.MutationResult<CorporateBenefitsSetBenefitsOnCartMutation>;
export type CorporateBenefitsSetBenefitsOnCartMutationOptions = Apollo.BaseMutationOptions<CorporateBenefitsSetBenefitsOnCartMutation, CorporateBenefitsSetBenefitsOnCartMutationVariables>;
export const CorporateInfoItemCartDocument = gql`
    query CorporateInfoItemCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    availableBudget {
      employeeBudgetDepleted
      totalBudgetDepleted
    }
    availableCorporateBenefits {
      corporatePartner {
        name
      }
      isBudgetAvailable
      isSpecialPriceAvailable
    }
  }
}
    `;

/**
 * __useCorporateInfoItemCartQuery__
 *
 * To run a query within a React component, call `useCorporateInfoItemCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorporateInfoItemCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorporateInfoItemCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useCorporateInfoItemCartQuery(baseOptions: Apollo.QueryHookOptions<CorporateInfoItemCartQuery, CorporateInfoItemCartQueryVariables> & ({ variables: CorporateInfoItemCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorporateInfoItemCartQuery, CorporateInfoItemCartQueryVariables>(CorporateInfoItemCartDocument, options);
      }
export function useCorporateInfoItemCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorporateInfoItemCartQuery, CorporateInfoItemCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorporateInfoItemCartQuery, CorporateInfoItemCartQueryVariables>(CorporateInfoItemCartDocument, options);
        }
export function useCorporateInfoItemCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CorporateInfoItemCartQuery, CorporateInfoItemCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CorporateInfoItemCartQuery, CorporateInfoItemCartQueryVariables>(CorporateInfoItemCartDocument, options);
        }
export type CorporateInfoItemCartQueryHookResult = ReturnType<typeof useCorporateInfoItemCartQuery>;
export type CorporateInfoItemCartLazyQueryHookResult = ReturnType<typeof useCorporateInfoItemCartLazyQuery>;
export type CorporateInfoItemCartSuspenseQueryHookResult = ReturnType<typeof useCorporateInfoItemCartSuspenseQuery>;
export type CorporateInfoItemCartQueryResult = Apollo.QueryResult<CorporateInfoItemCartQuery, CorporateInfoItemCartQueryVariables>;
export const SummaryButtonCreateOrderFromCartDocument = gql`
    mutation SummaryButtonCreateOrderFromCart($cartId: ID!) {
  createOrderFromCart(cartId: $cartId, skipSetupFutureUsage: true) {
    ... on Order {
      id
      priceTable {
        total {
          value
        }
        items {
          __typename
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type SummaryButtonCreateOrderFromCartMutationFn = Apollo.MutationFunction<SummaryButtonCreateOrderFromCartMutation, SummaryButtonCreateOrderFromCartMutationVariables>;

/**
 * __useSummaryButtonCreateOrderFromCartMutation__
 *
 * To run a mutation, you first call `useSummaryButtonCreateOrderFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSummaryButtonCreateOrderFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [summaryButtonCreateOrderFromCartMutation, { data, loading, error }] = useSummaryButtonCreateOrderFromCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useSummaryButtonCreateOrderFromCartMutation(baseOptions?: Apollo.MutationHookOptions<SummaryButtonCreateOrderFromCartMutation, SummaryButtonCreateOrderFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SummaryButtonCreateOrderFromCartMutation, SummaryButtonCreateOrderFromCartMutationVariables>(SummaryButtonCreateOrderFromCartDocument, options);
      }
export type SummaryButtonCreateOrderFromCartMutationHookResult = ReturnType<typeof useSummaryButtonCreateOrderFromCartMutation>;
export type SummaryButtonCreateOrderFromCartMutationResult = Apollo.MutationResult<SummaryButtonCreateOrderFromCartMutation>;
export type SummaryButtonCreateOrderFromCartMutationOptions = Apollo.BaseMutationOptions<SummaryButtonCreateOrderFromCartMutation, SummaryButtonCreateOrderFromCartMutationVariables>;
export const SummaryButtonTrackCheckoutCompleteDocument = gql`
    mutation SummaryButtonTrackCheckoutComplete($orderId: ID!, $deviceId: String!, $sessionId: Float!, $userTrackingId: String) {
  trackCheckoutComplete(
    orderId: $orderId
    deviceId: $deviceId
    sessionId: $sessionId
    userTrackingId: $userTrackingId
  )
}
    `;
export type SummaryButtonTrackCheckoutCompleteMutationFn = Apollo.MutationFunction<SummaryButtonTrackCheckoutCompleteMutation, SummaryButtonTrackCheckoutCompleteMutationVariables>;

/**
 * __useSummaryButtonTrackCheckoutCompleteMutation__
 *
 * To run a mutation, you first call `useSummaryButtonTrackCheckoutCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSummaryButtonTrackCheckoutCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [summaryButtonTrackCheckoutCompleteMutation, { data, loading, error }] = useSummaryButtonTrackCheckoutCompleteMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      deviceId: // value for 'deviceId'
 *      sessionId: // value for 'sessionId'
 *      userTrackingId: // value for 'userTrackingId'
 *   },
 * });
 */
export function useSummaryButtonTrackCheckoutCompleteMutation(baseOptions?: Apollo.MutationHookOptions<SummaryButtonTrackCheckoutCompleteMutation, SummaryButtonTrackCheckoutCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SummaryButtonTrackCheckoutCompleteMutation, SummaryButtonTrackCheckoutCompleteMutationVariables>(SummaryButtonTrackCheckoutCompleteDocument, options);
      }
export type SummaryButtonTrackCheckoutCompleteMutationHookResult = ReturnType<typeof useSummaryButtonTrackCheckoutCompleteMutation>;
export type SummaryButtonTrackCheckoutCompleteMutationResult = Apollo.MutationResult<SummaryButtonTrackCheckoutCompleteMutation>;
export type SummaryButtonTrackCheckoutCompleteMutationOptions = Apollo.BaseMutationOptions<SummaryButtonTrackCheckoutCompleteMutation, SummaryButtonTrackCheckoutCompleteMutationVariables>;
export const SummaryButtonGetMarketplaceFeeDocument = gql`
    query SummaryButtonGetMarketplaceFee($orderId: ID!) {
  getMarketplaceFeeForOrder(orderId: $orderId) {
    value
    currency
  }
}
    `;

/**
 * __useSummaryButtonGetMarketplaceFeeQuery__
 *
 * To run a query within a React component, call `useSummaryButtonGetMarketplaceFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryButtonGetMarketplaceFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryButtonGetMarketplaceFeeQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSummaryButtonGetMarketplaceFeeQuery(baseOptions: Apollo.QueryHookOptions<SummaryButtonGetMarketplaceFeeQuery, SummaryButtonGetMarketplaceFeeQueryVariables> & ({ variables: SummaryButtonGetMarketplaceFeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummaryButtonGetMarketplaceFeeQuery, SummaryButtonGetMarketplaceFeeQueryVariables>(SummaryButtonGetMarketplaceFeeDocument, options);
      }
export function useSummaryButtonGetMarketplaceFeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummaryButtonGetMarketplaceFeeQuery, SummaryButtonGetMarketplaceFeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummaryButtonGetMarketplaceFeeQuery, SummaryButtonGetMarketplaceFeeQueryVariables>(SummaryButtonGetMarketplaceFeeDocument, options);
        }
export function useSummaryButtonGetMarketplaceFeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummaryButtonGetMarketplaceFeeQuery, SummaryButtonGetMarketplaceFeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummaryButtonGetMarketplaceFeeQuery, SummaryButtonGetMarketplaceFeeQueryVariables>(SummaryButtonGetMarketplaceFeeDocument, options);
        }
export type SummaryButtonGetMarketplaceFeeQueryHookResult = ReturnType<typeof useSummaryButtonGetMarketplaceFeeQuery>;
export type SummaryButtonGetMarketplaceFeeLazyQueryHookResult = ReturnType<typeof useSummaryButtonGetMarketplaceFeeLazyQuery>;
export type SummaryButtonGetMarketplaceFeeSuspenseQueryHookResult = ReturnType<typeof useSummaryButtonGetMarketplaceFeeSuspenseQuery>;
export type SummaryButtonGetMarketplaceFeeQueryResult = Apollo.QueryResult<SummaryButtonGetMarketplaceFeeQuery, SummaryButtonGetMarketplaceFeeQueryVariables>;
export const VoucherSelectionSetVoucherOnCartDocument = gql`
    mutation VoucherSelectionSetVoucherOnCart($cartId: ID!, $voucher: String) {
  setVoucherOnCart(cartId: $cartId, voucher: $voucher) {
    ... on Cart {
      id
      isVoucherEnabled
      priceTable {
        total {
          value
          currency
        }
        itemsV3 {
          ... on PriceTableItemBasic {
            ...priceTableItemBasicAttributes
          }
          ... on PriceTableItemAddon {
            ...priceTableItemAddonAttributes
          }
          ... on PriceTableItemVoucher {
            ...priceTableItemVoucherAttributes
          }
          ... on PriceTableItemMembership {
            ...priceTableItemMembershipAttributes
          }
          ... on PriceTableItemBudget {
            ...priceTableItemBudgetAttributes
          }
          ... on PriceTableItemSpecialPrice {
            ...priceTableItemSpecialPriceAttributes
          }
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        id
        message
        path
      }
    }
  }
}
    ${PriceTableItemBasicAttributesFragmentDoc}
${PriceTableItemAddonAttributesFragmentDoc}
${PriceTableItemVoucherAttributesFragmentDoc}
${PriceTableItemMembershipAttributesFragmentDoc}
${PriceTableItemBudgetAttributesFragmentDoc}
${PriceTableItemSpecialPriceAttributesFragmentDoc}`;
export type VoucherSelectionSetVoucherOnCartMutationFn = Apollo.MutationFunction<VoucherSelectionSetVoucherOnCartMutation, VoucherSelectionSetVoucherOnCartMutationVariables>;

/**
 * __useVoucherSelectionSetVoucherOnCartMutation__
 *
 * To run a mutation, you first call `useVoucherSelectionSetVoucherOnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoucherSelectionSetVoucherOnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voucherSelectionSetVoucherOnCartMutation, { data, loading, error }] = useVoucherSelectionSetVoucherOnCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      voucher: // value for 'voucher'
 *   },
 * });
 */
export function useVoucherSelectionSetVoucherOnCartMutation(baseOptions?: Apollo.MutationHookOptions<VoucherSelectionSetVoucherOnCartMutation, VoucherSelectionSetVoucherOnCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoucherSelectionSetVoucherOnCartMutation, VoucherSelectionSetVoucherOnCartMutationVariables>(VoucherSelectionSetVoucherOnCartDocument, options);
      }
export type VoucherSelectionSetVoucherOnCartMutationHookResult = ReturnType<typeof useVoucherSelectionSetVoucherOnCartMutation>;
export type VoucherSelectionSetVoucherOnCartMutationResult = Apollo.MutationResult<VoucherSelectionSetVoucherOnCartMutation>;
export type VoucherSelectionSetVoucherOnCartMutationOptions = Apollo.BaseMutationOptions<VoucherSelectionSetVoucherOnCartMutation, VoucherSelectionSetVoucherOnCartMutationVariables>;
export const VoucherSelectionCartDocument = gql`
    query VoucherSelectionCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    isVoucherEnabled
    priceTable {
      itemsV3 {
        ... on PriceTableItemVoucher {
          code
        }
      }
    }
  }
}
    `;

/**
 * __useVoucherSelectionCartQuery__
 *
 * To run a query within a React component, call `useVoucherSelectionCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoucherSelectionCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoucherSelectionCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useVoucherSelectionCartQuery(baseOptions: Apollo.QueryHookOptions<VoucherSelectionCartQuery, VoucherSelectionCartQueryVariables> & ({ variables: VoucherSelectionCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VoucherSelectionCartQuery, VoucherSelectionCartQueryVariables>(VoucherSelectionCartDocument, options);
      }
export function useVoucherSelectionCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VoucherSelectionCartQuery, VoucherSelectionCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VoucherSelectionCartQuery, VoucherSelectionCartQueryVariables>(VoucherSelectionCartDocument, options);
        }
export function useVoucherSelectionCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VoucherSelectionCartQuery, VoucherSelectionCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VoucherSelectionCartQuery, VoucherSelectionCartQueryVariables>(VoucherSelectionCartDocument, options);
        }
export type VoucherSelectionCartQueryHookResult = ReturnType<typeof useVoucherSelectionCartQuery>;
export type VoucherSelectionCartLazyQueryHookResult = ReturnType<typeof useVoucherSelectionCartLazyQuery>;
export type VoucherSelectionCartSuspenseQueryHookResult = ReturnType<typeof useVoucherSelectionCartSuspenseQuery>;
export type VoucherSelectionCartQueryResult = Apollo.QueryResult<VoucherSelectionCartQuery, VoucherSelectionCartQueryVariables>;
export const CreateOrderFromCartHandlerCreateOrderFromCartDocument = gql`
    mutation CreateOrderFromCartHandlerCreateOrderFromCart($cartId: ID!) {
  createOrderFromCart(cartId: $cartId, skipSetupFutureUsage: true) {
    ... on Order {
      id
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type CreateOrderFromCartHandlerCreateOrderFromCartMutationFn = Apollo.MutationFunction<CreateOrderFromCartHandlerCreateOrderFromCartMutation, CreateOrderFromCartHandlerCreateOrderFromCartMutationVariables>;

/**
 * __useCreateOrderFromCartHandlerCreateOrderFromCartMutation__
 *
 * To run a mutation, you first call `useCreateOrderFromCartHandlerCreateOrderFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderFromCartHandlerCreateOrderFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderFromCartHandlerCreateOrderFromCartMutation, { data, loading, error }] = useCreateOrderFromCartHandlerCreateOrderFromCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useCreateOrderFromCartHandlerCreateOrderFromCartMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderFromCartHandlerCreateOrderFromCartMutation, CreateOrderFromCartHandlerCreateOrderFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderFromCartHandlerCreateOrderFromCartMutation, CreateOrderFromCartHandlerCreateOrderFromCartMutationVariables>(CreateOrderFromCartHandlerCreateOrderFromCartDocument, options);
      }
export type CreateOrderFromCartHandlerCreateOrderFromCartMutationHookResult = ReturnType<typeof useCreateOrderFromCartHandlerCreateOrderFromCartMutation>;
export type CreateOrderFromCartHandlerCreateOrderFromCartMutationResult = Apollo.MutationResult<CreateOrderFromCartHandlerCreateOrderFromCartMutation>;
export type CreateOrderFromCartHandlerCreateOrderFromCartMutationOptions = Apollo.BaseMutationOptions<CreateOrderFromCartHandlerCreateOrderFromCartMutation, CreateOrderFromCartHandlerCreateOrderFromCartMutationVariables>;
export const GetVenueTrackingIdPaymentOrderDocument = gql`
    query GetVenueTrackingIdPaymentOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    venue {
      externalTrackingIds {
        googleAnalyticsId
      }
    }
  }
}
    `;

/**
 * __useGetVenueTrackingIdPaymentOrderQuery__
 *
 * To run a query within a React component, call `useGetVenueTrackingIdPaymentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenueTrackingIdPaymentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenueTrackingIdPaymentOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetVenueTrackingIdPaymentOrderQuery(baseOptions: Apollo.QueryHookOptions<GetVenueTrackingIdPaymentOrderQuery, GetVenueTrackingIdPaymentOrderQueryVariables> & ({ variables: GetVenueTrackingIdPaymentOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenueTrackingIdPaymentOrderQuery, GetVenueTrackingIdPaymentOrderQueryVariables>(GetVenueTrackingIdPaymentOrderDocument, options);
      }
export function useGetVenueTrackingIdPaymentOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenueTrackingIdPaymentOrderQuery, GetVenueTrackingIdPaymentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenueTrackingIdPaymentOrderQuery, GetVenueTrackingIdPaymentOrderQueryVariables>(GetVenueTrackingIdPaymentOrderDocument, options);
        }
export function useGetVenueTrackingIdPaymentOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVenueTrackingIdPaymentOrderQuery, GetVenueTrackingIdPaymentOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVenueTrackingIdPaymentOrderQuery, GetVenueTrackingIdPaymentOrderQueryVariables>(GetVenueTrackingIdPaymentOrderDocument, options);
        }
export type GetVenueTrackingIdPaymentOrderQueryHookResult = ReturnType<typeof useGetVenueTrackingIdPaymentOrderQuery>;
export type GetVenueTrackingIdPaymentOrderLazyQueryHookResult = ReturnType<typeof useGetVenueTrackingIdPaymentOrderLazyQuery>;
export type GetVenueTrackingIdPaymentOrderSuspenseQueryHookResult = ReturnType<typeof useGetVenueTrackingIdPaymentOrderSuspenseQuery>;
export type GetVenueTrackingIdPaymentOrderQueryResult = Apollo.QueryResult<GetVenueTrackingIdPaymentOrderQuery, GetVenueTrackingIdPaymentOrderQueryVariables>;
export const PurchaseDataForGooglePaymentOrderDocument = gql`
    query PurchaseDataForGooglePaymentOrder($orderId: ID!) {
  order(id: $orderId) {
    ... on Order {
      id
      amount {
        value
        currency
      }
    }
  }
}
    `;

/**
 * __usePurchaseDataForGooglePaymentOrderQuery__
 *
 * To run a query within a React component, call `usePurchaseDataForGooglePaymentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseDataForGooglePaymentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseDataForGooglePaymentOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePurchaseDataForGooglePaymentOrderQuery(baseOptions: Apollo.QueryHookOptions<PurchaseDataForGooglePaymentOrderQuery, PurchaseDataForGooglePaymentOrderQueryVariables> & ({ variables: PurchaseDataForGooglePaymentOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseDataForGooglePaymentOrderQuery, PurchaseDataForGooglePaymentOrderQueryVariables>(PurchaseDataForGooglePaymentOrderDocument, options);
      }
export function usePurchaseDataForGooglePaymentOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseDataForGooglePaymentOrderQuery, PurchaseDataForGooglePaymentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseDataForGooglePaymentOrderQuery, PurchaseDataForGooglePaymentOrderQueryVariables>(PurchaseDataForGooglePaymentOrderDocument, options);
        }
export function usePurchaseDataForGooglePaymentOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PurchaseDataForGooglePaymentOrderQuery, PurchaseDataForGooglePaymentOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseDataForGooglePaymentOrderQuery, PurchaseDataForGooglePaymentOrderQueryVariables>(PurchaseDataForGooglePaymentOrderDocument, options);
        }
export type PurchaseDataForGooglePaymentOrderQueryHookResult = ReturnType<typeof usePurchaseDataForGooglePaymentOrderQuery>;
export type PurchaseDataForGooglePaymentOrderLazyQueryHookResult = ReturnType<typeof usePurchaseDataForGooglePaymentOrderLazyQuery>;
export type PurchaseDataForGooglePaymentOrderSuspenseQueryHookResult = ReturnType<typeof usePurchaseDataForGooglePaymentOrderSuspenseQuery>;
export type PurchaseDataForGooglePaymentOrderQueryResult = Apollo.QueryResult<PurchaseDataForGooglePaymentOrderQuery, PurchaseDataForGooglePaymentOrderQueryVariables>;
export const InitialDataLoaderCartDocument = gql`
    query InitialDataLoaderCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    patronQuestionType
    requiredInformation
    quickCheckoutAvailable
    isVoucherEnabled
    availableBudget {
      employeeBudgetDepleted
      totalBudgetDepleted
    }
    availableCorporateBenefits {
      corporatePartner {
        name
      }
      isBudgetAvailable
      isSpecialPriceAvailable
    }
    policies {
      id
      url
      type
      mandatory
    }
    priceTable {
      total {
        value
      }
      originalPrice {
        value
      }
    }
    items {
      __typename
      ... on BookableItemCartItem {
        id
        settleWith {
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
          ... on GenericAssignedProduct {
            id
          }
        }
        purchaseOptions {
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
        }
        confirmWithOptions {
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
        }
        addOns {
          id
        }
      }
      ... on ProductCartItem {
        id
        settleWith {
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
          ... on GenericAssignedProduct {
            id
          }
        }
        product {
          __typename
          ... on Card {
            id
          }
          ... on Membership {
            id
          }
          ... on Voucher {
            id
          }
          ... on Recording {
            id
          }
        }
        purchaseOptions {
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
        }
        confirmWithOptions {
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
        }
      }
    }
  }
}
    ${CardAttributesFragmentDoc}
${MembershipAttributesFragmentDoc}
${TicketAttributesFragmentDoc}
${SinglePurchaseAttributesFragmentDoc}
${AssignedCardAttributesFragmentDoc}
${AssignedMembershipAttributesFragmentDoc}`;

/**
 * __useInitialDataLoaderCartQuery__
 *
 * To run a query within a React component, call `useInitialDataLoaderCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialDataLoaderCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialDataLoaderCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useInitialDataLoaderCartQuery(baseOptions: Apollo.QueryHookOptions<InitialDataLoaderCartQuery, InitialDataLoaderCartQueryVariables> & ({ variables: InitialDataLoaderCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitialDataLoaderCartQuery, InitialDataLoaderCartQueryVariables>(InitialDataLoaderCartDocument, options);
      }
export function useInitialDataLoaderCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitialDataLoaderCartQuery, InitialDataLoaderCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitialDataLoaderCartQuery, InitialDataLoaderCartQueryVariables>(InitialDataLoaderCartDocument, options);
        }
export function useInitialDataLoaderCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InitialDataLoaderCartQuery, InitialDataLoaderCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InitialDataLoaderCartQuery, InitialDataLoaderCartQueryVariables>(InitialDataLoaderCartDocument, options);
        }
export type InitialDataLoaderCartQueryHookResult = ReturnType<typeof useInitialDataLoaderCartQuery>;
export type InitialDataLoaderCartLazyQueryHookResult = ReturnType<typeof useInitialDataLoaderCartLazyQuery>;
export type InitialDataLoaderCartSuspenseQueryHookResult = ReturnType<typeof useInitialDataLoaderCartSuspenseQuery>;
export type InitialDataLoaderCartQueryResult = Apollo.QueryResult<InitialDataLoaderCartQuery, InitialDataLoaderCartQueryVariables>;
export const InitialDataLoaderOrderDocument = gql`
    query InitialDataLoaderOrder($orderId: ID!) {
  order(id: $orderId) {
    ... on Order {
      id
      state
      payment {
        state
      }
      priceTable {
        total {
          value
          currency
        }
      }
    }
  }
}
    `;

/**
 * __useInitialDataLoaderOrderQuery__
 *
 * To run a query within a React component, call `useInitialDataLoaderOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialDataLoaderOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialDataLoaderOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useInitialDataLoaderOrderQuery(baseOptions: Apollo.QueryHookOptions<InitialDataLoaderOrderQuery, InitialDataLoaderOrderQueryVariables> & ({ variables: InitialDataLoaderOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitialDataLoaderOrderQuery, InitialDataLoaderOrderQueryVariables>(InitialDataLoaderOrderDocument, options);
      }
export function useInitialDataLoaderOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitialDataLoaderOrderQuery, InitialDataLoaderOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitialDataLoaderOrderQuery, InitialDataLoaderOrderQueryVariables>(InitialDataLoaderOrderDocument, options);
        }
export function useInitialDataLoaderOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InitialDataLoaderOrderQuery, InitialDataLoaderOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InitialDataLoaderOrderQuery, InitialDataLoaderOrderQueryVariables>(InitialDataLoaderOrderDocument, options);
        }
export type InitialDataLoaderOrderQueryHookResult = ReturnType<typeof useInitialDataLoaderOrderQuery>;
export type InitialDataLoaderOrderLazyQueryHookResult = ReturnType<typeof useInitialDataLoaderOrderLazyQuery>;
export type InitialDataLoaderOrderSuspenseQueryHookResult = ReturnType<typeof useInitialDataLoaderOrderSuspenseQuery>;
export type InitialDataLoaderOrderQueryResult = Apollo.QueryResult<InitialDataLoaderOrderQuery, InitialDataLoaderOrderQueryVariables>;
export const OrderAbortHandlerAbortOrderDocument = gql`
    mutation OrderAbortHandlerAbortOrder($orderId: ID!) {
  abortOrder(orderId: $orderId) {
    ... on Order {
      id
      state
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export type OrderAbortHandlerAbortOrderMutationFn = Apollo.MutationFunction<OrderAbortHandlerAbortOrderMutation, OrderAbortHandlerAbortOrderMutationVariables>;

/**
 * __useOrderAbortHandlerAbortOrderMutation__
 *
 * To run a mutation, you first call `useOrderAbortHandlerAbortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderAbortHandlerAbortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderAbortHandlerAbortOrderMutation, { data, loading, error }] = useOrderAbortHandlerAbortOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderAbortHandlerAbortOrderMutation(baseOptions?: Apollo.MutationHookOptions<OrderAbortHandlerAbortOrderMutation, OrderAbortHandlerAbortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAbortHandlerAbortOrderMutation, OrderAbortHandlerAbortOrderMutationVariables>(OrderAbortHandlerAbortOrderDocument, options);
      }
export type OrderAbortHandlerAbortOrderMutationHookResult = ReturnType<typeof useOrderAbortHandlerAbortOrderMutation>;
export type OrderAbortHandlerAbortOrderMutationResult = Apollo.MutationResult<OrderAbortHandlerAbortOrderMutation>;
export type OrderAbortHandlerAbortOrderMutationOptions = Apollo.BaseMutationOptions<OrderAbortHandlerAbortOrderMutation, OrderAbortHandlerAbortOrderMutationVariables>;
export const OrderCreationHandlerCartDocument = gql`
    query OrderCreationHandlerCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    patronQuestionType
    requiredInformation
    quickCheckoutAvailable
    isVoucherEnabled
    priceTable {
      total {
        value
      }
      originalPrice {
        value
      }
    }
    policies {
      id
      url
      type
      mandatory
    }
    items {
      __typename
      ... on BookableItemCartItem {
        purchaseOptions {
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
        }
        confirmWithOptions {
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
        }
        addOns {
          id
        }
      }
      ... on ProductCartItem {
        id
        purchaseOptions {
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
        }
        confirmWithOptions {
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
        }
        product {
          __typename
        }
      }
    }
  }
}
    ${CardAttributesFragmentDoc}
${MembershipAttributesFragmentDoc}
${TicketAttributesFragmentDoc}
${SinglePurchaseAttributesFragmentDoc}
${AssignedCardAttributesFragmentDoc}
${AssignedMembershipAttributesFragmentDoc}`;

/**
 * __useOrderCreationHandlerCartQuery__
 *
 * To run a query within a React component, call `useOrderCreationHandlerCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderCreationHandlerCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderCreationHandlerCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useOrderCreationHandlerCartQuery(baseOptions: Apollo.QueryHookOptions<OrderCreationHandlerCartQuery, OrderCreationHandlerCartQueryVariables> & ({ variables: OrderCreationHandlerCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderCreationHandlerCartQuery, OrderCreationHandlerCartQueryVariables>(OrderCreationHandlerCartDocument, options);
      }
export function useOrderCreationHandlerCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderCreationHandlerCartQuery, OrderCreationHandlerCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderCreationHandlerCartQuery, OrderCreationHandlerCartQueryVariables>(OrderCreationHandlerCartDocument, options);
        }
export function useOrderCreationHandlerCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderCreationHandlerCartQuery, OrderCreationHandlerCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderCreationHandlerCartQuery, OrderCreationHandlerCartQueryVariables>(OrderCreationHandlerCartDocument, options);
        }
export type OrderCreationHandlerCartQueryHookResult = ReturnType<typeof useOrderCreationHandlerCartQuery>;
export type OrderCreationHandlerCartLazyQueryHookResult = ReturnType<typeof useOrderCreationHandlerCartLazyQuery>;
export type OrderCreationHandlerCartSuspenseQueryHookResult = ReturnType<typeof useOrderCreationHandlerCartSuspenseQuery>;
export type OrderCreationHandlerCartQueryResult = Apollo.QueryResult<OrderCreationHandlerCartQuery, OrderCreationHandlerCartQueryVariables>;
export const UseBookingDetailsCartDocument = gql`
    query UseBookingDetailsCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    venue {
      id
      name
      images {
        large
      }
      isFeatureEnabled(name: "user-private-session-booking-request-enabled")
    }
    items {
      ... on ProductCartItem {
        id
        product {
          __typename
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Voucher {
            ...voucherAttributes
          }
          ... on Recording {
            ...recordingAttributes
          }
        }
      }
      ... on BookableItemCartItem {
        id
        settleWith {
          ... on Card {
            ...cardAttributes
          }
          ... on Membership {
            ...membershipAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
          ... on GenericAssignedProduct {
            id
          }
        }
        bookableItem {
          __typename
          ... on EventBookableItem {
            ...eventBookableItemAttributes
          }
        }
        trainer {
          id
          nickname
          firstName
        }
        timeRange {
          start
          end
        }
      }
    }
  }
}
    ${CardAttributesFragmentDoc}
${MembershipAttributesFragmentDoc}
${VoucherAttributesFragmentDoc}
${RecordingAttributesFragmentDoc}
${TicketAttributesFragmentDoc}
${SinglePurchaseAttributesFragmentDoc}
${AssignedCardAttributesFragmentDoc}
${AssignedMembershipAttributesFragmentDoc}
${EventBookableItemAttributesFragmentDoc}`;

/**
 * __useUseBookingDetailsCartQuery__
 *
 * To run a query within a React component, call `useUseBookingDetailsCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseBookingDetailsCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseBookingDetailsCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useUseBookingDetailsCartQuery(baseOptions: Apollo.QueryHookOptions<UseBookingDetailsCartQuery, UseBookingDetailsCartQueryVariables> & ({ variables: UseBookingDetailsCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseBookingDetailsCartQuery, UseBookingDetailsCartQueryVariables>(UseBookingDetailsCartDocument, options);
      }
export function useUseBookingDetailsCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseBookingDetailsCartQuery, UseBookingDetailsCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseBookingDetailsCartQuery, UseBookingDetailsCartQueryVariables>(UseBookingDetailsCartDocument, options);
        }
export function useUseBookingDetailsCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseBookingDetailsCartQuery, UseBookingDetailsCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseBookingDetailsCartQuery, UseBookingDetailsCartQueryVariables>(UseBookingDetailsCartDocument, options);
        }
export type UseBookingDetailsCartQueryHookResult = ReturnType<typeof useUseBookingDetailsCartQuery>;
export type UseBookingDetailsCartLazyQueryHookResult = ReturnType<typeof useUseBookingDetailsCartLazyQuery>;
export type UseBookingDetailsCartSuspenseQueryHookResult = ReturnType<typeof useUseBookingDetailsCartSuspenseQuery>;
export type UseBookingDetailsCartQueryResult = Apollo.QueryResult<UseBookingDetailsCartQuery, UseBookingDetailsCartQueryVariables>;
export const UseBookingDetailsOrderDocument = gql`
    query UseBookingDetailsOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    invoice {
      number
    }
    venue {
      id
      name
      images {
        large
      }
      location {
        street
        zip
        city
        detail
      }
    }
    items {
      __typename
      ... on AssignedProductOrderItem {
        endPrice
        reduction
        quantity
        confirmedWith {
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
          ... on AssignedCard {
            ...assignedCardAttributes
          }
        }
        purchasedWith {
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
        }
        assignedProduct {
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
          ... on AssignedCard {
            ...assignedCardAttributes
          }
          ... on AssignedVoucher {
            id
            product {
              ...voucherAttributes
            }
          }
          ... on AssignedRecording {
            id
            product {
              ...recordingAttributes
            }
          }
          ... on GenericAssignedProduct {
            id
          }
        }
      }
      ... on BookingOrderItem {
        confirmedWith {
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
          ... on AssignedCard {
            ...assignedCardAttributes
          }
        }
        purchasedWith {
          ... on SinglePurchase {
            ...singlePurchaseAttributes
          }
          ... on Ticket {
            ...ticketAttributes
          }
        }
        booking {
          ... on EventBooking {
            assignedSpot {
              id
              label
            }
            bookableItem {
              ...eventBookableItemAttributes
            }
          }
        }
      }
      ... on BookingRequestOrderItem {
        bookableItem {
          ...eventBookableItemAttributes
        }
        trainer {
          id
          nickname
          firstName
        }
        timeRange {
          start
          end
        }
        confirmedWith {
          ... on AssignedMembership {
            ...assignedMembershipAttributes
          }
          ... on AssignedCard {
            ...assignedCardAttributes
          }
        }
      }
    }
  }
}
    ${AssignedMembershipAttributesFragmentDoc}
${AssignedCardAttributesFragmentDoc}
${SinglePurchaseAttributesFragmentDoc}
${VoucherAttributesFragmentDoc}
${RecordingAttributesFragmentDoc}
${TicketAttributesFragmentDoc}
${EventBookableItemAttributesFragmentDoc}`;

/**
 * __useUseBookingDetailsOrderQuery__
 *
 * To run a query within a React component, call `useUseBookingDetailsOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseBookingDetailsOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseBookingDetailsOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useUseBookingDetailsOrderQuery(baseOptions: Apollo.QueryHookOptions<UseBookingDetailsOrderQuery, UseBookingDetailsOrderQueryVariables> & ({ variables: UseBookingDetailsOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseBookingDetailsOrderQuery, UseBookingDetailsOrderQueryVariables>(UseBookingDetailsOrderDocument, options);
      }
export function useUseBookingDetailsOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseBookingDetailsOrderQuery, UseBookingDetailsOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseBookingDetailsOrderQuery, UseBookingDetailsOrderQueryVariables>(UseBookingDetailsOrderDocument, options);
        }
export function useUseBookingDetailsOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseBookingDetailsOrderQuery, UseBookingDetailsOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseBookingDetailsOrderQuery, UseBookingDetailsOrderQueryVariables>(UseBookingDetailsOrderDocument, options);
        }
export type UseBookingDetailsOrderQueryHookResult = ReturnType<typeof useUseBookingDetailsOrderQuery>;
export type UseBookingDetailsOrderLazyQueryHookResult = ReturnType<typeof useUseBookingDetailsOrderLazyQuery>;
export type UseBookingDetailsOrderSuspenseQueryHookResult = ReturnType<typeof useUseBookingDetailsOrderSuspenseQuery>;
export type UseBookingDetailsOrderQueryResult = Apollo.QueryResult<UseBookingDetailsOrderQuery, UseBookingDetailsOrderQueryVariables>;
export const UseCartCreationHandlerCreateCartFromEventBookableItemDocument = gql`
    mutation UseCartCreationHandlerCreateCartFromEventBookableItem($bookableItemId: ID!, $origin: Origin!, $clientMetadata: ClientMetadataInput) {
  createCartFromEventBookableItem(
    bookableItemId: $bookableItemId
    origin: $origin
    clientMetadata: $clientMetadata
  ) {
    ... on Cart {
      id
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type UseCartCreationHandlerCreateCartFromEventBookableItemMutationFn = Apollo.MutationFunction<UseCartCreationHandlerCreateCartFromEventBookableItemMutation, UseCartCreationHandlerCreateCartFromEventBookableItemMutationVariables>;

/**
 * __useUseCartCreationHandlerCreateCartFromEventBookableItemMutation__
 *
 * To run a mutation, you first call `useUseCartCreationHandlerCreateCartFromEventBookableItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseCartCreationHandlerCreateCartFromEventBookableItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useCartCreationHandlerCreateCartFromEventBookableItemMutation, { data, loading, error }] = useUseCartCreationHandlerCreateCartFromEventBookableItemMutation({
 *   variables: {
 *      bookableItemId: // value for 'bookableItemId'
 *      origin: // value for 'origin'
 *      clientMetadata: // value for 'clientMetadata'
 *   },
 * });
 */
export function useUseCartCreationHandlerCreateCartFromEventBookableItemMutation(baseOptions?: Apollo.MutationHookOptions<UseCartCreationHandlerCreateCartFromEventBookableItemMutation, UseCartCreationHandlerCreateCartFromEventBookableItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseCartCreationHandlerCreateCartFromEventBookableItemMutation, UseCartCreationHandlerCreateCartFromEventBookableItemMutationVariables>(UseCartCreationHandlerCreateCartFromEventBookableItemDocument, options);
      }
export type UseCartCreationHandlerCreateCartFromEventBookableItemMutationHookResult = ReturnType<typeof useUseCartCreationHandlerCreateCartFromEventBookableItemMutation>;
export type UseCartCreationHandlerCreateCartFromEventBookableItemMutationResult = Apollo.MutationResult<UseCartCreationHandlerCreateCartFromEventBookableItemMutation>;
export type UseCartCreationHandlerCreateCartFromEventBookableItemMutationOptions = Apollo.BaseMutationOptions<UseCartCreationHandlerCreateCartFromEventBookableItemMutation, UseCartCreationHandlerCreateCartFromEventBookableItemMutationVariables>;
export const UseCartCreationHandlerCreateCartFromPrivateSessionOfferDocument = gql`
    mutation UseCartCreationHandlerCreateCartFromPrivateSessionOffer($privateSessionOfferId: ID!, $start: DateTime!, $origin: Origin!, $clientMetadata: ClientMetadataInput, $trainerId: ID) {
  createCartFromPrivateSessionOffer(
    privateSessionOfferId: $privateSessionOfferId
    trainerId: $trainerId
    start: $start
    origin: $origin
    clientMetadata: $clientMetadata
  ) {
    ... on Cart {
      id
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutationFn = Apollo.MutationFunction<UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutation, UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutationVariables>;

/**
 * __useUseCartCreationHandlerCreateCartFromPrivateSessionOfferMutation__
 *
 * To run a mutation, you first call `useUseCartCreationHandlerCreateCartFromPrivateSessionOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseCartCreationHandlerCreateCartFromPrivateSessionOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useCartCreationHandlerCreateCartFromPrivateSessionOfferMutation, { data, loading, error }] = useUseCartCreationHandlerCreateCartFromPrivateSessionOfferMutation({
 *   variables: {
 *      privateSessionOfferId: // value for 'privateSessionOfferId'
 *      start: // value for 'start'
 *      origin: // value for 'origin'
 *      clientMetadata: // value for 'clientMetadata'
 *      trainerId: // value for 'trainerId'
 *   },
 * });
 */
export function useUseCartCreationHandlerCreateCartFromPrivateSessionOfferMutation(baseOptions?: Apollo.MutationHookOptions<UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutation, UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutation, UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutationVariables>(UseCartCreationHandlerCreateCartFromPrivateSessionOfferDocument, options);
      }
export type UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutationHookResult = ReturnType<typeof useUseCartCreationHandlerCreateCartFromPrivateSessionOfferMutation>;
export type UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutationResult = Apollo.MutationResult<UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutation>;
export type UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutationOptions = Apollo.BaseMutationOptions<UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutation, UseCartCreationHandlerCreateCartFromPrivateSessionOfferMutationVariables>;
export const UseCartCreationHandlerCreateCartFromCourtBookableItemDocument = gql`
    mutation UseCartCreationHandlerCreateCartFromCourtBookableItem($courtId: ID!, $sportId: ID!, $start: String!, $end: String!, $origin: Origin!, $clientMetadata: ClientMetadataInput) {
  createCartFromCourtBookableItem(
    courtId: $courtId
    sportId: $sportId
    start: $start
    end: $end
    origin: $origin
    clientMetadata: $clientMetadata
  ) {
    ... on Cart {
      id
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type UseCartCreationHandlerCreateCartFromCourtBookableItemMutationFn = Apollo.MutationFunction<UseCartCreationHandlerCreateCartFromCourtBookableItemMutation, UseCartCreationHandlerCreateCartFromCourtBookableItemMutationVariables>;

/**
 * __useUseCartCreationHandlerCreateCartFromCourtBookableItemMutation__
 *
 * To run a mutation, you first call `useUseCartCreationHandlerCreateCartFromCourtBookableItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseCartCreationHandlerCreateCartFromCourtBookableItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useCartCreationHandlerCreateCartFromCourtBookableItemMutation, { data, loading, error }] = useUseCartCreationHandlerCreateCartFromCourtBookableItemMutation({
 *   variables: {
 *      courtId: // value for 'courtId'
 *      sportId: // value for 'sportId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      origin: // value for 'origin'
 *      clientMetadata: // value for 'clientMetadata'
 *   },
 * });
 */
export function useUseCartCreationHandlerCreateCartFromCourtBookableItemMutation(baseOptions?: Apollo.MutationHookOptions<UseCartCreationHandlerCreateCartFromCourtBookableItemMutation, UseCartCreationHandlerCreateCartFromCourtBookableItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseCartCreationHandlerCreateCartFromCourtBookableItemMutation, UseCartCreationHandlerCreateCartFromCourtBookableItemMutationVariables>(UseCartCreationHandlerCreateCartFromCourtBookableItemDocument, options);
      }
export type UseCartCreationHandlerCreateCartFromCourtBookableItemMutationHookResult = ReturnType<typeof useUseCartCreationHandlerCreateCartFromCourtBookableItemMutation>;
export type UseCartCreationHandlerCreateCartFromCourtBookableItemMutationResult = Apollo.MutationResult<UseCartCreationHandlerCreateCartFromCourtBookableItemMutation>;
export type UseCartCreationHandlerCreateCartFromCourtBookableItemMutationOptions = Apollo.BaseMutationOptions<UseCartCreationHandlerCreateCartFromCourtBookableItemMutation, UseCartCreationHandlerCreateCartFromCourtBookableItemMutationVariables>;
export const UseCartCreationHandlerCreateCartFromProductDocument = gql`
    mutation UseCartCreationHandlerCreateCartFromProduct($productId: ID!, $origin: Origin!, $venueId: ID!, $clientMetadata: ClientMetadataInput) {
  createCartFromProduct(
    productId: $productId
    origin: $origin
    venueId: $venueId
    clientMetadata: $clientMetadata
  ) {
    ... on Cart {
      id
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type UseCartCreationHandlerCreateCartFromProductMutationFn = Apollo.MutationFunction<UseCartCreationHandlerCreateCartFromProductMutation, UseCartCreationHandlerCreateCartFromProductMutationVariables>;

/**
 * __useUseCartCreationHandlerCreateCartFromProductMutation__
 *
 * To run a mutation, you first call `useUseCartCreationHandlerCreateCartFromProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseCartCreationHandlerCreateCartFromProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useCartCreationHandlerCreateCartFromProductMutation, { data, loading, error }] = useUseCartCreationHandlerCreateCartFromProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      origin: // value for 'origin'
 *      venueId: // value for 'venueId'
 *      clientMetadata: // value for 'clientMetadata'
 *   },
 * });
 */
export function useUseCartCreationHandlerCreateCartFromProductMutation(baseOptions?: Apollo.MutationHookOptions<UseCartCreationHandlerCreateCartFromProductMutation, UseCartCreationHandlerCreateCartFromProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseCartCreationHandlerCreateCartFromProductMutation, UseCartCreationHandlerCreateCartFromProductMutationVariables>(UseCartCreationHandlerCreateCartFromProductDocument, options);
      }
export type UseCartCreationHandlerCreateCartFromProductMutationHookResult = ReturnType<typeof useUseCartCreationHandlerCreateCartFromProductMutation>;
export type UseCartCreationHandlerCreateCartFromProductMutationResult = Apollo.MutationResult<UseCartCreationHandlerCreateCartFromProductMutation>;
export type UseCartCreationHandlerCreateCartFromProductMutationOptions = Apollo.BaseMutationOptions<UseCartCreationHandlerCreateCartFromProductMutation, UseCartCreationHandlerCreateCartFromProductMutationVariables>;
export const UseCartCreationHandlerCreateCartFromVoucherDocument = gql`
    mutation UseCartCreationHandlerCreateCartFromVoucher($amount: Int!, $venueId: ID!, $imageId: ID!, $message: String, $origin: Origin!, $clientMetadata: ClientMetadataInput) {
  createCartFromVoucher(
    amount: $amount
    venueId: $venueId
    imageId: $imageId
    message: $message
    origin: $origin
    clientMetadata: $clientMetadata
  ) {
    ... on Cart {
      id
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export type UseCartCreationHandlerCreateCartFromVoucherMutationFn = Apollo.MutationFunction<UseCartCreationHandlerCreateCartFromVoucherMutation, UseCartCreationHandlerCreateCartFromVoucherMutationVariables>;

/**
 * __useUseCartCreationHandlerCreateCartFromVoucherMutation__
 *
 * To run a mutation, you first call `useUseCartCreationHandlerCreateCartFromVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseCartCreationHandlerCreateCartFromVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useCartCreationHandlerCreateCartFromVoucherMutation, { data, loading, error }] = useUseCartCreationHandlerCreateCartFromVoucherMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      venueId: // value for 'venueId'
 *      imageId: // value for 'imageId'
 *      message: // value for 'message'
 *      origin: // value for 'origin'
 *      clientMetadata: // value for 'clientMetadata'
 *   },
 * });
 */
export function useUseCartCreationHandlerCreateCartFromVoucherMutation(baseOptions?: Apollo.MutationHookOptions<UseCartCreationHandlerCreateCartFromVoucherMutation, UseCartCreationHandlerCreateCartFromVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseCartCreationHandlerCreateCartFromVoucherMutation, UseCartCreationHandlerCreateCartFromVoucherMutationVariables>(UseCartCreationHandlerCreateCartFromVoucherDocument, options);
      }
export type UseCartCreationHandlerCreateCartFromVoucherMutationHookResult = ReturnType<typeof useUseCartCreationHandlerCreateCartFromVoucherMutation>;
export type UseCartCreationHandlerCreateCartFromVoucherMutationResult = Apollo.MutationResult<UseCartCreationHandlerCreateCartFromVoucherMutation>;
export type UseCartCreationHandlerCreateCartFromVoucherMutationOptions = Apollo.BaseMutationOptions<UseCartCreationHandlerCreateCartFromVoucherMutation, UseCartCreationHandlerCreateCartFromVoucherMutationVariables>;
export const UseCartCreationHandlerTrackCheckoutStartDocument = gql`
    mutation UseCartCreationHandlerTrackCheckoutStart($cartId: ID!, $deviceId: String!, $sessionId: Float!, $userTrackingId: String) {
  trackCheckoutStart(
    cartId: $cartId
    deviceId: $deviceId
    sessionId: $sessionId
    userTrackingId: $userTrackingId
  )
}
    `;
export type UseCartCreationHandlerTrackCheckoutStartMutationFn = Apollo.MutationFunction<UseCartCreationHandlerTrackCheckoutStartMutation, UseCartCreationHandlerTrackCheckoutStartMutationVariables>;

/**
 * __useUseCartCreationHandlerTrackCheckoutStartMutation__
 *
 * To run a mutation, you first call `useUseCartCreationHandlerTrackCheckoutStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseCartCreationHandlerTrackCheckoutStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useCartCreationHandlerTrackCheckoutStartMutation, { data, loading, error }] = useUseCartCreationHandlerTrackCheckoutStartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      deviceId: // value for 'deviceId'
 *      sessionId: // value for 'sessionId'
 *      userTrackingId: // value for 'userTrackingId'
 *   },
 * });
 */
export function useUseCartCreationHandlerTrackCheckoutStartMutation(baseOptions?: Apollo.MutationHookOptions<UseCartCreationHandlerTrackCheckoutStartMutation, UseCartCreationHandlerTrackCheckoutStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseCartCreationHandlerTrackCheckoutStartMutation, UseCartCreationHandlerTrackCheckoutStartMutationVariables>(UseCartCreationHandlerTrackCheckoutStartDocument, options);
      }
export type UseCartCreationHandlerTrackCheckoutStartMutationHookResult = ReturnType<typeof useUseCartCreationHandlerTrackCheckoutStartMutation>;
export type UseCartCreationHandlerTrackCheckoutStartMutationResult = Apollo.MutationResult<UseCartCreationHandlerTrackCheckoutStartMutation>;
export type UseCartCreationHandlerTrackCheckoutStartMutationOptions = Apollo.BaseMutationOptions<UseCartCreationHandlerTrackCheckoutStartMutation, UseCartCreationHandlerTrackCheckoutStartMutationVariables>;
export const UseConfirmationActionsOrderDocument = gql`
    query UseConfirmationActionsOrder($orderId: ID!) {
  order(id: $orderId) {
    ... on Order {
      id
      items {
        ... on AssignedProductOrderItem {
          assignedProduct {
            ... on AssignedProductInterface {
              id
            }
            ... on AssignedRecording {
              id
              product {
                id
              }
            }
            ... on AssignedVoucher {
              code
            }
            ... on GenericAssignedProduct {
              id
            }
          }
        }
        ... on BookingOrderItem {
          booking {
            ... on EventBooking {
              id
              participations(first: 1) {
                nodes {
                  id
                }
              }
              bookableItem {
                eventType
                floorPlan {
                  id
                }
              }
            }
          }
        }
        ... on BookingRequestOrderItem {
          endPrice
        }
      }
      venue {
        id
        name
        shortId
        slug
        company {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useUseConfirmationActionsOrderQuery__
 *
 * To run a query within a React component, call `useUseConfirmationActionsOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseConfirmationActionsOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseConfirmationActionsOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useUseConfirmationActionsOrderQuery(baseOptions: Apollo.QueryHookOptions<UseConfirmationActionsOrderQuery, UseConfirmationActionsOrderQueryVariables> & ({ variables: UseConfirmationActionsOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseConfirmationActionsOrderQuery, UseConfirmationActionsOrderQueryVariables>(UseConfirmationActionsOrderDocument, options);
      }
export function useUseConfirmationActionsOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseConfirmationActionsOrderQuery, UseConfirmationActionsOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseConfirmationActionsOrderQuery, UseConfirmationActionsOrderQueryVariables>(UseConfirmationActionsOrderDocument, options);
        }
export function useUseConfirmationActionsOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseConfirmationActionsOrderQuery, UseConfirmationActionsOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseConfirmationActionsOrderQuery, UseConfirmationActionsOrderQueryVariables>(UseConfirmationActionsOrderDocument, options);
        }
export type UseConfirmationActionsOrderQueryHookResult = ReturnType<typeof useUseConfirmationActionsOrderQuery>;
export type UseConfirmationActionsOrderLazyQueryHookResult = ReturnType<typeof useUseConfirmationActionsOrderLazyQuery>;
export type UseConfirmationActionsOrderSuspenseQueryHookResult = ReturnType<typeof useUseConfirmationActionsOrderSuspenseQuery>;
export type UseConfirmationActionsOrderQueryResult = Apollo.QueryResult<UseConfirmationActionsOrderQuery, UseConfirmationActionsOrderQueryVariables>;
export const UseCountriesCountriesDocument = gql`
    query UseCountriesCountries {
  countries {
    iso
    name
  }
}
    `;

/**
 * __useUseCountriesCountriesQuery__
 *
 * To run a query within a React component, call `useUseCountriesCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseCountriesCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseCountriesCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseCountriesCountriesQuery(baseOptions?: Apollo.QueryHookOptions<UseCountriesCountriesQuery, UseCountriesCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseCountriesCountriesQuery, UseCountriesCountriesQueryVariables>(UseCountriesCountriesDocument, options);
      }
export function useUseCountriesCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseCountriesCountriesQuery, UseCountriesCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseCountriesCountriesQuery, UseCountriesCountriesQueryVariables>(UseCountriesCountriesDocument, options);
        }
export function useUseCountriesCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseCountriesCountriesQuery, UseCountriesCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseCountriesCountriesQuery, UseCountriesCountriesQueryVariables>(UseCountriesCountriesDocument, options);
        }
export type UseCountriesCountriesQueryHookResult = ReturnType<typeof useUseCountriesCountriesQuery>;
export type UseCountriesCountriesLazyQueryHookResult = ReturnType<typeof useUseCountriesCountriesLazyQuery>;
export type UseCountriesCountriesSuspenseQueryHookResult = ReturnType<typeof useUseCountriesCountriesSuspenseQuery>;
export type UseCountriesCountriesQueryResult = Apollo.QueryResult<UseCountriesCountriesQuery, UseCountriesCountriesQueryVariables>;
export const UseEnabledFeaturePreviewsFeaturePreviewsDocument = gql`
    query UseEnabledFeaturePreviewsFeaturePreviews {
  featurePreviews(enabled: true) {
    id
    name
  }
}
    `;

/**
 * __useUseEnabledFeaturePreviewsFeaturePreviewsQuery__
 *
 * To run a query within a React component, call `useUseEnabledFeaturePreviewsFeaturePreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseEnabledFeaturePreviewsFeaturePreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseEnabledFeaturePreviewsFeaturePreviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseEnabledFeaturePreviewsFeaturePreviewsQuery(baseOptions?: Apollo.QueryHookOptions<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>(UseEnabledFeaturePreviewsFeaturePreviewsDocument, options);
      }
export function useUseEnabledFeaturePreviewsFeaturePreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>(UseEnabledFeaturePreviewsFeaturePreviewsDocument, options);
        }
export function useUseEnabledFeaturePreviewsFeaturePreviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>(UseEnabledFeaturePreviewsFeaturePreviewsDocument, options);
        }
export type UseEnabledFeaturePreviewsFeaturePreviewsQueryHookResult = ReturnType<typeof useUseEnabledFeaturePreviewsFeaturePreviewsQuery>;
export type UseEnabledFeaturePreviewsFeaturePreviewsLazyQueryHookResult = ReturnType<typeof useUseEnabledFeaturePreviewsFeaturePreviewsLazyQuery>;
export type UseEnabledFeaturePreviewsFeaturePreviewsSuspenseQueryHookResult = ReturnType<typeof useUseEnabledFeaturePreviewsFeaturePreviewsSuspenseQuery>;
export type UseEnabledFeaturePreviewsFeaturePreviewsQueryResult = Apollo.QueryResult<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>;
export const UseFamilyAccountMeDocument = gql`
    query UseFamilyAccountMe {
  me {
    ...userAttributes
  }
}
    ${UserAttributesFragmentDoc}`;

/**
 * __useUseFamilyAccountMeQuery__
 *
 * To run a query within a React component, call `useUseFamilyAccountMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseFamilyAccountMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseFamilyAccountMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseFamilyAccountMeQuery(baseOptions?: Apollo.QueryHookOptions<UseFamilyAccountMeQuery, UseFamilyAccountMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseFamilyAccountMeQuery, UseFamilyAccountMeQueryVariables>(UseFamilyAccountMeDocument, options);
      }
export function useUseFamilyAccountMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseFamilyAccountMeQuery, UseFamilyAccountMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseFamilyAccountMeQuery, UseFamilyAccountMeQueryVariables>(UseFamilyAccountMeDocument, options);
        }
export function useUseFamilyAccountMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseFamilyAccountMeQuery, UseFamilyAccountMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseFamilyAccountMeQuery, UseFamilyAccountMeQueryVariables>(UseFamilyAccountMeDocument, options);
        }
export type UseFamilyAccountMeQueryHookResult = ReturnType<typeof useUseFamilyAccountMeQuery>;
export type UseFamilyAccountMeLazyQueryHookResult = ReturnType<typeof useUseFamilyAccountMeLazyQuery>;
export type UseFamilyAccountMeSuspenseQueryHookResult = ReturnType<typeof useUseFamilyAccountMeSuspenseQuery>;
export type UseFamilyAccountMeQueryResult = Apollo.QueryResult<UseFamilyAccountMeQuery, UseFamilyAccountMeQueryVariables>;
export const MedicalCertificateCartDocument = gql`
    query MedicalCertificateCart($cartId: ID!) {
  cart(id: $cartId) {
    medicalCertificateRequired
    customer {
      medicalCertificate {
        status
        validityDate
      }
    }
  }
}
    `;

/**
 * __useMedicalCertificateCartQuery__
 *
 * To run a query within a React component, call `useMedicalCertificateCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalCertificateCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalCertificateCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useMedicalCertificateCartQuery(baseOptions: Apollo.QueryHookOptions<MedicalCertificateCartQuery, MedicalCertificateCartQueryVariables> & ({ variables: MedicalCertificateCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicalCertificateCartQuery, MedicalCertificateCartQueryVariables>(MedicalCertificateCartDocument, options);
      }
export function useMedicalCertificateCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicalCertificateCartQuery, MedicalCertificateCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicalCertificateCartQuery, MedicalCertificateCartQueryVariables>(MedicalCertificateCartDocument, options);
        }
export function useMedicalCertificateCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MedicalCertificateCartQuery, MedicalCertificateCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedicalCertificateCartQuery, MedicalCertificateCartQueryVariables>(MedicalCertificateCartDocument, options);
        }
export type MedicalCertificateCartQueryHookResult = ReturnType<typeof useMedicalCertificateCartQuery>;
export type MedicalCertificateCartLazyQueryHookResult = ReturnType<typeof useMedicalCertificateCartLazyQuery>;
export type MedicalCertificateCartSuspenseQueryHookResult = ReturnType<typeof useMedicalCertificateCartSuspenseQuery>;
export type MedicalCertificateCartQueryResult = Apollo.QueryResult<MedicalCertificateCartQuery, MedicalCertificateCartQueryVariables>;
export const UseSummaryCartDocument = gql`
    query UseSummaryCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    isVoucherEnabled
    items {
      ... on BookableItemCartItem {
        id
        settleWith {
          ... on Card {
            id
          }
          ... on Membership {
            id
          }
          ... on Ticket {
            id
          }
          ... on SinglePurchase {
            id
          }
          ... on AssignedCard {
            id
          }
          ... on AssignedMembership {
            id
          }
          ... on GenericAssignedProduct {
            id
          }
        }
        bookableItem {
          __typename
          ... on EventBookableItem {
            id
            floorPlan {
              id
            }
          }
        }
      }
      ... on ProductCartItem {
        id
        settleWith {
          ... on Card {
            id
          }
          ... on Membership {
            id
          }
          ... on Ticket {
            id
          }
          ... on SinglePurchase {
            id
          }
          ... on AssignedCard {
            id
          }
          ... on AssignedMembership {
            id
          }
          ... on GenericAssignedProduct {
            id
          }
        }
      }
    }
    priceTable {
      total {
        value
        currency
      }
      itemsV3 {
        ... on PriceTableItemBasic {
          ...priceTableItemBasicAttributes
        }
        ... on PriceTableItemAddon {
          ...priceTableItemAddonAttributes
        }
        ... on PriceTableItemVoucher {
          ...priceTableItemVoucherAttributes
        }
        ... on PriceTableItemMembership {
          ...priceTableItemMembershipAttributes
        }
        ... on PriceTableItemBudget {
          ...priceTableItemBudgetAttributes
        }
        ... on PriceTableItemSpecialPrice {
          ...priceTableItemSpecialPriceAttributes
        }
      }
    }
  }
}
    ${PriceTableItemBasicAttributesFragmentDoc}
${PriceTableItemAddonAttributesFragmentDoc}
${PriceTableItemVoucherAttributesFragmentDoc}
${PriceTableItemMembershipAttributesFragmentDoc}
${PriceTableItemBudgetAttributesFragmentDoc}
${PriceTableItemSpecialPriceAttributesFragmentDoc}`;

/**
 * __useUseSummaryCartQuery__
 *
 * To run a query within a React component, call `useUseSummaryCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseSummaryCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseSummaryCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useUseSummaryCartQuery(baseOptions: Apollo.QueryHookOptions<UseSummaryCartQuery, UseSummaryCartQueryVariables> & ({ variables: UseSummaryCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseSummaryCartQuery, UseSummaryCartQueryVariables>(UseSummaryCartDocument, options);
      }
export function useUseSummaryCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseSummaryCartQuery, UseSummaryCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseSummaryCartQuery, UseSummaryCartQueryVariables>(UseSummaryCartDocument, options);
        }
export function useUseSummaryCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseSummaryCartQuery, UseSummaryCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseSummaryCartQuery, UseSummaryCartQueryVariables>(UseSummaryCartDocument, options);
        }
export type UseSummaryCartQueryHookResult = ReturnType<typeof useUseSummaryCartQuery>;
export type UseSummaryCartLazyQueryHookResult = ReturnType<typeof useUseSummaryCartLazyQuery>;
export type UseSummaryCartSuspenseQueryHookResult = ReturnType<typeof useUseSummaryCartSuspenseQuery>;
export type UseSummaryCartQueryResult = Apollo.QueryResult<UseSummaryCartQuery, UseSummaryCartQueryVariables>;
export const UseSummaryOrderDocument = gql`
    query UseSummaryOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    isVoucherEnabled
    priceTable {
      total {
        value
        currency
      }
      itemsV3 {
        ... on PriceTableItemBasic {
          ...priceTableItemBasicAttributes
        }
        ... on PriceTableItemAddon {
          ...priceTableItemAddonAttributes
        }
        ... on PriceTableItemVoucher {
          ...priceTableItemVoucherAttributes
        }
        ... on PriceTableItemMembership {
          ...priceTableItemMembershipAttributes
        }
        ... on PriceTableItemBudget {
          ...priceTableItemBudgetAttributes
        }
        ... on PriceTableItemSpecialPrice {
          ...priceTableItemSpecialPriceAttributes
        }
      }
    }
    items {
      __typename
      ... on BookingOrderItem {
        booking {
          ... on EventBooking {
            bookableItem {
              id
              floorPlan {
                id
              }
            }
          }
        }
      }
    }
  }
}
    ${PriceTableItemBasicAttributesFragmentDoc}
${PriceTableItemAddonAttributesFragmentDoc}
${PriceTableItemVoucherAttributesFragmentDoc}
${PriceTableItemMembershipAttributesFragmentDoc}
${PriceTableItemBudgetAttributesFragmentDoc}
${PriceTableItemSpecialPriceAttributesFragmentDoc}`;

/**
 * __useUseSummaryOrderQuery__
 *
 * To run a query within a React component, call `useUseSummaryOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseSummaryOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseSummaryOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useUseSummaryOrderQuery(baseOptions: Apollo.QueryHookOptions<UseSummaryOrderQuery, UseSummaryOrderQueryVariables> & ({ variables: UseSummaryOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseSummaryOrderQuery, UseSummaryOrderQueryVariables>(UseSummaryOrderDocument, options);
      }
export function useUseSummaryOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseSummaryOrderQuery, UseSummaryOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseSummaryOrderQuery, UseSummaryOrderQueryVariables>(UseSummaryOrderDocument, options);
        }
export function useUseSummaryOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseSummaryOrderQuery, UseSummaryOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseSummaryOrderQuery, UseSummaryOrderQueryVariables>(UseSummaryOrderDocument, options);
        }
export type UseSummaryOrderQueryHookResult = ReturnType<typeof useUseSummaryOrderQuery>;
export type UseSummaryOrderLazyQueryHookResult = ReturnType<typeof useUseSummaryOrderLazyQuery>;
export type UseSummaryOrderSuspenseQueryHookResult = ReturnType<typeof useUseSummaryOrderSuspenseQuery>;
export type UseSummaryOrderQueryResult = Apollo.QueryResult<UseSummaryOrderQuery, UseSummaryOrderQueryVariables>;
export const UseVenueEnabledFeaturePreviewsVenueDocument = gql`
    query useVenueEnabledFeaturePreviewsVenue($venueId: ID!) {
  venue(venueId: $venueId) {
    id
    enabledFeatures {
      id
      name
    }
  }
}
    `;

/**
 * __useUseVenueEnabledFeaturePreviewsVenueQuery__
 *
 * To run a query within a React component, call `useUseVenueEnabledFeaturePreviewsVenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseVenueEnabledFeaturePreviewsVenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseVenueEnabledFeaturePreviewsVenueQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useUseVenueEnabledFeaturePreviewsVenueQuery(baseOptions: Apollo.QueryHookOptions<UseVenueEnabledFeaturePreviewsVenueQuery, UseVenueEnabledFeaturePreviewsVenueQueryVariables> & ({ variables: UseVenueEnabledFeaturePreviewsVenueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseVenueEnabledFeaturePreviewsVenueQuery, UseVenueEnabledFeaturePreviewsVenueQueryVariables>(UseVenueEnabledFeaturePreviewsVenueDocument, options);
      }
export function useUseVenueEnabledFeaturePreviewsVenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseVenueEnabledFeaturePreviewsVenueQuery, UseVenueEnabledFeaturePreviewsVenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseVenueEnabledFeaturePreviewsVenueQuery, UseVenueEnabledFeaturePreviewsVenueQueryVariables>(UseVenueEnabledFeaturePreviewsVenueDocument, options);
        }
export function useUseVenueEnabledFeaturePreviewsVenueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseVenueEnabledFeaturePreviewsVenueQuery, UseVenueEnabledFeaturePreviewsVenueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseVenueEnabledFeaturePreviewsVenueQuery, UseVenueEnabledFeaturePreviewsVenueQueryVariables>(UseVenueEnabledFeaturePreviewsVenueDocument, options);
        }
export type UseVenueEnabledFeaturePreviewsVenueQueryHookResult = ReturnType<typeof useUseVenueEnabledFeaturePreviewsVenueQuery>;
export type UseVenueEnabledFeaturePreviewsVenueLazyQueryHookResult = ReturnType<typeof useUseVenueEnabledFeaturePreviewsVenueLazyQuery>;
export type UseVenueEnabledFeaturePreviewsVenueSuspenseQueryHookResult = ReturnType<typeof useUseVenueEnabledFeaturePreviewsVenueSuspenseQuery>;
export type UseVenueEnabledFeaturePreviewsVenueQueryResult = Apollo.QueryResult<UseVenueEnabledFeaturePreviewsVenueQuery, UseVenueEnabledFeaturePreviewsVenueQueryVariables>;